(function () {
  const SELECTOR = '[data-smallsmore-patch-customizer]';
  const BASE_WIDTH = 1236;
  const BASE_HEIGHT = 2000;
  const PREVIEW_WIDTH = 1200;
  const PREVIEW_HEIGHT = 1200;
  const DEFAULT_PATCH_PLACEMENT = {
    x: 279,
    y: 82,
    width: 641,
    height: 1035
  };
  const HARDWARE_PREVIEW_BASE_SIZE = 1500;
  const HARDWARE_VECTOR_LAYERS = [
    {
      id: 'outer-frame',
      role: 'case',
      x: 300.8334,
      y: 81.3474,
      fill: '#2c2c2c',
      path: 'M882.152 854.673C882.387 874.163 881.479 885.288 887.155 904.793C890.246 915.398 895.16 919.595 895.204 930.171C895.307 954.971 895.241 979.844 895.241 1004.64L895.255 1151.3L895.226 1207.25C895.226 1215.83 895.16 1224.43 895.329 1233.01C895.373 1235.17 897.687 1237.31 897.716 1238.25C898.464 1260.1 897.628 1282.12 898.068 1304.02C898.09 1305.11 897.357 1306.29 896.852 1307.21C893.498 1312.66 895.783 1320 894.721 1326.29C893.117 1335.87 883.61 1343.73 874.052 1344.35C867.16 1344.8 859.814 1344.61 852.826 1344.61L815.436 1344.62L694.814 1344.6H194.724L73.6451 1344.65C59.2296 1344.65 44.7928 1344.75 30.3927 1344.55C21.4469 1344.39 16.637 1343.92 9.83943 1337.75C-1.59587 1327.36 6.33552 1316.02 0.187572 1304.52C-0.257741 1303.69 0.326005 1291.06 0.248368 1289.07C-0.369063 1273.14 0.405838 1257.24 0.0366973 1241.3C-0.0548555 1237.42 2.61409 1235.32 2.62507 1232.75C2.67122 1221.21 2.62435 1209.66 2.62362 1198.11L2.62069 1117.81L2.60458 917.486L2.58261 850.953C2.58041 839.307 2.52254 827.522 2.7137 815.884C2.83675 808.377 8.2413 800.972 11.0186 793.553C14.5936 783.753 16.7923 773.506 17.5496 763.106C18.4366 751.702 18.0242 736.929 18.0316 725.218L18.0565 660.574L18.0558 575.629C18.0506 559.128 18.419 541.103 17.6873 524.807C15.4923 523.47 12.9515 522.193 13.0042 519.131C13.4496 493.164 12.8592 467.163 13.3258 441.198C13.3675 438.89 15.7896 440.673 17.9356 438.319C18.0667 434.667 18.8717 423.458 17.346 420.542L14.1622 420.304L13.4158 419.28C12.9046 410.275 12.252 340.349 14.2171 337.244C14.9488 336.879 17.2787 335.825 17.3768 335.117C19.7125 318.356 16.1522 297.434 10.221 281.707C7.02986 273.244 2.93343 269.745 2.77376 262.705C2.40974 246.611 2.59944 231.061 2.6097 215.255L2.60091 125.072L2.60017 56.8049C2.60091 45.4238 2.31307 33.9248 2.83748 22.4221C3.441 9.18726 14.1505 0.0847316 27.1627 0.0686183C86.9847 -0.00682116 147.118 0.0305317 206.903 0.0290669L563.615 0.0210091L772.487 0.0217411L839.899 0.0232051C851.266 0.0232051 862.736 -0.0917874 874.103 0.190195C883.786 0.430429 894.457 10.3804 894.992 20.145C895.431 28.0728 895.263 36.2861 895.263 44.2263L895.241 89.0366L895.263 230.476L895.27 426.285L895.255 490.958C895.255 502.663 895.336 514.483 895.087 526.18C894.911 534.31 889.623 541.12 887.199 549.257C881.669 567.835 882.123 580.911 882.152 599.899C885.478 599.875 887.909 599.522 890.89 600.898C892.611 603.747 892.318 692.881 891.601 701.919C889.433 705.406 885.968 704.534 882.145 704.483C882.16 719.563 882.314 734.856 882.145 749.915C885.126 749.878 887.924 749.512 890.568 750.779C893.944 755.599 891.234 839.886 891.615 851.721C891.725 854.937 884.335 854.637 882.152 854.673ZM657.204 547.079C691.979 541.111 686.061 513.105 686.068 485.874L686.054 429.827L686.039 261.652L686.068 160.574C686.068 143.163 686.984 124.331 684.765 107.188C683.073 94.105 669.098 84.7696 656.383 84.5872C634.499 84.2737 612.614 84.3667 590.722 84.3806L465.536 84.4268L317.333 84.4165C295.236 84.4151 264.324 83.5054 242.846 84.4846C207.288 87.2283 212.025 116.697 212.041 142.821L212.035 187.002L212.016 332.599L212.024 457.099C212.028 477.95 211.604 499.369 212.53 520.177C213.15 534.113 226.669 546.327 240.62 546.774C256.088 547.27 271.78 547.119 287.376 547.117L376.446 547.104L657.204 547.079Z'
    },
    {
      id: 'button-two',
      role: 'buttonTwo',
      x: 1182.9785,
      y: 831.1854,
      fill: '#d10000',
      path: 'M0 0.0768297C2.98096 0.0402086 5.77881 -0.325963 8.42285 0.941127C11.7993 5.76046 9.08931 90.0475 9.47017 101.883C9.58003 105.099 2.18995 104.799 0.00733137 104.835L0 0.0768297Z'
    },
    {
      id: 'button-one',
      role: 'buttonOne',
      x: 1182.9785,
      y: 681.1883,
      fill: '#d10000',
      path: 'M0.00733137 0.0578221C3.33253 0.0336522 5.76412 -0.318633 8.74507 1.05686C10.4663 3.90598 10.1733 93.0403 9.4555 102.078C7.28753 105.565 3.82324 104.693 0 104.642L0.00733137 0.0578221Z'
    },
    {
      id: 'case-body',
      role: 'case',
      x: 352.0257,
      y: 105.4062,
      fill: '#7d7c7c',
      path: 'M25.7854 0.277147C38.695 -0.247267 54.2839 0.133593 67.3803 0.133593L144.083 0.144579L144.124 353.795L144.101 451.311C144.099 456.723 144.063 462.229 144.095 467.586C144.222 488.792 141.192 509.445 157.888 525.75C169.796 537.378 180.902 539.693 197.018 539.745L483.338 539.706L567.698 539.748C577.674 539.761 602.642 540.344 611.57 539.025C621.502 537.579 630.694 532.962 637.784 525.862C652.908 510.601 651.758 494.367 651.575 474.415C651.495 466.075 651.568 457.524 651.568 449.17L651.51 348.691L651.517 0.143841L732.237 0.0977073C740.264 0.0940451 748.277 0.107231 756.326 0.0837933C768.001 0.0339886 778.599 -0.521924 787.469 8.49346C798.433 19.6314 795.606 37.0953 795.599 51.9187L795.547 101.857L795.54 260.67L795.555 772.401V1101.91L795.518 1208.45C795.511 1225.68 795.797 1243.18 795.504 1260.39C795.379 1265.45 793.782 1270.24 791.212 1274.48C781.448 1290.51 761.922 1287.56 744.6 1287.57L705.255 1287.56L551.776 1287.51L205.284 1287.54L90.434 1287.55C69.8969 1287.55 49.3049 1287.63 28.7707 1287.42C22.1921 1287.35 17.5654 1285.95 12.0319 1282.44C7.29316 1279.44 1.48286 1271.05 0.881538 1265.52C-0.108696 1256.42 0.245053 1245.21 0.248715 1235.92L0.305846 1179.5L0.2978 983.859L0.31244 268.652L0.31025 101.354L0.294872 53.8794C0.185741 31.1707 -4.28642 4.90752 25.7854 0.277147Z'
    },
    {
      id: 'camera-frame',
      role: 'caseShadeMid',
      x: 504.2756,
      y: 156.538,
      fill: '#525252',
      path: 'M40.0874 0.514528C61.5635 -0.575316 93.8238 0.404668 115.979 0.406133L267.631 0.410525L390.422 0.40173C411.545 0.398068 432.653 0.0955767 453.835 0.69836C466.681 1.26086 478.891 8.17346 485.402 19.1678C492.719 31.5136 491.122 42.8426 491.196 56.558C491.262 67.0917 491.152 77.7858 491.137 88.3839V201.441L491.181 363.851V414.414C491.181 424.291 491.606 434.509 490.837 444.323C489.079 466.628 473.515 478.083 452.751 480.463C422.319 480.935 390.671 480.495 360.158 480.495L177.819 480.496L83.6951 480.558C71.1165 480.567 46.488 481.311 34.9707 480.042C26.7932 479.117 19.0882 475.736 12.8706 470.344C-2.51314 457.059 0.166028 437.885 0.197523 419.732L0.26127 374.453L0.232704 228.581L0.205569 99.6464L0.204854 60.1322C0.206319 39.2172 -2.43845 18.9166 18.7307 6.35706C26.2696 1.88416 31.4756 1.10047 40.0874 0.514528ZM453.762 471.888C488.537 465.92 482.619 437.915 482.626 410.683L482.612 354.636L482.597 186.462L482.626 85.3832C482.626 67.9721 483.542 49.14 481.323 31.9969C479.631 18.9144 465.656 9.57898 452.941 9.39661C431.056 9.08313 409.172 9.17615 387.28 9.19007L262.094 9.23621L113.891 9.22595C91.7942 9.22449 60.8816 8.31482 39.4041 9.29407C3.84574 12.0377 8.58231 41.5067 8.59842 67.6307L8.59257 111.812L8.57352 257.409L8.58157 381.909C8.58597 402.76 8.16188 424.179 9.08766 444.986C9.70802 458.923 23.2271 471.137 37.1783 471.583C52.6455 472.079 68.3377 471.928 83.9339 471.927L173.004 471.913L453.762 471.888Z'
    },
    {
      id: 'camera-inner',
      role: 'caseShadeDark',
      x: 512.6563,
      y: 165.3781,
      fill: '#7d7c7c',
      path: 'M31.0235 0.453961C52.501 -0.525287 83.4136 0.384379 105.51 0.385844L253.713 0.396103L378.899 0.349958C400.791 0.336042 422.676 0.243023 444.561 0.556499C457.275 0.738873 471.25 10.0743 472.942 23.1568C475.161 40.2999 474.246 59.1319 474.246 76.5431L474.216 177.622L474.231 345.796L474.246 401.843C474.238 429.075 480.156 457.08 445.381 463.048L164.623 463.073L75.5532 463.087C59.957 463.088 44.2649 463.239 28.7976 462.743C14.8465 462.296 1.32741 450.083 0.707045 436.146C-0.218737 415.339 0.205351 393.92 0.200956 373.068L0.19291 248.568L0.211954 102.972L0.21781 58.7906C0.201696 32.6666 -4.53488 3.19761 31.0235 0.453961ZM447.761 454.159C461.465 449.519 465.361 442.884 465.449 428.627C465.574 407.462 465.427 386.286 465.398 365.12V247.857L465.413 102.64C465.413 93.057 466.401 29.1693 464.321 23.5209C462.249 17.7274 457.861 13.0545 452.214 10.6163C445.33 7.70421 395.818 9.03867 384.583 9.02915L256.746 8.99254L104.359 8.99766C79.118 8.99912 51.7451 8.46226 26.6407 9.06798C19.1201 11.827 14.3103 14.3048 10.6702 21.9337C9.23978 24.9315 9.36063 28.037 9.20902 31.2999C8.99076 56.7025 9.08522 82.1959 9.08229 107.6L9.07057 252.515L9.07129 372.951C9.07129 391.711 8.43778 414.804 9.14603 433.32C9.21561 435.712 9.6697 438.076 10.4915 440.323C13.0117 447.359 20.678 453.918 28.3047 454.06C48.0728 454.427 67.8819 454.273 87.6565 454.269L197.759 454.236L362.632 454.23C390.61 454.229 419.878 454.649 447.761 454.159Z'
    }
  ];
  const IMAGE_CUSTOMIZER_PRINT_AREA = {
    x: 279,
    y: 82,
    width: 641,
    height: 1035
  };
  const THEME_FINISHED_SIZE_MM = {
    width: 85,
    height: 138
  };
  const THEME_BLEED_MM = 1;
  const TECH_THEME_CLIP_PATH_VERSION = 'theme-tech-bleed-1mm-v1';
  const TERRAIN_THEME_CLIP_PATH_VERSION = 'theme-terrain-bleed-1mm-v1';
  const PURE_COLOR_CLIP_PATH_VERSION = 'pure-color-bleed-1mm-v1';
  const THEME_PREVIEW_CLIP_PATH_VERSION = 'theme-preview-v1';
  const STANDARD_PREVIEW_PHOTO_FALLBACK_LABELS = ['Back', 'Front', 'Left', 'Right'];
  const CASE_COLOR_CARE_NOTICE_COLOR_IDS = new Set(['pantone-7527-c', 'pantone-2051-c']);
  const IMAGE_CUSTOMIZER_BLEED_X = (IMAGE_CUSTOMIZER_PRINT_AREA.width * THEME_BLEED_MM) / THEME_FINISHED_SIZE_MM.width;
  const IMAGE_CUSTOMIZER_BLEED_Y = (IMAGE_CUSTOMIZER_PRINT_AREA.height * THEME_BLEED_MM) / THEME_FINISHED_SIZE_MM.height;
  const IMAGE_CUSTOMIZER_PRINT_CLIP_PATH = [
    ['M', 301.67, 82.0],
    ['L', 395.15, 82.0],
    ['L', 395.15, 477.98],
    ['C', 395.15, 498.79, 412.07, 515.66, 432.92, 515.66],
    ['L', 766.08, 515.66],
    ['C', 786.94, 515.66, 803.86, 498.79, 803.86, 477.98],
    ['L', 803.85, 82.0],
    ['L', 897.33, 82.0],
    ['C', 909.85, 82.0, 920.0, 92.13, 920.0, 104.61],
    ['L', 920.0, 1094.39],
    ['C', 920.0, 1106.88, 909.86, 1117.0, 897.33, 1117.0],
    ['L', 301.67, 1117.0],
    ['C', 289.14, 1117.0, 279.0, 1106.88, 279.0, 1094.39],
    ['L', 279.0, 104.61],
    ['C', 279.0, 92.13, 289.15, 82.0, 301.67, 82.0],
    ['Z']
  ];
  const IMAGE_CUSTOMIZER_BLEED_CLIP_PATH = [
    ['M', 301.67, 82.0 - IMAGE_CUSTOMIZER_BLEED_Y],
    ['L', 395.15 + IMAGE_CUSTOMIZER_BLEED_X, 82.0 - IMAGE_CUSTOMIZER_BLEED_Y],
    ['L', 395.15 + IMAGE_CUSTOMIZER_BLEED_X, 477.98],
    ['C', 395.15 + IMAGE_CUSTOMIZER_BLEED_X, 498.79, 412.07, 515.66 - IMAGE_CUSTOMIZER_BLEED_Y, 432.92, 515.66 - IMAGE_CUSTOMIZER_BLEED_Y],
    ['L', 766.08, 515.66 - IMAGE_CUSTOMIZER_BLEED_Y],
    ['C', 786.94, 515.66 - IMAGE_CUSTOMIZER_BLEED_Y, 803.86 - IMAGE_CUSTOMIZER_BLEED_X, 498.79, 803.86 - IMAGE_CUSTOMIZER_BLEED_X, 477.98],
    ['L', 803.85 - IMAGE_CUSTOMIZER_BLEED_X, 82.0 - IMAGE_CUSTOMIZER_BLEED_Y],
    ['L', 897.33, 82.0 - IMAGE_CUSTOMIZER_BLEED_Y],
    ['C', 909.85 + IMAGE_CUSTOMIZER_BLEED_X, 82.0 - IMAGE_CUSTOMIZER_BLEED_Y, 920.0 + IMAGE_CUSTOMIZER_BLEED_X, 92.13 - IMAGE_CUSTOMIZER_BLEED_Y, 920.0 + IMAGE_CUSTOMIZER_BLEED_X, 104.61],
    ['L', 920.0 + IMAGE_CUSTOMIZER_BLEED_X, 1094.39],
    ['C', 920.0 + IMAGE_CUSTOMIZER_BLEED_X, 1106.88 + IMAGE_CUSTOMIZER_BLEED_Y, 909.86 + IMAGE_CUSTOMIZER_BLEED_X, 1117.0 + IMAGE_CUSTOMIZER_BLEED_Y, 897.33, 1117.0 + IMAGE_CUSTOMIZER_BLEED_Y],
    ['L', 301.67, 1117.0 + IMAGE_CUSTOMIZER_BLEED_Y],
    ['C', 289.14 - IMAGE_CUSTOMIZER_BLEED_X, 1117.0 + IMAGE_CUSTOMIZER_BLEED_Y, 279.0 - IMAGE_CUSTOMIZER_BLEED_X, 1106.88 + IMAGE_CUSTOMIZER_BLEED_Y, 279.0 - IMAGE_CUSTOMIZER_BLEED_X, 1094.39],
    ['L', 279.0 - IMAGE_CUSTOMIZER_BLEED_X, 104.61],
    ['C', 279.0 - IMAGE_CUSTOMIZER_BLEED_X, 92.13 - IMAGE_CUSTOMIZER_BLEED_Y, 289.15 - IMAGE_CUSTOMIZER_BLEED_X, 82.0 - IMAGE_CUSTOMIZER_BLEED_Y, 301.67, 82.0 - IMAGE_CUSTOMIZER_BLEED_Y],
    ['Z']
  ];
  const IMAGE_CUSTOMIZER_TEXT_AREA = {
    x: 395,
    y: 1018,
    width: 409,
    height: 78,
    fontSize: 42,
    minFontSize: 28,
    guideMaxFontSize: 24,
    guideMinFontSize: 14,
    guideDash: [12, 10],
    guideStrokeWidth: 3
  };
  const TEXT_AREA_SCALE_X = BASE_WIDTH / IMAGE_CUSTOMIZER_PRINT_AREA.width;
  const TEXT_AREA_SCALE_Y = BASE_HEIGHT / IMAGE_CUSTOMIZER_PRINT_AREA.height;
  const TEXT_AREA_SCALE = (TEXT_AREA_SCALE_X + TEXT_AREA_SCALE_Y) / 2;
  const DEFAULT_MAIN_TEXT = 'Portable';
  const DEFAULT_MAIN_TEXT_SECONDARY = 'Input Terminal';
  const DEFAULT_SIDE_TEXT = 'Keep typing';
  const DEFAULT_REGION_TEXT = '';
  const MAIN_TEXT_AREA = {
    x: 98,
    width: BASE_WIDTH - (98 * 2),
    topY: 1573,
    bottomY: 1733,
    topFontSize: 150,
    bottomFontSize: 91
  };
  const MONO_FONT_FAMILY = 'IBM Plex Mono';
  const SCALE_BAR_FONT_FAMILY = 'IBM Plex Mono';
  const WINDOW_COPY_FONT_FAMILY = 'Arial, Helvetica, sans-serif';
  const DEFAULT_CUSTOM_TEXT_FONT = 'Outfit';
  const CUSTOM_TEXT_FONTS = {
    Outfit: { fontStyle: '800' },
    'Space Grotesk': { fontStyle: '700' },
    'IBM Plex Mono': { fontStyle: '400' },
    'Libre Baskerville': { fontStyle: '700' },
    Caprasimo: { fontStyle: '400' },
    'Bowlby One SC': { fontStyle: '400' }
  };
  const CUSTOM_TEXT_FONT_LOADS = Array.from(new Set([
    '800 150px Outfit',
    '700 150px "Space Grotesk"',
    '400 150px "IBM Plex Mono"',
    '700 150px "Libre Baskerville"',
    '400 150px Caprasimo',
    '400 150px "Bowlby One SC"',
    '800 91px Outfit',
    `400 30px "${MONO_FONT_FAMILY}"`,
    `400 30px "${SCALE_BAR_FONT_FAMILY}"`,
    'italic 42px Arial'
  ]));
  const WINDOW_COPY_INK = '#202020';
  const WINDOW_SHOP_URL_INK = 'rgba(32, 32, 32, 0.46)';
  const WINDOW_SHOP_URL_TEXT = 'smallsmore.com';
  const WINDOW_SHOP_ICON_PATH = 'M1 1h4l2.68 13.39A2 2 0 0 0 9.64 16h9.72a2 2 0 0 0 2-1.61L23 6H6';
  const STANDARD_BOTTOM_BRAND_FILL = '#151515';
  const PURE_COLOR_STANDARD_BRAND_FALLBACK_FILL = '#f1f1ec';
  const PURE_COLOR_STANDARD_BRAND_FILLS = {
    blue: '#829FAA',
    green: '#B3B3A7'
  };
  const WINDOW_COPY_AREA = {
    x: 298,
    width: 640
  };
  const BOTTOM_TEXT_AREA = {
    x: Math.round((IMAGE_CUSTOMIZER_TEXT_AREA.x - IMAGE_CUSTOMIZER_PRINT_AREA.x) * TEXT_AREA_SCALE_X),
    y: Math.round((IMAGE_CUSTOMIZER_TEXT_AREA.y - IMAGE_CUSTOMIZER_PRINT_AREA.y) * TEXT_AREA_SCALE_Y),
    width: Math.round(IMAGE_CUSTOMIZER_TEXT_AREA.width * TEXT_AREA_SCALE_X),
    height: Math.round(IMAGE_CUSTOMIZER_TEXT_AREA.height * TEXT_AREA_SCALE_Y),
    fontSize: Math.round(IMAGE_CUSTOMIZER_TEXT_AREA.fontSize * TEXT_AREA_SCALE),
    minFontSize: Math.round(IMAGE_CUSTOMIZER_TEXT_AREA.minFontSize * TEXT_AREA_SCALE),
    guideFontSize: Math.round(Math.min(
      IMAGE_CUSTOMIZER_TEXT_AREA.guideMaxFontSize,
      Math.max(IMAGE_CUSTOMIZER_TEXT_AREA.guideMinFontSize, IMAGE_CUSTOMIZER_TEXT_AREA.height * 0.36)
    ) * TEXT_AREA_SCALE),
    guideDash: IMAGE_CUSTOMIZER_TEXT_AREA.guideDash.map((value) => Math.round(value * TEXT_AREA_SCALE)),
    guideStrokeWidth: Math.round(IMAGE_CUSTOMIZER_TEXT_AREA.guideStrokeWidth * TEXT_AREA_SCALE),
    lineHeight: 1.08
  };
  const DEFAULT_PRINT_PIXEL_RATIO = 3;
  const DESIGN_UPLOAD_TIMEOUT_MS = 8000;
  const SHARE_PREVIEW_SIZE = 1200;
  const SHARE_DOWNLOAD_SIZE = 800;
  const SHARE_COPY = 'Designed by smallsmore, shaped by you';
  const PATCH_HISTORY_LIMIT = 40;
  const EDIT_DRAFT_DB_NAME = 'smallsmore-customizer-drafts';
  const EDIT_DRAFT_DB_VERSION = 1;
  const EDIT_DRAFT_STORE_NAME = 'drafts';
  const EDIT_DRAFT_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  const EDIT_DRAFT_MAX_COUNT = 40;
  const DEFAULT_TERRAIN_GEOCODING_URL = 'https://geocoding-api.open-meteo.com';
  const DEFAULT_TERRAIN_ELEVATION_URL = 'https://api.open-meteo.com';
  const DEFAULT_TERRAIN_ZENITH_ELEVATION_URL = 'https://openzenith.cyopsys.com';
  const DEFAULT_TERRAIN_BACKUP_ELEVATION_URL = 'https://api.open-elevation.com';
  const TERRAIN_FEATURE_CODES = new Set(['HLL', 'HLLS', 'MT', 'MTS', 'PK', 'PKS', 'RDGE', 'VAL']);
  const TERRAIN_SUGGESTION_LIMIT = 6;
  const TERRAIN_SUGGESTION_DELAY_MS = 450;
  const TERRAIN_ELEVATION_BATCH_SIZE = 100;
  const TERRAIN_BACKUP_ELEVATION_BATCH_SIZE = 90;
  const TERRAIN_PEAK_LABEL_FONT_SIZE = 32;
  const TERRAIN_MAP_MAX_OFFSET_X = 320;
  const TERRAIN_MAP_MAX_OFFSET_Y = 520;
  const TERRAIN_DEFAULT_MAP_OFFSET = {
    x: 92,
    y: -195
  };
  const TERRAIN_DEFAULT_MARKER_POSITION = {
    x: 830,
    y: 1400
  };
  const TERRAIN_STALE_DEFAULT_MAP_OFFSETS = [
    { x: 0, y: 0 },
    { x: 92, y: -195 }
  ];
  const TERRAIN_DEFAULT_COLUMNS = 19;
  const TERRAIN_DEFAULT_ROWS = 25;
  const TERRAIN_DEFAULT_RADIUS_KM = 43;
  const TERRAIN_SCALE_OPTIONS = [
    { value: '1000', label: 'Close', radiusKm: 43, scaleBarKm: 10, scaleRatioLabel: '1:500000' },
    { value: '1500', label: 'Mid', radiusKm: 80, scaleBarKm: 20, scaleRatioLabel: '1:750000' },
    { value: '2000', label: 'Wide', radiusKm: 120, scaleBarKm: 40, scaleRatioLabel: '1:1000000' }
  ];
  const TERRAIN_DEFAULT_SCALE = '1000';
  const TERRAIN_CONTOUR_SAMPLE_SPACING = 16.7;
  const TERRAIN_CONTOUR_MAX_COLUMNS = 220;
  const TERRAIN_CONTOUR_MAX_ROWS = 260;
  const TERRAIN_ANNOTATION_HIT_RADIUS = 86;
  function mapImageCustomizerClipPoint(x, y, offset = null) {
    return {
      x: ((x - IMAGE_CUSTOMIZER_PRINT_AREA.x) * BASE_WIDTH) / IMAGE_CUSTOMIZER_PRINT_AREA.width + (offset && Number(offset.x) || 0),
      y: ((y - IMAGE_CUSTOMIZER_PRINT_AREA.y) * BASE_HEIGHT) / IMAGE_CUSTOMIZER_PRINT_AREA.height + (offset && Number(offset.y) || 0)
    };
  }

  function drawImageCustomizerClipPath(context, clipPath, offset = null) {
    context.beginPath();
    clipPath.forEach((command) => {
      const type = command[0];

      if (type === 'M') {
        const point = mapImageCustomizerClipPoint(command[1], command[2], offset);
        context.moveTo(point.x, point.y);
      }
      if (type === 'L') {
        const point = mapImageCustomizerClipPoint(command[1], command[2], offset);
        context.lineTo(point.x, point.y);
      }
      if (type === 'C') {
        const point1 = mapImageCustomizerClipPoint(command[1], command[2], offset);
        const point2 = mapImageCustomizerClipPoint(command[3], command[4], offset);
        const point3 = mapImageCustomizerClipPoint(command[5], command[6], offset);
        context.bezierCurveTo(point1.x, point1.y, point2.x, point2.y, point3.x, point3.y);
      }
      if (type === 'Q') {
        const point1 = mapImageCustomizerClipPoint(command[1], command[2], offset);
        const point2 = mapImageCustomizerClipPoint(command[3], command[4], offset);
        context.quadraticCurveTo(point1.x, point1.y, point2.x, point2.y);
      }
      if (type === 'Z') context.closePath();
    });
  }

  function drawImageCustomizerPrintClipPath(context) {
    drawImageCustomizerClipPath(context, IMAGE_CUSTOMIZER_PRINT_CLIP_PATH);
  }

  function drawImageCustomizerBleedClipPath(context, offset) {
    drawImageCustomizerClipPath(context, IMAGE_CUSTOMIZER_BLEED_CLIP_PATH, offset);
  }

  function formatCanvasFontFamily(fontFamily) {
    const family = String(fontFamily || '').trim();
    const safeFamily = family || 'sans-serif';
    return /[\s,]/.test(safeFamily) ? `"${safeFamily.replace(/"/g, '\\"')}"` : safeFamily;
  }

  const CURATED_TERRAIN_LOCATIONS = [
    {
      id: 'curated:mount-everest',
      name: 'Mount Everest',
      display_name: 'Mount Everest, Himalayas, Nepal / China',
      latitude: 27.9881,
      longitude: 86.925,
      elevation: 8849,
      country: 'Nepal / China',
      admin1: 'Himalayas',
      feature_code: 'PK',
      featured: true,
      featuredOrder: 1,
      aliases: ['mount everest', 'mt everest', 'everest', 'sagarmatha', 'chomolungma', '珠峰', '珠穆朗玛峰']
    },
    {
      id: 'curated:k2',
      name: 'K2',
      display_name: 'K2, Karakoram, Pakistan / China',
      latitude: 35.8808,
      longitude: 76.5158,
      elevation: 8611,
      country: 'Pakistan / China',
      admin1: 'Karakoram',
      feature_code: 'PK',
      featured: true,
      featuredOrder: 3,
      aliases: ['k2', 'mount godwin austen', 'chhogori', '乔戈里峰', '乔戈里']
    },
    {
      id: 'curated:kangchenjunga',
      name: 'Kangchenjunga',
      display_name: 'Kangchenjunga, Himalayas, Nepal / India',
      latitude: 27.7025,
      longitude: 88.1475,
      elevation: 8586,
      country: 'Nepal / India',
      admin1: 'Himalayas',
      feature_code: 'PK',
      featured: true,
      featuredOrder: 4,
      aliases: ['kangchenjunga', 'kanchenjunga', 'kangchendzonga', '干城章嘉峰']
    },
    {
      id: 'curated:denali',
      name: 'Mount McKinley',
      display_name: 'Mount McKinley (Denali), Alaska, United States',
      latitude: 63.0695,
      longitude: -151.0074,
      elevation: 6190,
      country: 'United States',
      admin1: 'Alaska',
      feature_code: 'MT',
      featured: true,
      featuredOrder: 5,
      aliases: ['mount mckinley', 'mt mckinley', 'denali', '德纳里峰', '麦金利山']
    },
    {
      id: 'curated:kilimanjaro',
      name: 'Mount Kilimanjaro',
      display_name: 'Mount Kilimanjaro, Kilimanjaro Region, Tanzania',
      latitude: -3.0674,
      longitude: 37.3556,
      elevation: 5895,
      country: 'Tanzania',
      admin1: 'Kilimanjaro Region',
      feature_code: 'MT',
      featured: true,
      featuredOrder: 6,
      aliases: ['mount kilimanjaro', 'mt kilimanjaro', 'kilimanjaro', '乞力马扎罗']
    },
    {
      id: 'curated:matterhorn',
      name: 'Matterhorn',
      display_name: 'Matterhorn, Valais, Switzerland / Italy',
      latitude: 45.9763,
      longitude: 7.6586,
      elevation: 4478,
      country: 'Switzerland / Italy',
      admin1: 'Valais',
      feature_code: 'PK',
      featured: true,
      featuredOrder: 7,
      aliases: ['matterhorn', 'monte cervino', 'mont cervin', '马特洪峰']
    },
    {
      id: 'curated:mont-blanc',
      name: 'Mont Blanc',
      display_name: 'Mont Blanc, Alps, France / Italy',
      latitude: 45.8326,
      longitude: 6.8652,
      elevation: 4808,
      country: 'France / Italy',
      admin1: 'Alps',
      feature_code: 'PK',
      featured: true,
      featuredOrder: 8,
      aliases: ['mont blanc', 'monte bianco', '勃朗峰']
    },
    {
      id: 'curated:aconcagua',
      name: 'Aconcagua',
      display_name: 'Aconcagua, Mendoza, Argentina',
      latitude: -32.6532,
      longitude: -70.0109,
      elevation: 6961,
      country: 'Argentina',
      admin1: 'Mendoza',
      feature_code: 'MT',
      featured: true,
      featuredOrder: 9,
      aliases: ['aconcagua', 'cerro aconcagua', '阿空加瓜', '阿空加瓜山']
    },
    {
      id: 'curated:mount-fuji',
      name: 'Mount Fuji',
      display_name: 'Mount Fuji, Shizuoka / Yamanashi, Japan',
      latitude: 35.3606,
      longitude: 138.7274,
      elevation: 3776,
      country: 'Japan',
      admin1: 'Shizuoka / Yamanashi',
      feature_code: 'MT',
      featured: true,
      featuredOrder: 10,
      aliases: ['mount fuji', 'mt fuji', 'fuji', 'fuji san', 'fujisan', '富士山']
    },
    {
      id: 'curated:vinson-massif',
      name: 'Vinson Massif',
      display_name: 'Vinson Massif, Ellsworth Mountains, Antarctica',
      latitude: -78.5254,
      longitude: -85.6171,
      elevation: 4892,
      country: 'Antarctica',
      admin1: 'Ellsworth Mountains',
      feature_code: 'MT',
      featured: true,
      featuredOrder: 11,
      aliases: ['vinson massif', 'mount vinson', 'vinson', '文森峰']
    },
    {
      id: 'curated:el-capitan-yosemite',
      name: 'El Capitan',
      display_name: 'El Capitan, Yosemite Valley, California, United States',
      latitude: 37.73404,
      longitude: -119.63773,
      elevation: 2308,
      country: 'United States',
      admin1: 'California',
      feature_code: 'CLF',
      featured: true,
      featuredOrder: 12,
      aliases: ['el capitan', 'ei capitan', 'capitan', 'el capitan yosemite', 'yosemite el capitan', '酋长岩']
    },
    {
      id: 'curated:huangshan-lotus-peak',
      name: 'Huangshan',
      display_name: 'Mount Huangshan (Lotus Peak), Anhui, China',
      latitude: 30.12745,
      longitude: 118.16594,
      elevation: 1864,
      country: 'China',
      admin1: 'Anhui',
      feature_code: 'PK',
      featured: true,
      featuredOrder: 2,
      aliases: ['huangshan', 'mount huangshan', 'yellow mountain', 'yellow mountains', '黄山', '黄山风景区', '莲花峰', 'lianhua feng', 'lotus peak']
    },
    {
      id: 'curated:half-dome',
      name: 'Half Dome',
      display_name: 'Half Dome, Yosemite Valley, California, United States',
      latitude: 37.746,
      longitude: -119.5332,
      elevation: 2694,
      country: 'United States',
      admin1: 'California',
      feature_code: 'CLF',
      featured: true,
      featuredOrder: 13,
      aliases: ['half dome', 'yosemite half dome']
    },
    {
      id: 'curated:mount-rainier',
      name: 'Mount Rainier',
      display_name: 'Mount Rainier, Washington, United States',
      latitude: 46.8523,
      longitude: -121.7603,
      elevation: 4392,
      country: 'United States',
      admin1: 'Washington',
      feature_code: 'MT',
      featured: true,
      featuredOrder: 14,
      aliases: ['mount rainier', 'mt rainier', 'rainier']
    },
    {
      id: 'curated:aoraki-mount-cook',
      name: 'Aoraki / Mount Cook',
      display_name: 'Aoraki / Mount Cook, Canterbury, New Zealand',
      latitude: -43.595,
      longitude: 170.1418,
      elevation: 3724,
      country: 'New Zealand',
      admin1: 'Canterbury',
      feature_code: 'MT',
      aliases: ['aoraki', 'mount cook', 'mt cook', 'aoraki mount cook']
    },
    {
      id: 'curated:jade-dragon-snow-mountain',
      name: 'Jade Dragon Snow Mountain',
      display_name: 'Jade Dragon Snow Mountain, Yunnan, China',
      latitude: 27.1002,
      longitude: 100.1731,
      elevation: 5596,
      country: 'China',
      admin1: 'Yunnan',
      feature_code: 'MTS',
      aliases: ['jade dragon snow mountain', 'yulong snow mountain', '玉龙雪山']
    }
  ];

  const STANDARD_TERRAIN_QUICK_PICK_EXCLUDED_IDS = new Set();
  const CUSTOMIZATION_OPTION_NAMES = ['Version', 'Customization'];
  const RANDOM_TERRAIN_PATTERN_ID = 'random-pattern';
  const RANDOM_TERRAIN_PATTERN_LABEL = 'Random pattern';
  const STANDARD_RANDOM_PATTERN_SEED = 'smallsmore-standard-random-pattern-v1';
  const STANDARD_COLOR_COMBOS = {
    'black-blue': {
      caseColorId: 'black',
      caseLabel: 'Classic Black',
      paletteId: 'tech-blue'
    },
    'grey-orange': {
      caseColorId: 'pantone-7527-c',
      caseLabel: 'Retro White',
      paletteId: 'signal-orange'
    },
    'pink-pink': {
      caseColorId: 'pantone-2051-c',
      caseLabel: 'Mauve Haze',
      paletteId: 'soft-pink'
    },
    'green-yellow': {
      caseColorId: 'pantone-2410-c',
      caseLabel: 'Olive Green',
      paletteId: 'warm-yellow'
    }
  };

  const PRELOADED_TERRAIN_DATA = {"curated:mount-everest":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":29.06607,"south":26.91013,"east":87.68186,"west":86.16814,"radius_km":120},"grid":{"columns":9,"rows":11,"min":168,"max":8771,"peak":{"elevation":8771,"latitude":27.9881,"longitude":86.925,"row":5,"column":4},"elevations":[[5340,4755,5435,5196,4734,5553,4855,4993,4086],[5252,4434,5499,5294,5321,5076,4790,5425,5668],[5012,4998,4807,4385,4472,4426,4887,4233,4714],[4648,5220,4930,5125,4815,4630,5155,5184,4268],[5255,5707,5340,6185,5297,4959,4966,4878,5003],[4106,4920,5126,5247,8771,4666,4707,4752,4651],[2140,4155,4773,3076,5382,5571,2965,3466,5106],[1689,1986,3069,3060,3496,2518,1011,3897,3266],[1176,2184,1790,1695,2640,1152,1089,2699,1881],[886,944,825,680,1822,1000,909,1238,1065],[168,422,499,672,264,400,561,1037,1734]]}},"curated:k2":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":36.95877,"south":34.80283,"east":77.34067,"west":75.69093,"radius_km":120},"grid":{"columns":9,"rows":11,"min":2325,"max":8309,"peak":{"elevation":8309,"latitude":35.8808,"longitude":76.5158,"row":5,"column":4},"elevations":[[5028,3710,4290,3451,4982,3136,3058,3609,3777],[4754,5477,3380,5727,4239,4883,4084,4692,4953],[5485,3819,3852,4161,4468,4828,5603,5022,5687],[5071,4585,4529,4902,4663,4726,5333,5501,5387],[5560,5062,5107,5862,4234,5285,5290,5274,5493],[4202,5377,5379,4930,8309,4905,4804,5642,5267],[4655,3391,3312,5119,4919,5620,6103,5382,5417],[2325,3911,4554,3940,4591,4540,5301,5736,5951],[4878,2344,3810,4424,4174,4653,5159,4607,4507],[5168,4635,3041,4595,2573,4933,5212,5456,3972],[3523,4373,3894,5036,4814,5334,4355,4287,5597]]}},"curated:kangchenjunga":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":28.78047,"south":26.62453,"east":88.90237,"west":87.39263,"radius_km":120},"grid":{"columns":9,"rows":11,"min":88,"max":8510,"peak":{"elevation":8510,"latitude":27.7025,"longitude":88.1475,"row":5,"column":4},"elevations":[[5442,5764,5071,5353,5728,5478,4884,4897,4573],[4209,4860,4333,4798,4332,5196,4879,5632,5603],[4936,4448,4415,4970,4679,4479,4748,5210,5085],[4905,5089,4665,4628,4606,4781,4911,5074,4916],[2985,4991,5428,5654,5544,4985,4280,4795,5780],[2577,4595,4185,3874,8510,5458,4207,4551,4313],[3355,2250,1436,3182,3962,2783,781,3965,2940],[1906,1843,907,1942,1678,2112,1129,1168,4166],[1985,1108,1856,2010,1588,1415,744,1606,1007],[954,1771,362,1402,803,526,126,132,138],[113,118,120,117,114,107,102,91,88]]}},"curated:denali":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":64.14747,"south":61.99153,"east":-149.53173,"west":-152.48307,"radius_km":120},"grid":{"columns":9,"rows":11,"min":0,"max":0,"peak":{"elevation":0,"latitude":64.14747,"longitude":-152.48307,"row":0,"column":0},"elevations":[[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0]]}},"curated:kilimanjaro":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":-1.98943,"south":-4.14537,"east":38.0249,"west":36.6863,"radius_km":120},"grid":{"columns":9,"rows":11,"min":635,"max":5834,"peak":{"elevation":5834,"latitude":-3.0674,"longitude":37.3556,"row":5,"column":4},"elevations":[[1647,1580,1473,1439,1228,1129,1003,932,852],[1640,1664,1334,1266,1213,1114,937,900,793],[1435,1307,1295,1164,1133,1073,1149,1029,849],[1363,1216,1144,1130,1169,1184,1059,1856,932],[1290,1158,1224,1811,1633,1425,1232,916,948],[1448,1286,1341,2898,5834,2438,1158,858,737],[2029,1578,1176,1116,1088,1415,946,984,1047],[1184,969,888,879,712,706,716,860,987],[1056,918,1009,1036,770,882,1335,710,781],[1386,1163,1107,1016,1031,734,1168,1058,809],[1285,1460,1327,1188,962,635,807,1006,642]]}},"curated:matterhorn":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":47.05427,"south":44.89833,"east":8.62031,"west":6.69689,"radius_km":120},"grid":{"columns":9,"rows":11,"min":96,"max":4181,"peak":{"elevation":4181,"latitude":45.9763,"longitude":7.6586,"row":5,"column":4},"elevations":[[1002,718,478,552,626,935,815,552,641],[466,444,599,899,873,1186,887,970,830],[795,886,1041,1376,1347,1003,3353,2986,1861],[440,551,1832,1841,2619,2928,1054,2195,1125],[949,1997,1161,841,3037,1145,1324,1440,941],[2422,1373,1840,3068,4181,3225,944,462,655],[2065,2544,2350,1435,1016,2293,1689,470,276],[1442,2578,2733,3099,1576,1220,285,212,207],[2016,3340,2689,1551,321,230,183,131,119],[1885,1547,864,391,252,286,240,252,101],[2061,2288,1417,291,235,262,165,141,96]]}},"curated:mont-blanc":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":46.91057,"south":44.75463,"east":7.82442,"west":5.90598,"radius_km":120},"grid":{"columns":9,"rows":11,"min":196,"max":4761,"peak":{"elevation":4761,"latitude":45.8326,"longitude":6.8652,"row":5,"column":4},"elevations":[[560,842,893,874,422,492,669,648,917],[750,1027,1114,593,702,657,1139,1085,1033],[722,1316,440,370,532,1758,1358,1677,2879],[850,424,580,756,1737,1488,1167,1651,1791],[479,725,801,854,2771,2075,2907,2857,2262],[456,575,1520,1502,4761,2618,1202,1906,1667],[366,775,1634,2178,1552,3146,1662,1854,778],[1384,1575,2253,1949,2875,2344,2352,1100,246],[1222,2119,2304,1616,2435,2388,1811,337,196],[1822,1596,3134,2131,2508,2180,1022,252,254],[1591,2271,2885,2021,2526,1919,313,254,330]]}},"curated:aconcagua":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":-31.57523,"south":-33.73117,"east":-69.2171,"west":-70.8047,"radius_km":120},"grid":{"columns":9,"rows":11,"min":427,"max":6891,"peak":{"elevation":6891,"latitude":-32.6532,"longitude":-70.0109,"row":5,"column":4},"elevations":[[1436,3565,3974,3065,3590,4172,2165,1824,3210],[2404,1833,4164,3925,2982,3473,1916,1979,2837],[1845,1722,3782,3981,4134,2421,3291,2208,3137],[742,2012,3350,3803,3349,2410,4736,2549,2261],[1399,1704,2733,4486,3399,3766,3622,2788,2466],[1912,1363,3486,3598,6891,4327,3449,1834,2724],[1083,823,1220,2169,4195,3127,4673,3568,1902],[682,1263,3462,3372,3614,3791,4212,4147,1902],[485,1065,1804,3589,4725,4089,3183,2107,1400],[452,593,1616,1415,3372,4717,5377,2367,1086],[427,1169,2208,2886,4011,4134,3958,3107,1141]]}},"curated:mount-fuji":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":36.43857,"south":34.28263,"east":139.54692,"west":137.90788,"radius_km":120},"grid":{"columns":9,"rows":11,"min":0,"max":3695,"peak":{"elevation":3695,"latitude":35.3606,"longitude":138.7274,"row":5,"column":4},"elevations":[[701,1134,775,1459,848,503,255,406,271],[614,1983,978,899,531,264,79,33,21],[1107,762,1837,1125,1224,694,445,79,24],[1085,1472,686,1301,945,928,508,143,39],[446,1546,1569,243,1306,417,378,135,38],[892,2234,843,1118,3695,508,462,9,17],[764,899,418,285,4,114,0,0,0],[451,427,233,0,0,129,104,0,0],[6,57,0,0,0,249,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0]]}},"curated:vinson-massif":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":-77.44743,"south":-79.60337,"east":-82.25747,"west":-88.97673,"radius_km":120},"grid":{"columns":9,"rows":11,"min":0,"max":0,"peak":{"elevation":0,"latitude":-77.44743,"longitude":-88.97673,"row":0,"column":0},"elevations":[[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0]]}},"curated:el-capitan-yosemite":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":38.81201,"south":36.65607,"east":-118.79265,"west":-120.48281,"radius_km":120},"grid":{"columns":9,"rows":11,"min":43,"max":3507,"peak":{"elevation":3507,"latitude":37.51845,"longitude":-118.79265,"row":6,"column":8},"elevations":[[1489,2010,2258,2821,1915,2365,1442,1773,1616],[1221,1828,2603,2896,2065,1844,1960,1507,2519],[860,1597,2072,2050,2844,2291,2285,1986,2113],[688,979,1662,2549,2967,3370,2178,2375,2165],[329,852,1369,1531,2481,3080,2605,1948,2293],[189,718,935,1574,2165,2430,3032,2368,2099],[85,227,665,1083,1413,2285,1925,2857,3507],[55,81,285,252,875,2012,2465,2431,3441],[43,70,98,224,260,1357,1898,2789,3274],[45,52,74,103,130,445,330,937,1928],[83,48,65,81,100,118,312,1085,2305]]}},"curated:half-dome":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":38.82397,"south":36.66803,"east":-118.68798,"west":-120.37842,"radius_km":120},"grid":{"columns":9,"rows":11,"min":46,"max":3661,"peak":{"elevation":3661,"latitude":37.31481,"longitude":-118.89928,"row":7,"column":7},"elevations":[[1627,2366,2818,1579,2591,1443,1438,1837,1307],[1597,2359,2548,2156,1854,2440,2443,1933,1206],[1145,1990,2137,2692,2886,2820,2152,1878,2373],[988,1093,2144,2771,2631,2162,2356,2174,2467],[578,1045,1668,1727,2550,3609,2058,2077,1984],[246,917,1225,2025,2381,3257,2720,2167,3143],[109,495,921,1824,1996,2365,2361,3559,2454],[62,173,387,511,1132,1072,2574,3661,3568],[60,85,151,347,424,1694,2665,2460,3535],[46,65,86,119,190,813,714,1854,3253],[56,54,73,89,104,142,861,1906,2755]]}},"curated:mount-rainier":{"source":"preloaded-open-elevation","attribution":"Preloaded elevation data from Open-Elevation.com","bounds":{"north":47.93027,"south":45.77433,"east":-120.78302,"west":-122.73758,"radius_km":120},"grid":{"columns":9,"rows":11,"min":0,"max":4359,"peak":{"elevation":4359,"latitude":46.8523,"longitude":-121.7603,"row":5,"column":4},"elevations":[[55,0,146,175,245,1283,872,1229,1155],[82,0,102,12,337,1624,402,1297,1204],[154,0,101,574,316,1649,1465,1714,2048],[0,44,18,191,413,1278,1048,871,1365],[74,119,195,537,1368,1273,1179,1569,991],[180,150,379,1271,4359,1288,1562,817,771],[220,687,620,978,897,1516,964,1743,715],[187,577,734,553,459,1002,1104,1116,361],[637,920,1058,824,1156,2912,749,1081,1044],[476,67,530,1012,1338,566,556,1006,1392],[61,121,798,752,625,179,604,603,549]]}}};

  const PRELOADED_TERRAIN_OVERRIDES = {
    'curated:denali': {
      source: 'preloaded-open-meteo',
      attribution: 'Preloaded elevation data from Open-Meteo.com',
      bounds: { north: 64.14747, south: 61.99153, east: -149.53173, west: -152.48307, radius_km: 120 },
      grid: {
        columns: 9,
        rows: 11,
        min: 57,
        max: 6144,
        peak: { elevation: 6144, latitude: 63.0695, longitude: -151.0074, row: 5, column: 4 },
        elevations: [
          [231, 422, 398, 212, 187, 141, 194, 240, 393],
          [249, 357, 195, 176, 161, 199, 870, 474, 633],
          [234, 236, 238, 254, 316, 795, 673, 714, 751],
          [310, 295, 344, 544, 789, 844, 1081, 1232, 1216],
          [356, 460, 532, 651, 929, 1268, 1474, 1509, 913],
          [503, 622, 1282, 1752, 6144, 2738, 1049, 1106, 541],
          [537, 1866, 1394, 1893, 1495, 861, 803, 358, 663],
          [1615, 1314, 847, 784, 1249, 217, 188, 652, 791],
          [1628, 466, 791, 426, 511, 370, 177, 371, 424],
          [498, 742, 97, 405, 272, 249, 109, 264, 958],
          [617, 375, 217, 58, 57, 165, 65, 143, 867]
        ]
      }
    },
    'curated:vinson-massif': {
      source: 'preloaded-open-meteo',
      attribution: 'Preloaded elevation data from Open-Meteo.com',
      bounds: { north: -77.44743, south: -79.60337, east: -82.25747, west: -88.97673, radius_km: 120 },
      grid: {
        columns: 9,
        rows: 11,
        min: 171,
        max: 4850,
        peak: { elevation: 4850, latitude: -78.5254, longitude: -85.6171, row: 5, column: 4 },
        elevations: [
          [1398, 1316, 1309, 1289, 851, 586, 618, 555, 413],
          [1478, 1522, 1459, 1490, 944, 473, 491, 692, 388],
          [1642, 1625, 1767, 1799, 1564, 417, 344, 688, 679],
          [1795, 1767, 1859, 2051, 1993, 438, 325, 524, 670],
          [1902, 1928, 2095, 2168, 1710, 702, 301, 250, 524],
          [1881, 1937, 2088, 1967, 4850, 2118, 726, 194, 182],
          [2010, 1937, 1765, 1679, 1075, 2069, 324, 186, 193],
          [2076, 2014, 1864, 1360, 1138, 651, 472, 251, 171],
          [2051, 2069, 1977, 1610, 1374, 1992, 566, 370, 325],
          [1966, 1957, 1969, 1931, 1562, 1027, 1764, 677, 566],
          [1904, 1834, 1842, 1827, 1787, 1632, 1166, 1054, 443]
        ]
      }
    },
    'curated:huangshan-lotus-peak': {
      source: 'preloaded-open-meteo',
      attribution: 'Preloaded elevation data from Open-Meteo.com',
      bounds: { north: 31.20542, south: 29.04948, east: 118.93867, west: 117.39321, radius_km: 120 },
      grid: {
        columns: 9,
        rows: 11,
        min: 4,
        max: 1745,
        peak: { elevation: 1745, latitude: 30.12745, longitude: 118.16594, row: 5, column: 4 },
        elevations: [
          [8, 13, 22, 11, 6, 14, 6, 6, 21],
          [76, 69, 18, 14, 38, 7, 36, 4, 116],
          [11, 12, 10, 40, 75, 100, 66, 113, 33],
          [10, 100, 38, 257, 317, 498, 186, 624, 70],
          [102, 500, 772, 111, 697, 189, 252, 206, 772],
          [350, 357, 218, 584, 1745, 943, 707, 352, 598],
          [294, 347, 197, 367, 482, 273, 238, 367, 607],
          [153, 280, 343, 192, 230, 194, 423, 288, 463],
          [75, 649, 381, 715, 607, 319, 184, 99, 337],
          [133, 166, 104, 214, 362, 259, 462, 990, 268],
          [54, 218, 243, 238, 231, 130, 329, 564, 81]
        ]
      }
    },
    'curated:aoraki-mount-cook': {
      source: 'preloaded-open-meteo',
      attribution: 'Preloaded elevation data from Open-Meteo.com',
      bounds: { north: -42.51703, south: -44.67297, east: 171.06463, west: 169.21897, radius_km: 120 },
      grid: {
        columns: 9,
        rows: 11,
        min: 0,
        max: 3724,
        peak: { elevation: 3724, latitude: -43.595, longitude: 170.1418, row: 5, column: 4 },
        elevations: [
          [0, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 0, 0, 267],
          [0, 0, 0, 0, 0, 0, 0, 672, 238],
          [0, 0, 0, 0, 0, 24, 187, 1662, 1897],
          [0, 0, 0, 0, 117, 883, 1128, 1176, 1650],
          [0, 0, 24, 630, 3724, 1860, 1181, 1009, 785],
          [301, 376, 917, 2143, 598, 1535, 868, 1315, 709],
          [655, 1362, 1879, 627, 532, 770, 1478, 387, 453],
          [294, 615, 1703, 905, 466, 582, 1074, 303, 113],
          [820, 1314, 895, 463, 1108, 1142, 691, 911, 116],
          [313, 529, 914, 1116, 605, 236, 296, 575, 68]
        ]
      }
    },
    'curated:jade-dragon-snow-mountain': {
      source: 'preloaded-open-meteo',
      attribution: 'Preloaded elevation data from Open-Meteo.com',
      bounds: { north: 28.17817, south: 26.02223, east: 100.92387, west: 99.42233, radius_km: 120 },
      grid: {
        columns: 9,
        rows: 11,
        min: 1341,
        max: 5596,
        peak: { elevation: 5596, latitude: 27.1002, longitude: 100.1731, row: 5, column: 4 },
        elevations: [
          [2929, 3380, 3393, 4493, 3310, 4652, 2901, 3801, 3164],
          [2480, 3796, 3396, 3921, 3323, 3310, 3126, 3164, 2778],
          [2631, 4055, 3738, 3772, 2824, 2012, 3281, 3085, 2867],
          [2973, 3048, 3188, 4271, 3240, 3546, 3425, 3248, 3269],
          [3656, 2279, 3871, 2356, 3235, 3153, 2884, 2837, 3195],
          [3154, 2470, 3280, 3214, 5596, 3539, 2631, 2946, 2797],
          [2702, 4311, 3047, 1816, 2473, 2756, 1873, 3121, 2558],
          [2947, 3476, 3066, 2597, 2686, 2865, 2736, 2184, 2727],
          [2400, 2371, 2332, 2790, 2361, 2215, 3010, 2207, 2820],
          [2635, 3421, 2546, 2094, 2395, 1464, 1395, 2085, 2161],
          [2118, 2811, 1983, 2738, 2216, 1951, 1341, 2363, 1665]
        ]
      }
    }
  };

  class SmallsmorePatchCustomizer {
    constructor(root) {
      this.root = root;
      this.config = this.readConfig();
      this.stage = null;
      this.layer = null;
      this.activePalette = null;
      this.caseColorId = '';
      this.patchColorId = '';
      this.buttonColorId = '';
      this.isSubmitting = false;
      this.isAddSubmitIntent = false;
      this.statusTimer = null;
      this.shareStatusTimer = null;
      this.terrainData = null;
      this.terrainDataRegion = '';
      this.terrainLoadTimer = null;
      this.terrainPromise = null;
      this.terrainRequestId = 0;
      this.terrainCache = new Map();
      this.terrainSuggestionTimer = null;
      this.terrainSuggestionRequestId = 0;
      this.terrainSuggestionCache = new Map();
      this.terrainSuggestions = [];
      this.selectedTerrainLocation = null;
      this.presetRegionInputValue = '';
      this.terrainMapOffset = { ...TERRAIN_DEFAULT_MAP_OFFSET };
      this.terrainDrag = null;
      this.terrainAnnotationOverride = null;
      this.terrainContourCache = null;
      this.terrainScale = TERRAIN_DEFAULT_SCALE;
      this.terrainScaleBarVisible = true;
      this.textSizeId = 'm';
      this.textSizeScale = 1;
      this.textColor = '';
      this.textColorId = 'palette';
      this.textStroke = '';
      this.textStrokeWidth = 0;
      this.textStrokeId = 'none';
      this.textAlign = 'center';
      this.bottomTextSkipped = false;
      this.customizationMode = 'Standard';
      this.standardTerrainId = RANDOM_TERRAIN_PATTERN_ID;
      this.standardComboId = 'black-blue';
      this.standardPreviewView = 'effect';
      this.standardPreviewPhotoIndex = 0;
      this.standardPreviewPhotoSetKey = '';
      this.standardRandomTerrainData = null;
      this.customModeSnapshot = null;
      this.useNativeCartSubmit = false;
      this.undoStack = [];
      this.redoStack = [];
      this.pendingHistorySnapshot = null;
      this.isRestoringHistory = false;
      this.previewOverlayTimer = null;
      this.previewDialog = null;
      this.cartAddingMount = null;
      this.previewImageUrl = '';
      this.previewUploadMeta = null;
      this.productionLineId = '';
      this.editDraftId = '';
      this.editCartKey = '';
      this.editPath = '';
      this.editDraftStorageUnavailable = false;
      this.editDraftRestorePromise = null;
      this.variantChangeUnsubscriber = null;
      this.collapsiblePatchStepIds = [];
      this.activePatchStepId = null;
      this.collapsedPatchSteps = new Set();

      this.nodes = {
        productInfo: root.querySelector('product-info'),
        layout: root.querySelector('.smallsmore-patch-customizer__layout'),
        commerceSummary: root.querySelector('.smallsmore-patch-customizer__commerce-summary'),
        commercePrice: root.querySelector('.smallsmore-patch-customizer__commerce-price'),
        commerceControls: root.querySelector('[data-patch-commerce-controls]'),
        purchaseRow: root.querySelector('[data-patch-purchase-row]'),
        inventory: root.querySelector('[data-patch-inventory]'),
        quantity: root.querySelector('[data-patch-quantity]'),
        preview: root.querySelector('.smallsmore-patch-customizer__preview'),
        stage: root.querySelector('[data-patch-stage]'),
        previewButton: root.querySelector('[data-patch-preview-open]'),
        standardPhotoPreview: root.querySelector('[data-standard-photo-preview]'),
        standardPhotoImage: root.querySelector('[data-standard-photo-image]'),
        standardPreviewTabs: root.querySelector('[data-standard-preview-tabs]'),
        standardPreviewNote: root.querySelector('[data-standard-preview-note]'),
        standardPreviewViewButtons: Array.from(root.querySelectorAll('[data-standard-preview-view]')),
        standardPhotoThumbnails: root.querySelector('[data-standard-photo-thumbnails]'),
        standardPhotoThumbnailList: root.querySelector('[data-standard-photo-thumbnail-list]'),
        specBlock: root.querySelector('[data-patch-spec-block]'),
        specToggle: root.querySelector('[data-patch-spec-toggle]'),
        form: root.querySelector('form[data-type="add-to-cart-form"]') || root.querySelector('form[action*="/cart/add"]'),
        steps: Array.from(root.querySelectorAll('[data-patch-step]')),
        customizationFallback: root.querySelector('[data-patch-customization-fallback]'),
        customizationModeButtons: Array.from(root.querySelectorAll('[data-patch-customization-mode]')),
        customContent: Array.from(root.querySelectorAll('[data-patch-custom-content]')),
        customPanel: root.querySelector('[data-patch-custom-panel]'),
        standardPanel: root.querySelector('[data-patch-standard-panel]'),
        standardCaseColorCareNotice: root.querySelector('[data-patch-standard-case-color-care-notice]'),
        standardComboButtons: Array.from(root.querySelectorAll('[data-patch-standard-combo]')),
        standardButtonColors: root.querySelector('[data-patch-standard-button-colors]'),
        standardTerrainButtons: Array.from(root.querySelectorAll('[data-patch-standard-terrain]')),
        randomTerrainButtons: Array.from(root.querySelectorAll('[data-patch-random-terrain]')),
        variantId: root.querySelector('[data-patch-variant-id]'),
        template: root.querySelector('[data-patch-template]'),
        mainText: root.querySelector('[data-patch-main-text]'),
        mainTextSecondary: root.querySelector('[data-patch-main-text-secondary]'),
        sideText: root.querySelector('[data-patch-side-text]'),
        bottomFont: root.querySelector('[data-patch-bottom-font]'),
        bottomText: root.querySelector('[data-patch-bottom-text]'),
        bottomTextControls: root.querySelector('[data-patch-bottom-text-controls]'),
        bottomTextSkip: root.querySelector('[data-patch-bottom-text-skip]'),
        textSizeButtons: Array.from(root.querySelectorAll('[data-patch-text-size]')),
        textAlignButtons: Array.from(root.querySelectorAll('[data-patch-text-align]')),
        textColorButtons: Array.from(root.querySelectorAll('[data-patch-text-color]')),
        textStrokeButtons: Array.from(root.querySelectorAll('[data-patch-text-stroke-option]')),
        region: root.querySelector('[data-patch-region]'),
        showRegion: root.querySelector('[data-patch-show-region]'),
        locationModes: Array.from(root.querySelectorAll('[data-patch-location-mode]')),
        searchPanel: root.querySelector('[data-patch-search-panel]'),
        coordinatePanel: root.querySelector('[data-patch-coordinate-panel]'),
        coordinates: root.querySelector('[data-patch-coordinates]'),
        coordinateLabel: root.querySelector('[data-patch-coordinate-label]'),
        regionQuickPicks: root.querySelector('[data-patch-region-quick-picks]'),
        regionSuggestions: root.querySelector('[data-patch-region-suggestions]'),
        regionSuggestionStatus: root.querySelector('[data-patch-region-suggestion-status]'),
        getMapButton: root.querySelector('[data-patch-get-map]'),
        mapActions: root.querySelector('[data-patch-map-actions]'),
        guideOpenButton: root.querySelector('[data-patch-guide-open]'),
        guideDialog: root.querySelector('[data-patch-guide-dialog]'),
        guideCloseButtons: Array.from(root.querySelectorAll('[data-patch-guide-close]')),
        coordinateGuideOpenButton: root.querySelector('[data-patch-coordinate-guide-open]'),
        coordinateGuideDialog: root.querySelector('[data-patch-coordinate-guide-dialog]'),
        coordinateGuideCloseButtons: Array.from(root.querySelectorAll('[data-patch-coordinate-guide-close]')),
        terrainReminderDialog: root.querySelector('[data-patch-terrain-reminder-dialog]'),
        terrainReminderCloseButtons: Array.from(root.querySelectorAll('[data-patch-terrain-reminder-close]')),
        terrainReminderGetMapButton: root.querySelector('[data-patch-terrain-reminder-get-map]'),
        historyTools: root.querySelector('[data-patch-history-tools]'),
        undo: root.querySelector('[data-patch-undo]'),
        redo: root.querySelector('[data-patch-redo]'),
        centerMapButton: root.querySelector('[data-patch-center-map]'),
        resetPointButton: root.querySelector('[data-patch-reset-point]'),
        terrainScaleControl: root.querySelector('[data-patch-terrain-scale-control]'),
        terrainScaleControls: Array.from(root.querySelectorAll('[data-patch-terrain-scale]')),
        scaleBarToggle: root.querySelector('[data-patch-scale-bar-toggle]'),
        caseColors: root.querySelector('[data-patch-case-colors]'),
        caseColorCareNotice: root.querySelector('[data-patch-case-color-care-notice]'),
        patchColors: root.querySelector('[data-patch-patch-colors]'),
        buttonColors: root.querySelector('[data-patch-button-colors]'),
        palettes: root.querySelector('[data-patch-palettes]'),
        status: root.querySelector('[data-patch-status]'),
        cartAdding: root.querySelector('[data-patch-cart-adding]'),
        cartAddingTitle: root.querySelector('[data-patch-cart-adding-title]'),
        cartAddingMessage: root.querySelector('[data-patch-cart-adding-message]'),
        previewOverlay: root.querySelector('[data-patch-preview-overlay]'),
        previewOverlayText: root.querySelector('[data-patch-preview-overlay-text]'),
        previewOverlaySpinner: root.querySelector('[data-patch-preview-overlay-spinner]'),
        propertyTemplate: root.querySelector('[data-patch-property-template]'),
        propertyMainText: root.querySelector('[data-patch-property-main-text]'),
        propertySideText: root.querySelector('[data-patch-property-side-text]'),
        propertyBottomText: root.querySelector('[data-patch-property-bottom-text]'),
        propertyTextFont: root.querySelector('[data-patch-property-text-font]'),
        propertyTextColor: root.querySelector('[data-patch-property-text-color]'),
        propertyTextOutline: root.querySelector('[data-patch-property-text-outline]'),
        propertyRegion: root.querySelector('[data-patch-property-region]'),
        propertyShowRegion: root.querySelector('[data-patch-property-show-region]'),
        propertyCustomization: root.querySelector('[data-patch-property-customization]'),
        propertyTerrainChoice: root.querySelector('[data-patch-property-terrain-choice]'),
        propertyCaseColor: root.querySelector('[data-patch-property-case-color]'),
        propertyButtonColor: root.querySelector('[data-patch-property-button-color]'),
        propertyPatchColor: root.querySelector('[data-patch-property-patch-color]'),
        propertyPalette: root.querySelector('[data-patch-property-palette]'),
        propertyPrintResolution: root.querySelector('[data-patch-property-print-resolution]'),
        propertyPrintFile: root.querySelector('[data-patch-property-print-file]'),
        propertyDesignImage: root.querySelector('[data-patch-property-design-image]'),
        propertyProductionLineId: root.querySelector('[data-patch-property-production-line-id]'),
        propertyPayload: root.querySelector('[data-patch-property-payload]'),
        propertyEditDraftId: root.querySelector('[data-patch-property-edit-draft-id]'),
        propertyEditPath: root.querySelector('[data-patch-property-edit-path]'),
        printFile: root.querySelector('[data-patch-print-file]'),
        shareControl: root.querySelector('[data-patch-share-control]'),
        shareButton: root.querySelector('[data-patch-share]'),
        shareMenu: root.querySelector('[data-patch-share-menu]'),
        shareDownload: root.querySelector('[data-patch-share-download]'),
        shareSystem: root.querySelector('[data-patch-share-system]'),
        shareStatus: root.querySelector('[data-patch-share-status]'),
        actions: root.querySelector('[data-patch-actions]'),
        submitButton: root.querySelector('button[type="submit"]'),
        submitButtonText: root.querySelector('button[type="submit"] span')
      };
      this.previewControlDefaults = {
        guideOpenHidden: Boolean(this.nodes.guideOpenButton && this.nodes.guideOpenButton.hidden),
        guideOpenDisabled: Boolean(this.nodes.guideOpenButton && this.nodes.guideOpenButton.disabled)
      };

      const defaultTextColorButton = this.nodes.textColorButtons.find((button) => button.classList.contains('is-active')) || this.nodes.textColorButtons[0];
      if (defaultTextColorButton && defaultTextColorButton.dataset.patchTextColorId !== 'palette') {
        this.textColorId = defaultTextColorButton.dataset.patchTextColorId || defaultTextColorButton.dataset.patchTextColor || 'palette';
        this.textColor = defaultTextColorButton.dataset.patchTextColor || '';
      }
    }

    init() {
      if (!window.Konva) {
        this.setStatus('The patch editor could not load. Please refresh and try again.', 'error');
        return;
      }

      if (!this.nodes.form) {
        this.setStatus('Select a default Shopify product before testing this patch customizer.', 'error');
        return;
      }

      this.readEditContext();
      this.syncVariantOptionState();
      this.applyInitialCustomizationModeFromUrl();
      const initialVariant = this.getVariantFromSelectedControls();
      if (initialVariant) {
        this.config.variant_id = initialVariant.id;
        if (this.nodes.variantId) {
          this.nodes.variantId.value = initialVariant.id;
          this.nodes.variantId.disabled = !initialVariant.available;
        }
      }
      this.syncPurchaseAvailability(initialVariant || this.getConfiguredVariant());
      this.populateHardwareColorOptions();
      this.populatePalettes();
      this.populateTerrainQuickPicks();
      this.setupPatchStepToggles();
      this.createStage();
      this.normalizeMainTextInputs();
      this.bindEvents();
      this.syncRegionControls();
      this.loadEditorFonts();
      this.applyPalette(this.isStandardCustomizationMode()
        ? this.getStandardCombo(this.standardComboId).paletteId || this.getPalettes()[0].id
        : this.getPalettes()[0].id, { render: false });
      this.syncLocationModeUi();
      this.syncTerrainScaleControls();
      this.updatePatchSteps();
      this.updateTerrainControls();
      this.updateTerrainQuickPicks();
      this.syncCustomizationModeUi({ loadStandardTerrain: true });
      this.render();
      this.updateHistoryButtons();
      this.queueTerrainSuggestions({ immediate: true });
      if (this.editDraftId) this.restoreEditDraftFromUrl();
    }

    readConfig() {
      const script = this.root.querySelector('[data-patch-config]');
      if (!script) return {};

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return {};
      }
    }

    getRequestedCustomizationMode() {
      const params = new URLSearchParams(window.location.search || '');
      const value = params.get('sm_purchase_mode') || params.get('sm_customization_mode') || '';
      const normalized = this.normalizeVariantOptionName(value);

      if (normalized === 'custom' || normalized === 'make it yours' || normalized === 'make-it-yours') return 'Custom';
      if (normalized === 'standard') return 'Standard';

      return '';
    }

    applyInitialCustomizationModeFromUrl() {
      const requestedMode = this.getRequestedCustomizationMode();
      if (!requestedMode || requestedMode === this.getCustomizationMode()) return;

      this.setCustomizationMode(requestedMode, {
        loadStandardTerrain: requestedMode === 'Standard',
        restoreCustomSnapshot: false,
        render: false
      });
    }

    readEditContext() {
      const params = new URLSearchParams(window.location.search || '');
      this.editDraftId = (params.get('sm_draft') || '').trim();
      this.editCartKey = (params.get('sm_cart_key') || '').trim();
      this.editPath = this.getCleanEditPath();
    }

    applyEditContext(detail = {}) {
      const draftId = (detail.draftId || '').trim();
      const cartKey = (detail.cartKey || '').trim();

      if (draftId) this.editDraftId = draftId;
      if (cartKey) this.editCartKey = cartKey;
      this.editPath = this.getCleanEditPath();
      this.syncEditDraftProperties(this.editDraftId ? { id: this.editDraftId, editPath: this.editPath } : null);
    }

    getCleanEditPath() {
      const url = new URL(window.location.href);
      url.searchParams.delete('sm_draft');
      url.searchParams.delete('sm_cart_key');
      const query = url.searchParams.toString();
      return `${url.pathname}${query ? `?${query}` : ''}`;
    }

    createEditDraftId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }

      const random = Math.random().toString(36).slice(2, 10);
      return `patch-draft-${Date.now().toString(36)}-${random}`;
    }

    getDraftRequest(request) {
      return new Promise((resolve, reject) => {
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error || new Error('Draft storage request failed.'));
      });
    }

    openDraftDatabase() {
      if (!window.indexedDB) {
        return Promise.reject(new Error('Draft storage is not available.'));
      }

      return new Promise((resolve, reject) => {
        const request = window.indexedDB.open(EDIT_DRAFT_DB_NAME, EDIT_DRAFT_DB_VERSION);

        request.onupgradeneeded = () => {
          const db = request.result;
          if (!db.objectStoreNames.contains(EDIT_DRAFT_STORE_NAME)) {
            db.createObjectStore(EDIT_DRAFT_STORE_NAME, { keyPath: 'id' });
          }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error || new Error('Draft storage could not open.'));
      });
    }

    async withDraftStore(mode, callback) {
      const db = await this.openDraftDatabase();

      try {
        return await new Promise((resolve, reject) => {
          const transaction = db.transaction(EDIT_DRAFT_STORE_NAME, mode);
          const store = transaction.objectStore(EDIT_DRAFT_STORE_NAME);
          let callbackResult;

          transaction.oncomplete = () => resolve(callbackResult);
          transaction.onerror = () => reject(transaction.error || new Error('Draft storage transaction failed.'));
          transaction.onabort = () => reject(transaction.error || new Error('Draft storage transaction aborted.'));

          try {
            callbackResult = callback(store);
          } catch (error) {
            transaction.abort();
            reject(error);
          }
        });
      } finally {
        db.close();
      }
    }

    saveDraftRecord(record) {
      return this.withDraftStore('readwrite', (store) => {
        store.put(record);
      });
    }

    getDraftRecord(draftId) {
      return this.withDraftStore('readonly', (store) => this.getDraftRequest(store.get(draftId)));
    }

    async pruneDraftRecords(maxCount = EDIT_DRAFT_MAX_COUNT) {
      const now = Date.now();
      const records = await this.withDraftStore('readonly', (store) => this.getDraftRequest(store.getAll()));
      const sorted = (Array.isArray(records) ? records : [])
        .filter((record) => record && record.id)
        .sort((first, second) => Number(second.updatedAt || 0) - Number(first.updatedAt || 0));
      const keepIds = new Set(sorted.slice(0, maxCount).map((record) => record.id));
      const expiredIds = sorted
        .filter((record) => (now - Number(record.updatedAt || record.createdAt || 0)) > EDIT_DRAFT_MAX_AGE_MS || !keepIds.has(record.id))
        .map((record) => record.id);

      if (!expiredIds.length) return;

      await this.withDraftStore('readwrite', (store) => {
        expiredIds.forEach((id) => store.delete(id));
      });
    }

    getPalettes() {
      const palettes = Array.isArray(this.config.palettes) ? this.config.palettes : [];

      if (palettes.length) return palettes;

      return [
        {
          id: 'original-graphite',
          label: 'Graphite',
          base: '#212121',
          pattern: '#333333',
          text: '#f2efe5',
          accent: '#ed0806'
        }
      ];
    }

    normalizeVariantOptionName(value) {
      const normalized = String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      if (normalized === 'figma black' || normalized === 'figma-black') return 'black';
      return normalized;
    }

    isHiddenCaseColorValue(value) {
      const normalized = this.normalizeVariantOptionName(value);
      return normalized === 'pantone-2265-c' || normalized === 'very green';
    }

    isHiddenCaseColor(color) {
      if (!color) return false;

      return [
        color.id,
        color.label,
        color.optionValue
      ].some((value) => this.isHiddenCaseColorValue(value));
    }

    getVisibleCaseColors(colors) {
      return (Array.isArray(colors) ? colors : [])
        .filter((color) => !this.isHiddenCaseColor(color));
    }

    getVisibleCaseOptionValues() {
      return this.getVariantOptionValues('Case Color')
        .filter((value) => !this.isHiddenCaseColorValue(value));
    }

    getVariantOptionIndex(optionName) {
      const expected = this.normalizeVariantOptionName(optionName);
      if (!expected) return -1;

      return Array.from(this.root.querySelectorAll('[data-patch-variant-option]'))
        .findIndex((control) => this.normalizeVariantOptionName(control.dataset.patchVariantOption) === expected);
    }

    getVariantOptionValue(variant, optionName) {
      if (!variant) return '';

      const optionIndex = this.getVariantOptionIndex(optionName);
      if (optionIndex < 0) return '';

      const options = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3];
      return String(options[optionIndex] || '').trim();
    }

    isHiddenCaseVariant(variant) {
      const caseColorValue = this.getVariantOptionValue(variant, 'Case Color');
      if (this.isHiddenCaseColorValue(caseColorValue)) return true;
      return this.isHiddenCaseColor(this.getCaseColorForOptionValue(caseColorValue));
    }

    getVariantOptionControl(optionName) {
      const expected = this.normalizeVariantOptionName(optionName);
      if (!expected) return null;

      return Array.from(this.root.querySelectorAll('[data-patch-variant-option]'))
        .find((control) => this.normalizeVariantOptionName(control.dataset.patchVariantOption) === expected) || null;
    }

    hasVariantOption(optionName) {
      return Boolean(this.getVariantOptionControl(optionName));
    }

    getCustomizationVariantOptionName() {
      return CUSTOMIZATION_OPTION_NAMES.find((optionName) => this.hasVariantOption(optionName)) || '';
    }

    hasCustomizationVariantOption() {
      return Boolean(this.getCustomizationVariantOptionName());
    }

    getSelectedCustomizationVariantOptionValue() {
      const optionName = this.getCustomizationVariantOptionName();
      return optionName ? this.getSelectedVariantOptionValue(optionName) : '';
    }

    selectCustomizationVariantOption(optionValue, options = {}) {
      const optionName = this.getCustomizationVariantOptionName();
      return optionName ? this.selectVariantOption(optionName, optionValue, options) : false;
    }

    getVariantOptionValues(optionName) {
      const control = this.getVariantOptionControl(optionName);
      if (!control) return [];

      const values = [];
      control.querySelectorAll('input[type="radio"], option').forEach((input) => {
        const value = String(input.value || '').trim();
        if (value && !values.some((existing) => this.normalizeVariantOptionName(existing) === this.normalizeVariantOptionName(value))) {
          values.push(value);
        }
      });

      return values;
    }

    getSelectedVariantOptionValue(optionName) {
      const control = this.getVariantOptionControl(optionName);
      if (!control) return '';

      const select = control.querySelector('select');
      if (select) {
        const selectedOption = select.options[select.selectedIndex] || null;
        return selectedOption ? String(selectedOption.value || selectedOption.textContent || '').trim() : String(select.value || '').trim();
      }

      const selectedInput = control.querySelector('input[type="radio"]:checked');
      if (selectedInput) return String(selectedInput.value || '').trim();

      return '';
    }

    selectVariantOption(optionName, optionValue, options = {}) {
      const control = this.getVariantOptionControl(optionName);
      const expected = this.normalizeVariantOptionName(optionValue);
      if (!control || !expected) return false;
      const notifyDawn = options.notifyDawn !== false && !this.isContourTemplate();
      const syncVariant = options.syncVariant !== false;

      const select = control.querySelector('select');
      if (select) {
        const option = Array.from(select.options).find((item) => this.normalizeVariantOptionName(item.value) === expected);
        if (!option) return false;
        if (select.value !== option.value) {
          select.value = option.value;
          if (notifyDawn) {
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        this.updateVariantOptionLabel(control, option.value || option.textContent || optionValue);
        if (syncVariant) this.syncSelectedVariantFromControls();
        return true;
      }

      const input = Array.from(control.querySelectorAll('input[type="radio"]'))
        .find((item) => this.normalizeVariantOptionName(item.value) === expected);
      if (!input) return false;
      if (!input.checked) {
        input.checked = true;
        if (notifyDawn) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      this.updateVariantOptionLabel(control, input.value || optionValue);
      if (syncVariant) this.syncSelectedVariantFromControls();
      return true;
    }

    updateVariantOptionLabel(control, value) {
      const label = control && control.querySelector('[data-selected-value]');
      if (label) label.textContent = String(value || '').trim();
    }

    getSelectedVariantOptionsFromControls() {
      return Array.from(this.root.querySelectorAll('[data-patch-variant-option]'))
        .map((control) => {
          const select = control.querySelector('select');
          if (select) {
            const selectedOption = select.options[select.selectedIndex] || null;
            return selectedOption ? String(selectedOption.value || selectedOption.textContent || '').trim() : String(select.value || '').trim();
          }

          const selectedInput = control.querySelector('input[type="radio"]:checked');
          return selectedInput ? String(selectedInput.value || '').trim() : '';
        })
        .filter(Boolean);
    }

    getVariantFromSelectedControls() {
      const variants = Array.isArray(this.config.variants) ? this.config.variants : [];
      const selectedOptions = this.getSelectedVariantOptionsFromControls();
      if (!variants.length || !selectedOptions.length) return null;

      return variants.find((variant) => {
        const options = Array.isArray(variant.options)
          ? variant.options
          : [variant.option1, variant.option2, variant.option3].filter(Boolean);
        return selectedOptions.every((option, index) => (
          this.normalizeVariantOptionName(options[index]) === this.normalizeVariantOptionName(option)
        ));
      }) || null;
    }

    getConfiguredVariant() {
      const variants = Array.isArray(this.config.variants) ? this.config.variants : [];
      const variantId = String(this.config.variant_id || '');
      if (!variants.length || !variantId) return null;

      return variants.find((variant) => String(variant.id) === variantId) || null;
    }

    syncSelectedVariantFromControls() {
      const variant = this.getVariantFromSelectedControls();
      if (!variant) {
        this.handleProductVariantChange(null);
        return;
      }

      this.handleProductVariantChange(variant);
    }

    getCaseColorForOptionValue(optionValue) {
      const normalized = this.normalizeVariantOptionName(optionValue);
      const configMatch = (Array.isArray(this.config.case_colors) ? this.config.case_colors : [])
        .find((color) => this.normalizeVariantOptionName(color.label) === normalized || this.normalizeVariantOptionName(color.id) === normalized);

      if (configMatch) {
        return {
          ...configMatch,
          optionValue
        };
      }

      const colorMap = {
        black: { id: 'black', label: 'Classic Black', reference: 'Original black', hex: '#2C2C2C', outer_hex: '#2C2C2C', shade_mid_hex: '#525252', shade_dark_hex: '#2C2C2C' },
        'figma black': { id: 'black', label: 'Classic Black', reference: 'Original black', hex: '#2C2C2C', outer_hex: '#2C2C2C', shade_mid_hex: '#525252', shade_dark_hex: '#2C2C2C' },
        'olive green': { id: 'pantone-2410-c', label: 'Olive Green', reference: 'Pantone 2410 C', hex: '#445A3E' },
        green: { id: 'pantone-2410-c', label: 'Olive Green', reference: 'Pantone 2410 C', hex: '#445A3E' },
        pink: { id: 'pantone-2051-c', label: 'Mauve Haze', reference: 'Pantone 2051 C', hex: '#DDC2CF' },
        blue: { id: 'pantone-7527-c', label: 'Retro White', reference: 'Pantone 7527 C', hex: '#D6D2C4' },
        grey: { id: 'pantone-7527-c', label: 'Retro White', reference: 'Pantone 7527 C', hex: '#D6D2C4' },
        gray: { id: 'pantone-7527-c', label: 'Retro White', reference: 'Pantone 7527 C', hex: '#D6D2C4' }
      };
      const mapped = colorMap[normalized];

      if (mapped) {
        return {
          ...mapped,
          optionValue
        };
      }

      return {
        id: normalized.replace(/[^a-z0-9]+/g, '-') || 'case-color',
        label: optionValue,
        hex: '#d6d2c4',
        optionValue
      };
    }

    getCaseColors() {
      const colors = Array.isArray(this.config.case_colors) ? this.config.case_colors : [];
      const optionValues = this.getVisibleCaseOptionValues();
      if (colors.length) {
        const visibleColors = this.getVisibleCaseColors(colors);
        if (!optionValues.length) return visibleColors;
        const optionColorsById = new Map(optionValues.map((value) => {
          const color = this.getCaseColorForOptionValue(value);
          return [color.id, color];
        }));
        return visibleColors.map((color) => ({
          ...color,
          optionValue: color.optionValue || (optionColorsById.get(color.id) && optionColorsById.get(color.id).optionValue) || ''
        }));
      }

      if (optionValues.length) {
        return optionValues.map((value) => this.getCaseColorForOptionValue(value));
      }

      return this.getVisibleCaseColors([
        { id: 'black', label: 'Classic Black', reference: 'Original black', hex: '#2c2c2c', outer_hex: '#2c2c2c', shade_mid_hex: '#525252', shade_dark_hex: '#2c2c2c' },
        { id: 'pantone-2051-c', label: 'Mauve Haze', reference: 'Pantone 2051 C', hex: '#ddc2cf' },
        { id: 'pantone-7527-c', label: 'Retro White', reference: 'Pantone 7527 C', hex: '#d6d2c4' },
        { id: 'pantone-2410-c', label: 'Olive Green', reference: 'Pantone 2410 C', hex: '#445a3e' },
        { id: 'pantone-2265-c', label: 'Very Green', reference: 'Pantone 2265 C', hex: '#5c7e51' }
      ]);
    }

    selectVisibleCaseColorFallback(options = {}) {
      const fallbackColor = this.getCaseColors()[0];
      if (!fallbackColor) return false;

      this.caseColorId = fallbackColor.id;
      if (!fallbackColor.optionValue) return true;

      return this.selectVariantOption('Case Color', fallbackColor.optionValue, {
        notifyDawn: false,
        syncVariant: options.syncVariant !== false
      });
    }

    getButtonColors() {
      const colors = Array.isArray(this.config.button_colors) ? this.config.button_colors : [];
      if (colors.length) return colors;

      return [
        { id: 'black', label: 'Black', hex: '#2C2C2C' },
        { id: 'champagne-gold', label: 'Champagne Gold', hex: '#d9c39a' },
        { id: 'silver', label: 'Silver', hex: '#c9cdd2' },
        { id: 'taro-purple', label: 'Taro Purple', hex: '#c9b5da' },
        { id: 'pink', label: 'Pink', hex: '#ba8e96' },
        { id: 'mint-green', label: 'Mint Green', hex: '#b8e6d1' },
        { id: 'orange', label: 'Orange', hex: '#f47a2a' },
        { id: 'deep-blue', label: 'Deep Blue', hex: '#173b8f' },
        { id: 'green', label: 'Green', hex: '#3e8b49' },
        { id: 'red', label: 'Red', hex: '#d71920' }
      ];
    }

    getPatchColors() {
      const colors = Array.isArray(this.config.patch_colors) ? this.config.patch_colors : [];
      if (colors.length) return colors;

      return this.getButtonColors();
    }

    getHardwareColor(collection, colorId) {
      const colors = collection === 'case'
        ? this.getCaseColors()
        : (collection === 'patch' ? this.getPatchColors() : this.getButtonColors());
      return colors.find((color) => color.id === colorId) || colors[0];
    }

    getActiveCaseColor() {
      return this.getHardwareColor('case', this.caseColorId);
    }

    getActiveButtonColor() {
      return this.getHardwareColor('button', this.buttonColorId);
    }

    getActivePatchColor() {
      return this.getHardwareColor('patch', this.patchColorId || this.buttonColorId);
    }

    getHardwareColorPayload(color) {
      if (!color) return null;

      return {
        id: color.id,
        label: color.label,
        reference: color.reference || '',
        hex: color.hex,
        outer_hex: color.outer_hex || '',
        shade_mid_hex: color.shade_mid_hex || '',
        shade_dark_hex: color.shade_dark_hex || ''
      };
    }

    formatHardwareColorProperty(color) {
      if (!color) return '';
      return color.label || color.id || '';
    }

    getReadableColorForBackground(color) {
      const rgb = this.parseHexColor(color);
      if (!rgb) return '#ffffff';
      const brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
      return brightness > 156 ? '#151515' : '#ffffff';
    }

    syncVariantOptionState() {
      const caseColorValue = this.getSelectedVariantOptionValue('Case Color');
      if (caseColorValue) {
        const caseColor = this.getCaseColorForOptionValue(caseColorValue);
        if (this.isHiddenCaseColor(caseColor)) {
          this.selectVisibleCaseColorFallback({ syncVariant: false });
        } else {
          this.caseColorId = caseColor.id;
        }
      }

      const patchColorValue = this.getSelectedVariantOptionValue('Patch Color');
      if (patchColorValue) {
        const patchColors = this.isPureColorTemplate() ? this.getPatchColors() : this.getButtonColors();
        const patchColor = patchColors.find((color) => (
          this.normalizeVariantOptionName(color.label) === this.normalizeVariantOptionName(patchColorValue) ||
          this.normalizeVariantOptionName(color.id) === this.normalizeVariantOptionName(patchColorValue)
        ));
        if (patchColor) {
          if (this.isPureColorTemplate()) {
            this.patchColorId = patchColor.id;
          } else {
            this.buttonColorId = patchColor.id;
          }
        }
      }

      const customizationValue = this.getSelectedCustomizationVariantOptionValue();
      if (customizationValue) {
        this.customizationMode = customizationValue;
      }
    }

    getCustomizationMode() {
      const value = this.getSelectedCustomizationVariantOptionValue() || this.customizationMode || 'Custom';
      return this.normalizeVariantOptionName(value) === 'standard' ? 'Standard' : 'Custom';
    }

    isStandardCustomizationMode() {
      return this.getCustomizationMode() === 'Standard';
    }

    getCurrentStandardPreviewPhotoSet() {
      if (!this.isStandardCustomizationMode()) return [];

      const matchingComboId = this.getMatchingStandardComboId();
      const standardId = matchingComboId || this.standardComboId || this.getDefaultStandardComboId();
      const photos = this.config && this.config.standard_preview_photos;
      const photoValue = photos && typeof photos === 'object' && standardId ? photos[standardId] : null;
      return this.normalizeStandardPreviewPhotoSet(photoValue);
    }

    normalizeStandardPreviewPhotoSet(photoValue) {
      if (!photoValue) return [];

      const values = Array.isArray(photoValue) ? photoValue : [photoValue];
      return values.map((item, index) => {
        const fallbackLabel = STANDARD_PREVIEW_PHOTO_FALLBACK_LABELS[index] || `Photo ${index + 1}`;

        if (typeof item === 'string') {
          const url = this.normalizeAssetUrl(item);
          return url
            ? {
              id: index === 0 ? 'back' : `photo-${index + 1}`,
              label: fallbackLabel,
              url
            }
            : null;
        }

        if (!item || typeof item !== 'object') return null;

        const url = this.normalizeAssetUrl(String(item.url || item.src || item.assetUrl || item.image || ''));
        if (!url) return null;

        return {
          id: String(item.id || `photo-${index + 1}`),
          label: String(item.label || fallbackLabel),
          url
        };
      }).filter(Boolean);
    }

    getCurrentStandardPreviewPhoto(photoSet = this.getCurrentStandardPreviewPhotoSet()) {
      if (!this.isStandardCustomizationMode()) return null;

      if (photoSet.length) {
        const maxIndex = photoSet.length - 1;
        const index = Math.min(Math.max(Number(this.standardPreviewPhotoIndex) || 0, 0), maxIndex);
        this.standardPreviewPhotoIndex = index;
        return {
          isPlaceholder: false,
          index,
          photos: photoSet,
          ...photoSet[index]
        };
      }

      const placeholderUrl = this.config && this.config.standard_preview_placeholder_photo
        ? this.normalizeAssetUrl(this.config.standard_preview_placeholder_photo)
        : '';
      return placeholderUrl
        ? {
          isPlaceholder: true,
          index: 0,
          photos: [],
          url: placeholderUrl
        }
        : null;
    }

    setStandardPreviewPhotoIndex(index) {
      const numericIndex = Number(index);
      if (!Number.isFinite(numericIndex)) return;

      this.standardPreviewPhotoIndex = Math.max(0, Math.floor(numericIndex));
      this.syncStandardPreviewUi();
    }

    setStandardPreviewView(view) {
      const normalized = view === 'photo' ? 'photo' : 'effect';
      if (normalized === 'photo' && !this.getCurrentStandardPreviewPhoto()) return;

      const canRestoreScroll = typeof window !== 'undefined' && typeof window.scrollTo === 'function';
      const scrollX = canRestoreScroll ? window.scrollX : 0;
      const scrollY = canRestoreScroll ? window.scrollY : 0;
      this.standardPreviewView = normalized;
      this.syncStandardPreviewUi();
      if (canRestoreScroll) {
        window.scrollTo(scrollX, scrollY);
        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
        }
      }
    }

    syncStandardPreviewUi() {
      const photoSet = this.getCurrentStandardPreviewPhotoSet();
      const photoSetKey = photoSet.map((photo) => photo.url).join('|');
      if (photoSetKey !== this.standardPreviewPhotoSetKey) {
        this.standardPreviewPhotoSetKey = photoSetKey;
        this.standardPreviewPhotoIndex = 0;
      }

      const previewPhoto = this.getCurrentStandardPreviewPhoto(photoSet);
      const canShowPhoto = Boolean(previewPhoto && previewPhoto.url);

      if (!canShowPhoto) {
        this.standardPreviewView = 'effect';
      }

      const isPhotoView = canShowPhoto && this.standardPreviewView === 'photo';
      this.root.dataset.standardPreviewMode = isPhotoView ? 'photo' : 'effect';

      if (this.nodes.standardPreviewTabs) {
        this.nodes.standardPreviewTabs.hidden = !canShowPhoto;
        this.nodes.standardPreviewTabs.setAttribute('aria-hidden', canShowPhoto ? 'false' : 'true');
      }

      if (this.nodes.standardPreviewNote) {
        this.nodes.standardPreviewNote.hidden = !canShowPhoto;
        this.nodes.standardPreviewNote.setAttribute('aria-hidden', canShowPhoto ? 'false' : 'true');
        this.nodes.standardPreviewNote.innerHTML = isPhotoView
          ? (previewPhoto && previewPhoto.isPlaceholder
            ? this.getStandardPreviewNote('placeholder')
            : this.getStandardPreviewNote('photo'))
          : this.getStandardPreviewNote('effect');
      }

      this.nodes.standardPreviewViewButtons.forEach((button) => {
        const isActive = button.dataset.standardPreviewView === (isPhotoView ? 'photo' : 'effect');
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (this.nodes.standardPhotoImage) {
        if (canShowPhoto && this.nodes.standardPhotoImage.getAttribute('src') !== previewPhoto.url) {
          this.nodes.standardPhotoImage.src = previewPhoto.url;
        } else if (!canShowPhoto) {
          this.nodes.standardPhotoImage.removeAttribute('src');
        }
      }

      if (this.nodes.standardPhotoPreview) {
        this.nodes.standardPhotoPreview.hidden = !isPhotoView;
        this.nodes.standardPhotoPreview.setAttribute('aria-hidden', isPhotoView ? 'false' : 'true');
        this.nodes.standardPhotoPreview.dataset.standardPhotoPlaceholder = previewPhoto && previewPhoto.isPlaceholder ? 'true' : 'false';
      }

      this.renderStandardPreviewPhotoThumbnails(photoSet, isPhotoView && !previewPhoto.isPlaceholder);
    }

    renderStandardPreviewPhotoThumbnails(photoSet, shouldShow) {
      if (!this.nodes.standardPhotoThumbnails || !this.nodes.standardPhotoThumbnailList) return;

      const photos = Array.isArray(photoSet) ? photoSet : [];
      const canShow = Boolean(shouldShow && photos.length > 1);
      this.nodes.standardPhotoThumbnails.hidden = !canShow;
      this.nodes.standardPhotoThumbnails.setAttribute('aria-hidden', canShow ? 'false' : 'true');

      if (!canShow) {
        this.nodes.standardPhotoThumbnailList.replaceChildren();
        return;
      }

      this.nodes.standardPhotoThumbnailList.style.setProperty('--standard-photo-thumbnail-count', String(photos.length));
      this.nodes.standardPhotoThumbnailList.replaceChildren();

      photos.forEach((photo, index) => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        const image = document.createElement('img');
        const angleLabel = document.createElement('span');
        const isActive = index === this.standardPreviewPhotoIndex;
        const label = photo.label || STANDARD_PREVIEW_PHOTO_FALLBACK_LABELS[index] || `Photo ${index + 1}`;

        item.className = 'smallsmore-standard-photo-thumbnail-item';
        item.classList.toggle('is-active', isActive);
        button.className = 'smallsmore-standard-photo-thumbnail';
        button.type = 'button';
        button.dataset.standardPhotoThumbnail = String(index);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-label', `Show ${label} real photo`);
        if (isActive) button.setAttribute('aria-current', 'true');

        image.src = photo.url;
        image.alt = `${label} thumbnail`;
        image.width = 416;
        image.height = 416;
        image.loading = 'lazy';

        angleLabel.className = 'smallsmore-standard-photo-thumbnail-angle';
        angleLabel.textContent = label;
        angleLabel.setAttribute('aria-hidden', 'true');

        button.append(image);
        button.addEventListener('click', () => this.setStandardPreviewPhotoIndex(index));
        item.append(button);
        item.append(angleLabel);
        this.nodes.standardPhotoThumbnailList.append(item);
      });
    }

    getStandardPreviewNote(type) {
      if (type === 'photo') {
        return (this.config && this.config.standard_preview_photo_note) ||
          (this.nodes.standardPreviewNote && this.nodes.standardPreviewNote.dataset.standardPreviewPhotoNote) ||
          'Real photo shows the actual case.<br>Use Design preview for button color.';
      }

      if (type === 'placeholder') {
        return (this.config && this.config.standard_preview_placeholder_note) ||
          (this.nodes.standardPreviewNote && this.nodes.standardPreviewNote.dataset.standardPreviewPlaceholderNote) ||
          'Real photo is coming soon for this option.<br>Use Design preview for the selected look.';
      }

      return (this.config && this.config.standard_preview_effect_note) ||
        (this.nodes.standardPreviewNote && this.nodes.standardPreviewNote.dataset.standardPreviewEffectNote) ||
        'Design preview shows pattern placement<br>and selected button color.';
    }

    normalizeAssetUrl(src) {
      if (!src || typeof src !== 'string') return src;
      if (src.startsWith('//')) return `https:${src}`;
      return src;
    }

    getStandardTerrainLocation(terrainId = this.standardTerrainId) {
      if (terrainId === RANDOM_TERRAIN_PATTERN_ID) return null;
      return CURATED_TERRAIN_LOCATIONS.find((location) => location.id === terrainId) || CURATED_TERRAIN_LOCATIONS.find((location) => location.id === 'curated:el-capitan-yosemite') || null;
    }

    getTerrainChoiceLabel() {
      if (this.isRandomPatternTerrain()) return RANDOM_TERRAIN_PATTERN_LABEL;

      if (this.isStandardCustomizationMode()) {
        const location = this.getStandardTerrainLocation();
        return location ? location.name : '';
      }

      return this.getRegionText();
    }

    clearTerrainSelection(options = {}) {
      this.selectedTerrainLocation = null;
      this.terrainData = null;
      this.terrainDataRegion = '';
      this.terrainPromise = null;
      this.terrainSuggestions = [];
      if (options.clearRegion && this.nodes.region) this.nodes.region.value = '';
      this.renderTerrainSuggestions();
      this.clearTerrainContourCache();
      this.clearTerrainAnnotationOverride();
      this.resetTerrainMapOffset({ silent: true });
      this.clearPreviewOverlay();
      this.updateSuggestionStatus('');
      this.updateTerrainControls();
      this.updateTerrainQuickPicks();
    }

    syncCustomizationFallbackVisibility() {
      if (!this.nodes.customizationFallback) return;
      this.nodes.customizationFallback.hidden = !this.isContourTemplate() && this.hasCustomizationVariantOption();
    }

    syncCustomizationModeUi(options = {}) {
      this.syncVariantOptionState();
      this.syncCustomizationFallbackVisibility();

      const isStandard = this.isStandardCustomizationMode();
      if (this.nodes.historyTools) {
        this.nodes.historyTools.hidden = isStandard;
        this.nodes.historyTools.setAttribute('aria-hidden', isStandard ? 'true' : 'false');
      }
      if (this.nodes.guideOpenButton && !this.isContourTemplate()) {
        this.nodes.guideOpenButton.hidden = isStandard || Boolean(this.previewControlDefaults.guideOpenHidden);
        this.nodes.guideOpenButton.disabled = isStandard || Boolean(this.previewControlDefaults.guideOpenDisabled);
      }
      if (isStandard) this.closeGuideDialog({ restoreFocus: false });
      if (this.nodes.customContent) {
        this.nodes.customContent.forEach((node) => {
          node.hidden = isStandard;
          node.setAttribute('aria-hidden', isStandard ? 'true' : 'false');
        });
      }
      if (this.nodes.customPanel) this.nodes.customPanel.hidden = isStandard;
      if (this.nodes.standardPanel) this.nodes.standardPanel.hidden = !isStandard;
      this.root.dataset.patchModeState = isStandard ? 'standard' : 'custom';
      this.syncTerrainInitialPreviewState();

      this.nodes.customizationModeButtons.forEach((button) => {
        const isActive = this.normalizeVariantOptionName(button.dataset.patchCustomizationMode) === this.normalizeVariantOptionName(this.getCustomizationMode());
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (isStandard && options.loadStandardTerrain && this.isContourTemplate()) {
        this.ensureStandardRandomPattern({ render: false, silent: true });
      }
      if (!isStandard) this.syncStandardInitialTerrainPalette();
      this.updateStandardComboButtons();
      this.updateStandardTerrainButtons();
      this.syncStandardPreviewUi();
      this.updatePatchSteps();
      if (this.isContourTemplate()) this.updateTerrainControls();
    }

    captureCustomModeSnapshot() {
      if (this.getCustomizationMode() !== 'Custom') return;
      this.customModeSnapshot = this.captureHistorySnapshot();
    }

    restoreCustomModeSnapshot() {
      if (!this.customModeSnapshot) return false;

      this.restoreHistorySnapshot({
        ...this.customModeSnapshot,
        customizationMode: 'Custom'
      });
      return true;
    }

    setCustomizationMode(mode, options = {}) {
      const previousMode = this.getCustomizationMode();
      const normalized = this.normalizeVariantOptionName(mode) === 'standard' ? 'Standard' : 'Custom';
      if (previousMode === 'Custom' && normalized === 'Standard') {
        this.captureCustomModeSnapshot();
      }

      if (this.hasCustomizationVariantOption()) {
        this.selectCustomizationVariantOption(normalized, {
          notifyDawn: false,
          syncVariant: options.syncVariant !== false
        });
      }

      this.customizationMode = normalized;
      if (normalized === 'Custom') {
        if (
          previousMode === 'Standard' &&
          options.restoreCustomSnapshot !== false &&
          this.restoreCustomModeSnapshot()
        ) {
          return;
        }

        this.standardTerrainId = '';
        if (previousMode !== 'Custom') this.clearTerrainSelection({ clearRegion: true });
      }
      this.syncCustomizationModeUi({ loadStandardTerrain: normalized === 'Standard' && options.loadStandardTerrain !== false });
      if (options.render !== false) this.render();
    }

    handleCustomizationModeClick(mode) {
      const normalized = this.normalizeVariantOptionName(mode) === 'standard' ? 'Standard' : 'Custom';
      if (normalized === 'Standard') {
        this.applyStandardComboFromCurrentColors();
        return;
      }

      this.setCustomizationMode(normalized, {
        loadStandardTerrain: false,
        restoreCustomSnapshot: false
      });
      this.updateStandardComboButtons();
    }

    preserveWindowScrollDuring(callback) {
      const canRestoreScroll = typeof window !== 'undefined' && typeof window.scrollTo === 'function';
      const scrollX = canRestoreScroll ? window.scrollX : 0;
      const scrollY = canRestoreScroll ? window.scrollY : 0;
      const result = callback();

      if (!canRestoreScroll) return result;

      const restore = () => window.scrollTo(scrollX, scrollY);
      restore();
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => {
          restore();
          window.requestAnimationFrame(restore);
        });
      } else {
        window.setTimeout(restore, 0);
      }
      window.setTimeout(restore, 60);
      window.setTimeout(restore, 180);

      return result;
    }

    getStandardCombos() {
      if (Array.isArray(this.config.standard_combos) && this.config.standard_combos.length) {
        return this.config.standard_combos.reduce((combos, combo) => {
          if (combo && combo.id) combos[combo.id] = combo;
          return combos;
        }, {});
      }

      if (this.config.standard_combos && typeof this.config.standard_combos === 'object') {
        return this.config.standard_combos;
      }

      return STANDARD_COLOR_COMBOS;
    }

    getDefaultStandardComboId() {
      return Object.keys(this.getStandardCombos())[0] || 'black-blue';
    }

    getStandardCombo(comboId = this.standardComboId) {
      const combos = this.getStandardCombos();
      const fallbackId = this.getDefaultStandardComboId();
      const id = combos[comboId] ? comboId : fallbackId;

      return {
        id,
        ...combos[id]
      };
    }

    getStandardComboPatchColorId(combo) {
      if (!combo) return '';
      return combo.patchColorId || combo.patch_color_id || combo.patchColor || '';
    }

    getStandardComboPatchLabel(combo) {
      if (!combo) return '';
      return combo.patchLabel || combo.patch_color_label || combo.patchColorLabel || '';
    }

    getCaseColorForStandardCombo(combo) {
      const normalizedLabel = this.normalizeVariantOptionName(combo && combo.caseLabel);
      return this.getCaseColors().find((color) => (
        color.id === combo.caseColorId ||
        this.normalizeVariantOptionName(color.label) === normalizedLabel ||
        this.normalizeVariantOptionName(color.optionValue) === normalizedLabel
      )) || this.getCaseColors()[0] || null;
    }

    getStandardCaseColorId(caseColorId) {
      const standardCombos = Object.values(this.getStandardCombos());
      if (standardCombos.some((combo) => combo.caseColorId === caseColorId)) return caseColorId;

      const caseColor = this.getHardwareColor('case', caseColorId);
      const normalizedLabel = this.normalizeVariantOptionName(caseColor && caseColor.label);
      if (caseColorId === 'pantone-2265-c' || normalizedLabel === 'very green') return 'pantone-2410-c';

      return caseColorId;
    }

    getStandardComboIdForCasePatch(caseColorId, patchColorId) {
      const matchingCaseCombos = Object.entries(this.getStandardCombos())
        .filter(([, combo]) => combo.caseColorId === caseColorId);
      if (!matchingCaseCombos.length) return '';

      const exactCombo = patchColorId
        ? matchingCaseCombos.find(([, combo]) => {
          const comboPatchColorId = this.getStandardComboPatchColorId(combo);
          return comboPatchColorId
            ? comboPatchColorId === patchColorId
            : combo.buttonColorId === patchColorId;
        })
        : null;
      return (exactCombo || matchingCaseCombos[0])[0];
    }

    getStandardComboIdForCurrentColors() {
      const activeCaseId = (this.getActiveCaseColor() && this.getActiveCaseColor().id) || this.caseColorId;
      const activePatchId = (this.getActivePatchColor() && this.getActivePatchColor().id) || this.patchColorId;
      const standardCaseId = this.getStandardCaseColorId(activeCaseId);
      const standardPatchId = this.isPureColorTemplate() ? activePatchId : '';

      return this.getStandardComboIdForCasePatch(standardCaseId, standardPatchId) ||
        this.standardComboId ||
        this.getDefaultStandardComboId();
    }

    shouldUseStandardInitialTerrainPattern() {
      return Boolean(
        this.isContourTemplate() &&
        !this.isStandardCustomizationMode() &&
        !this.selectedTerrainLocation &&
        !this.hasTerrainForCurrentSelection() &&
        !this.hasPendingTerrainInput()
      );
    }

    syncTerrainInitialPreviewState() {
      if (!this.root) return false;

      if (this.shouldUseStandardInitialTerrainPattern()) {
        this.root.dataset.terrainInitialPreview = 'standard';
        return true;
      }

      delete this.root.dataset.terrainInitialPreview;
      return false;
    }

    syncStandardInitialTerrainPalette() {
      if (!this.shouldUseStandardInitialTerrainPattern()) return false;

      const combo = this.getStandardCombo(this.getStandardComboIdForCurrentColors());
      this.standardComboId = combo.id;
      if (!combo.paletteId || (this.activePalette && this.activePalette.id === combo.paletteId)) return false;

      this.applyPalette(combo.paletteId, { render: false });
      return true;
    }

    getStandardRandomPatternTerrainData() {
      const seed = this.hashString(STANDARD_RANDOM_PATTERN_SEED);
      this.standardRandomTerrainData = this.standardRandomTerrainData || this.createRandomPatternTerrainData(seed);
      return this.standardRandomTerrainData;
    }

    getDrawableTerrainData() {
      if (this.terrainData) return this.terrainData;
      if (this.shouldUseStandardInitialTerrainPattern()) return this.getStandardRandomPatternTerrainData();
      return null;
    }

    getDrawableTerrainMapOffset() {
      if (this.shouldUseStandardInitialTerrainPattern()) return { x: 0, y: 0 };
      return this.getTerrainMapOffset();
    }

    applyStandardComboFromCurrentColors() {
      const comboId = this.getStandardComboIdForCurrentColors();
      this.setCustomizationMode('Standard', {
        loadStandardTerrain: false,
        syncVariant: false,
        render: false
      });
      this.applyStandardCombo(comboId, {
        preserveMode: true,
        preserveButtonColor: !this.isPureColorTemplate()
      });
    }

    getMatchingStandardComboId() {
      const activePaletteId = this.activePalette && this.activePalette.id;
      const activeCaseId = this.getActiveCaseColor() && this.getActiveCaseColor().id;
      const activeAccentColor = this.getActiveButtonColor() && this.getActiveButtonColor().id;
      const activePatchColor = this.getActivePatchColor() && this.getActivePatchColor().id;

      return Object.entries(this.getStandardCombos())
        .find(([, combo]) => {
          const comboPatchColorId = this.getStandardComboPatchColorId(combo);
          const matchesPatchColor = !this.isPureColorTemplate() || !comboPatchColorId || comboPatchColorId === activePatchColor;
          const matchesButtonColor = this.isPureColorTemplate() || !combo.buttonColorId || combo.buttonColorId === activeAccentColor;

          return combo.caseColorId === activeCaseId &&
            matchesPatchColor &&
            matchesButtonColor &&
            (!combo.paletteId || combo.paletteId === activePaletteId);
        })?.[0] || '';
    }

    updateStandardComboButtons() {
      const isStandard = this.isStandardCustomizationMode();
      const matchingComboId = isStandard ? this.getMatchingStandardComboId() : '';
      if (matchingComboId) this.standardComboId = matchingComboId;
      const activeComboId = matchingComboId || this.standardComboId;

      this.nodes.standardComboButtons.forEach((button) => {
        const isActive = isStandard && button.dataset.patchStandardCombo === activeComboId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      this.updateStandardCaseColorCareNotice(activeComboId, isStandard);
    }

    updateStandardCaseColorCareNotice(comboId = this.standardComboId, isStandard = this.isStandardCustomizationMode()) {
      if (!this.nodes.standardCaseColorCareNotice) return;

      const combo = this.getStandardCombo(comboId);
      const shouldShow = isStandard && CASE_COLOR_CARE_NOTICE_COLOR_IDS.has(combo.caseColorId);
      this.nodes.standardCaseColorCareNotice.hidden = !shouldShow;
      this.nodes.standardCaseColorCareNotice.classList.toggle('is-visible', shouldShow);
    }

    applyStandardCombo(comboId = this.standardComboId, options = {}) {
      const previousComboId = this.standardComboId;
      const combo = this.getStandardCombo(comboId);
      this.standardComboId = combo.id;
      if (combo.id !== previousComboId) {
        this.standardPreviewPhotoIndex = 0;
      }
      const syncVariant = options.syncVariant !== false;
      const preserveButtonColor = options.preserveButtonColor === true && !this.isPureColorTemplate();
      const previousButtonColorId = this.buttonColorId;

      if (!options.preserveMode && !this.isStandardCustomizationMode()) {
        this.setCustomizationMode('Standard', {
          loadStandardTerrain: false,
          syncVariant: false,
          render: false
        });
      }

      const caseColor = this.getCaseColorForStandardCombo(combo);
      if (caseColor) {
        this.caseColorId = caseColor.id;
        this.selectVariantOption('Case Color', caseColor.optionValue || combo.caseLabel, {
          notifyDawn: false,
          syncVariant: false
        });
      }

      const comboPatchColorId = this.getStandardComboPatchColorId(combo);
      const comboPatchLabel = this.getStandardComboPatchLabel(combo);
      const patchColor = comboPatchColorId || comboPatchLabel
        ? this.getPatchColors().find((color) => (
          color.id === comboPatchColorId ||
          this.normalizeVariantOptionName(color.label) === this.normalizeVariantOptionName(comboPatchLabel)
        ))
        : null;
      if (patchColor) {
        this.patchColorId = patchColor.id;
        this.selectVariantOption('Patch Color', patchColor.label || comboPatchLabel, {
          notifyDawn: false,
          syncVariant: false
        });
      }

      const buttonColor = this.getButtonColors().find((color) => (
        color.id === combo.buttonColorId ||
        this.normalizeVariantOptionName(color.label) === this.normalizeVariantOptionName(combo.buttonLabel)
      ));
      if (buttonColor && !preserveButtonColor) {
        this.buttonColorId = buttonColor.id;
        if (!patchColor && this.hasVariantOption('Patch Color')) {
          this.selectVariantOption('Patch Color', buttonColor.label || combo.buttonLabel, {
            notifyDawn: false,
            syncVariant: false
          });
        }
      }
      if (comboPatchColorId && !patchColor && this.hasVariantOption('Patch Color')) {
        this.selectVariantOption('Patch Color', comboPatchLabel || comboPatchColorId, {
          notifyDawn: false,
          syncVariant: false
        });
      }
      if (preserveButtonColor && previousButtonColorId) this.buttonColorId = previousButtonColorId;

      if (syncVariant) this.syncSelectedVariantFromControls();
      this.applyPalette(combo.paletteId || (this.activePalette && this.activePalette.id) || (this.getPalettes()[0] && this.getPalettes()[0].id));
      if (this.isContourTemplate()) {
        this.ensureStandardRandomPattern({ silent: true });
      }
      this.updateHardwareColorButtons();
      this.updatePaletteButtons();
      this.updateStandardComboButtons();
      this.syncStandardPreviewUi();
      this.updatePatchSteps();
      this.render();
    }

    handleStandardTerrainClick(terrainId) {
      if (this.isStandardCustomizationMode()) {
        this.setCustomizationMode('Custom', {
          loadStandardTerrain: false,
          restoreCustomSnapshot: false
        });
      }
      return this.selectStandardTerrain(terrainId, { autoLoad: true });
    }

    handleRandomTerrainClick() {
      if (this.isStandardCustomizationMode()) {
        this.setCustomizationMode('Custom', {
          loadStandardTerrain: false,
          restoreCustomSnapshot: false
        });
      }
      return this.selectRandomTerrainPattern();
    }

    updateStandardTerrainButtons() {
      this.nodes.standardTerrainButtons.forEach((button) => {
        const isActive = !this.isStandardCustomizationMode() && button.dataset.patchStandardTerrain === this.standardTerrainId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      this.nodes.randomTerrainButtons.forEach((button) => {
        const isActive = !this.isStandardCustomizationMode() && this.standardTerrainId === RANDOM_TERRAIN_PATTERN_ID;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    isRandomPatternTerrain() {
      if (this.terrainData) {
        return this.terrainData.source === 'smallsmore-random-pattern';
      }

      if (this.selectedTerrainLocation) return false;

      return this.standardTerrainId === RANDOM_TERRAIN_PATTERN_ID;
    }

    ensureStandardRandomPattern(options = {}) {
      const selectionKey = RANDOM_TERRAIN_PATTERN_LABEL.toLowerCase();
      const hasCurrentStandardPattern = this.terrainData && this.terrainData === this.standardRandomTerrainData && this.terrainDataRegion === selectionKey;

      if (!hasCurrentStandardPattern) {
        this.standardRandomTerrainData = this.getStandardRandomPatternTerrainData();
        this.standardTerrainId = RANDOM_TERRAIN_PATTERN_ID;
        this.selectedTerrainLocation = null;
        this.terrainData = this.standardRandomTerrainData;
        this.terrainDataRegion = selectionKey;
        this.terrainPromise = null;
        this.terrainSuggestions = [];
        if (this.nodes.region) this.nodes.region.value = RANDOM_TERRAIN_PATTERN_LABEL;
        this.clearPresetRegionInputValue();
        this.renderTerrainSuggestions();
        this.clearTerrainContourCache();
        this.clearTerrainAnnotationOverride();
        this.resetTerrainMapOffset({ silent: true });
      }

      this.updateStandardTerrainButtons();
      this.updateTerrainQuickPicks();
      this.updateSuggestionStatus('');
      this.updateTerrainControls();
      this.updatePatchSteps();
      if (!options.silent) this.setStatus('', '');
      if (options.render !== false) this.render();

      return this.terrainData;
    }

    selectRandomTerrainPattern() {
      const seed = this.hashString(`${RANDOM_TERRAIN_PATTERN_ID}|${Date.now()}|${Math.random()}`);
      const terrainData = this.createRandomPatternTerrainData(seed);
      const selectionKey = RANDOM_TERRAIN_PATTERN_LABEL.toLowerCase();

      this.standardTerrainId = RANDOM_TERRAIN_PATTERN_ID;
      this.selectedTerrainLocation = null;
      this.terrainData = terrainData;
      this.terrainDataRegion = selectionKey;
      this.terrainPromise = null;
      this.terrainSuggestions = [];
      if (this.nodes.region) this.nodes.region.value = RANDOM_TERRAIN_PATTERN_LABEL;
      this.clearPresetRegionInputValue();
      this.renderTerrainSuggestions();
      this.clearTerrainContourCache();
      this.clearTerrainAnnotationOverride();
      this.resetTerrainMapOffset({ silent: true });
      this.updateStandardTerrainButtons();
      this.updateTerrainQuickPicks();
      this.updateSuggestionStatus('');
      this.updateTerrainControls();
      this.updatePatchSteps();
      this.setPreviewStatus('MAP READY', 'success');
      this.setStatus('Generated a fictional terrain pattern.', 'success');
      this.render();

      return terrainData;
    }

    selectStandardTerrain(terrainId, options = {}) {
      const location = this.getStandardTerrainLocation(terrainId);
      if (!location) return null;

      this.standardTerrainId = location.id;
      this.selectedTerrainLocation = location;
      this.terrainData = null;
      this.terrainDataRegion = '';
      this.terrainPromise = null;
      this.clearTerrainContourCache();
      this.clearTerrainAnnotationOverride();
      if (this.nodes.region) {
        this.nodes.region.value = location.display_name || location.name;
        this.setPresetRegionInputValue(this.nodes.region.value);
      }
      this.updateStandardTerrainButtons();
      this.updateTerrainQuickPicks();
      this.updatePatchSteps();

      if (!options.autoLoad) {
        this.render();
        return null;
      }

      return this.startTerrainLoad(location.display_name || location.name, { location });
    }

    getPaletteColor(name) {
      const palette = this.activePalette || this.getPalettes()[0];
      const fallbacks = {
        base: palette.base || palette.black || palette.background || '#212121',
        pattern: palette.pattern || palette.grid || '#333333',
        text: palette.text || palette.white || palette.secondary || palette.primary || '#f2efe5',
        accent: palette.accent || palette.red || '#ed0806'
      };

      return palette[name] || fallbacks[name];
    }

    getContourLineColor(isSecondaryLine = false) {
      const baseColor = this.getPaletteColor('base');
      const patternColor = this.getPaletteColor('pattern');
      const contrast = this.getColorContrastRatio(patternColor, baseColor);
      const targetContrast = isSecondaryLine ? 2.2 : 1.75;
      if (!Number.isFinite(contrast) || contrast >= targetContrast) return patternColor;

      const candidateTargets = [
        this.getPaletteColor('text'),
        '#f2efe5',
        '#111111'
      ];
      const targetColor = candidateTargets
        .map((color) => ({
          color,
          contrast: this.getColorContrastRatio(color, baseColor)
        }))
        .filter((item) => Number.isFinite(item.contrast))
        .sort((a, b) => b.contrast - a.contrast)[0];

      if (!targetColor || targetColor.contrast <= contrast) return patternColor;

      return this.mixHexColors(patternColor, targetColor.color, isSecondaryLine ? 0.42 : 0.28);
    }

    getContourAccentColor() {
      const palette = this.activePalette || this.getPalettes()[0];
      if (palette.id === 'warm-yellow') {
        return '#fff8ec';
      }

      if (['tech-blue', 'field-green'].includes(palette.id)) {
        return '#ffd447';
      }

      const accentColor = this.getPaletteColor('accent');
      const accentRgb = this.parseHexColor(accentColor);
      if (!accentRgb) return accentColor;

      const isRedAccent = accentRgb.r > 160 && accentRgb.r > accentRgb.g * 1.8 && accentRgb.r > accentRgb.b * 1.8;
      if (!isRedAccent) return accentColor;

      return this.mixHexColors(accentColor, '#ff2a36', 0.48);
    }

    getColorContrastRatio(colorA, colorB) {
      const luminanceA = this.getColorLuminance(colorA);
      const luminanceB = this.getColorLuminance(colorB);
      if (!Number.isFinite(luminanceA) || !Number.isFinite(luminanceB)) return null;

      const light = Math.max(luminanceA, luminanceB);
      const dark = Math.min(luminanceA, luminanceB);
      return (light + 0.05) / (dark + 0.05);
    }

    getColorLuminance(color) {
      const rgb = this.parseHexColor(color);
      if (!rgb) return null;

      const channels = [rgb.r, rgb.g, rgb.b].map((value) => {
        const channel = value / 255;
        return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
      });

      return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
    }

    mixHexColors(fromColor, toColor, amount) {
      const from = this.parseHexColor(fromColor);
      const to = this.parseHexColor(toColor);
      if (!from || !to) return fromColor;

      const weight = Math.min(1, Math.max(0, Number(amount) || 0));
      const channelToHex = (value) => Math.round(value).toString(16).padStart(2, '0');

      return `#${channelToHex(from.r + (to.r - from.r) * weight)}${channelToHex(from.g + (to.g - from.g) * weight)}${channelToHex(from.b + (to.b - from.b) * weight)}`;
    }

    parseHexColor(color) {
      const value = String(color || '').trim();
      const match = value.match(/^#?([a-f0-9]{3}|[a-f0-9]{6})$/i);
      if (!match) return null;

      const hex = match[1].length === 3
        ? match[1].split('').map((character) => character + character).join('')
        : match[1];

      return {
        r: Number.parseInt(hex.slice(0, 2), 16),
        g: Number.parseInt(hex.slice(2, 4), 16),
        b: Number.parseInt(hex.slice(4, 6), 16)
      };
    }

    getTemplateId() {
      if (this.nodes.template && this.nodes.template.value) {
        return this.nodes.template.value;
      }

      return this.config.template_id || 'portable-input-terminal';
    }

    getTemplateLabel() {
      if (this.nodes.template && this.nodes.template.selectedOptions && this.nodes.template.selectedOptions[0]) {
        return this.nodes.template.selectedOptions[0].textContent.trim();
      }

      return this.config.template_label || 'Portable Input Terminal';
    }

    isContourTemplate() {
      return this.getTemplateId() === 'patch-contour-terminal';
    }

    isPureColorTemplate() {
      return this.getTemplateId() === 'pure-color';
    }

    isBottomTextTemplate() {
      return this.isContourTemplate() || this.isPureColorTemplate();
    }

    isTechThemeTemplate() {
      return this.getTemplateId() === 'portable-input-terminal';
    }

    isTerrainThemeTemplate() {
      return this.isContourTemplate();
    }

    getThemeId() {
      if (this.isTerrainThemeTemplate()) return 'terrain';
      if (this.isTechThemeTemplate()) return 'tech';
      if (this.isPureColorTemplate()) return 'pure-color';
      return '';
    }

    hasThemeBleed() {
      return this.getThemeId() === 'tech' || this.getThemeId() === 'terrain' || this.getThemeId() === 'pure-color';
    }

    getTerrainEndpoint() {
      return typeof this.config.terrain_endpoint === 'string' ? this.config.terrain_endpoint.trim() : '';
    }

    normalizeTerrainScale(value) {
      const scaleValue = String(value || '').trim();
      return TERRAIN_SCALE_OPTIONS.some((option) => option.value === scaleValue)
        ? scaleValue
        : TERRAIN_DEFAULT_SCALE;
    }

    getTerrainScaleOption(value = this.terrainScale) {
      const scaleValue = this.normalizeTerrainScale(value);
      return TERRAIN_SCALE_OPTIONS.find((option) => option.value === scaleValue) || TERRAIN_SCALE_OPTIONS[0];
    }

    getTerrainDisplayRadiusKm() {
      return this.getTerrainScaleOption().radiusKm;
    }

    getTerrainMaxDisplayRadiusKm() {
      return TERRAIN_SCALE_OPTIONS.reduce((max, option) => Math.max(max, option.radiusKm), TERRAIN_DEFAULT_RADIUS_KM);
    }

    getTerrainScalePayload() {
      const option = this.getTerrainScaleOption();

      return {
        value: option.value,
        label: option.label,
        scale_bar_km: option.scaleBarKm,
        scale_ratio: option.scaleRatioLabel,
        scale_bar_visible: this.shouldShowTerrainScaleBar(),
        display_radius_km: option.radiusKm,
        source_radius_km: this.getTerrainGridOptions().radius_km
      };
    }

    shouldShowTerrainScaleBar() {
      return this.terrainScaleBarVisible !== false && !this.isRandomPatternTerrain();
    }

    syncTerrainScaleControls() {
      const checkedControl = this.nodes.terrainScaleControls.find((control) => control.checked);
      this.terrainScale = this.normalizeTerrainScale(checkedControl ? checkedControl.value : this.terrainScale);
      this.nodes.terrainScaleControls.forEach((control) => {
        control.checked = this.normalizeTerrainScale(control.value) === this.terrainScale;
      });
    }

    getTerrainGridOptions() {
      const grid = this.config.terrain_grid || {};
      const configuredRadius = Number(grid.radius_km);

      return {
        columns: Number(grid.columns) || TERRAIN_DEFAULT_COLUMNS,
        rows: Number(grid.rows) || TERRAIN_DEFAULT_ROWS,
        radius_km: Math.max(
          Number.isFinite(configuredRadius) && configuredRadius > 0 ? configuredRadius : TERRAIN_DEFAULT_RADIUS_KM,
          this.getTerrainMaxDisplayRadiusKm()
        )
      };
    }

    getTerrainTimeoutMs() {
      const timeout = Number(this.config.terrain_timeout_ms);
      return timeout > 0 ? timeout : 12000;
    }

    getTerrainEndpointTimeoutMs() {
      const timeout = Number(this.config.terrain_endpoint_timeout_ms);
      return timeout > 0 ? timeout : Math.min(this.getTerrainTimeoutMs(), 4500);
    }

    shouldUseTerrainProviderFallback() {
      return this.config.terrain_provider_fallback !== false;
    }

    getTerrainProviderUrl(type) {
      const provider = this.config.terrain_provider || {};
      const fallback = type === 'elevation'
        ? DEFAULT_TERRAIN_ELEVATION_URL
        : (type === 'zenithElevation'
          ? DEFAULT_TERRAIN_ZENITH_ELEVATION_URL
          : (type === 'backupElevation' ? DEFAULT_TERRAIN_BACKUP_ELEVATION_URL : DEFAULT_TERRAIN_GEOCODING_URL));
      const value = type === 'elevation'
        ? provider.elevation_url
        : (type === 'zenithElevation'
          ? provider.zenith_elevation_url
          : (type === 'backupElevation' ? provider.backup_elevation_url : provider.geocoding_url));

      return typeof value === 'string' && value.trim() ? value.trim() : fallback;
    }

    getTerrainCacheKey(region, location = this.selectedTerrainLocation) {

      return JSON.stringify({
        region: String(region || '').trim().toLowerCase(),
        latitude: location ? this.roundTerrainCoordinate(location.latitude) : null,
        longitude: location ? this.roundTerrainCoordinate(location.longitude) : null,
        ...this.getTerrainGridOptions()
      });
    }

    getTerrainSelectionKey(location = this.selectedTerrainLocation, region = this.getRegionText()) {
      if (location && Number.isFinite(Number(location.latitude)) && Number.isFinite(Number(location.longitude))) {
        return [
          this.roundTerrainCoordinate(Number(location.latitude)),
          this.roundTerrainCoordinate(Number(location.longitude))
        ].join('|');
      }

      return String(region || '').trim().toLowerCase();
    }

    hasTerrainForCurrentSelection() {
      return Boolean(
        this.terrainData &&
        this.terrainDataRegion === this.getTerrainSelectionKey()
      );
    }

    canMoveTerrainMap() {
      return this.isContourTemplate() && this.hasTerrainForCurrentSelection() && !this.terrainPromise;
    }

    getTerrainMapOffset() {
      const offset = this.terrainMapOffset || {};

      return {
        x: Number(offset.x) || 0,
        y: Number(offset.y) || 0
      };
    }

    getDefaultTerrainMapOffset() {
      if (this.isRandomPatternTerrain()) {
        return { x: 0, y: 0 };
      }

      const annotation = this.getManualTerrainAnnotationInfo() || this.getTerrainAnnotationInfo();
      if (annotation && Number.isFinite(Number(annotation.x)) && Number.isFinite(Number(annotation.y))) {
        return this.getClampedTerrainMapOffset({
          x: TERRAIN_DEFAULT_MARKER_POSITION.x - Number(annotation.x),
          y: TERRAIN_DEFAULT_MARKER_POSITION.y - Number(annotation.y)
        });
      }

      return { ...TERRAIN_DEFAULT_MAP_OFFSET };
    }

    shouldRecalculateTerrainMapOffset(offset) {
      if (this.isRandomPatternTerrain()) return false;
      const candidate = this.getClampedTerrainMapOffset(offset || { x: 0, y: 0 });

      return TERRAIN_STALE_DEFAULT_MAP_OFFSETS.some((staleOffset) => (
        candidate.x === staleOffset.x && candidate.y === staleOffset.y
      ));
    }

    resolveRestoredTerrainMapOffset(offset) {
      if (this.shouldRecalculateTerrainMapOffset(offset)) {
        return this.getDefaultTerrainMapOffset();
      }

      return this.getClampedTerrainMapOffset(offset || { x: 0, y: 0 });
    }

    getClampedTerrainMapOffset(offset) {
      const x = Number(offset && offset.x) || 0;
      const y = Number(offset && offset.y) || 0;

      return {
        x: Math.round(Math.min(TERRAIN_MAP_MAX_OFFSET_X, Math.max(-TERRAIN_MAP_MAX_OFFSET_X, x))),
        y: Math.round(Math.min(TERRAIN_MAP_MAX_OFFSET_Y, Math.max(-TERRAIN_MAP_MAX_OFFSET_Y, y)))
      };
    }

    hasTerrainMapOffset() {
      const offset = this.getTerrainMapOffset();
      const defaultOffset = this.getDefaultTerrainMapOffset();

      return offset.x !== defaultOffset.x || offset.y !== defaultOffset.y;
    }

    setTerrainMapOffset(offset, options = {}) {
      const nextOffset = this.getClampedTerrainMapOffset(offset);
      const currentOffset = this.getTerrainMapOffset();
      if (nextOffset.x === currentOffset.x && nextOffset.y === currentOffset.y) return;

      this.terrainMapOffset = nextOffset;
      this.updateTerrainControls();
      if (!options.silent) this.render();
    }

    resetTerrainMapOffset(options = {}) {
      this.setTerrainMapOffset(this.getDefaultTerrainMapOffset(), options);
    }

    hasTerrainAnnotationOverride() {
      return Boolean(this.terrainAnnotationOverride);
    }

    canResetTerrainAnnotationPoint() {
      return this.isContourTemplate() && this.hasTerrainForCurrentSelection() && this.hasTerrainAnnotationOverride() && !this.terrainPromise;
    }

    clearTerrainAnnotationOverride() {
      this.terrainAnnotationOverride = null;
    }

    resetTerrainAnnotationPoint(options = {}) {
      if (!this.hasTerrainAnnotationOverride()) return;

      this.clearTerrainAnnotationOverride();
      this.updateTerrainControls();
      if (!options.silent) this.render();
    }

    setTerrainAnnotationOverrideFromPoint(point, options = {}) {
      const annotation = this.getTerrainAnnotationFromVisiblePoint(point);
      if (!annotation) return false;

      this.terrainAnnotationOverride = annotation;
      this.updateTerrainControls();
      if (!options.silent) this.render();

      return true;
    }

    clearTerrainContourCache() {
      this.terrainContourCache = null;
    }

    getTerrainMapProjection(terrainData = this.terrainData) {
      const viewport = {
        x: -TERRAIN_MAP_MAX_OFFSET_X,
        y: -TERRAIN_MAP_MAX_OFFSET_Y,
        width: BASE_WIDTH + TERRAIN_MAP_MAX_OFFSET_X * 2,
        height: BASE_HEIGHT + TERRAIN_MAP_MAX_OFFSET_Y * 2
      };
      const fallback = {
        mode: 'true_aspect_cover',
        x: viewport.x,
        y: viewport.y,
        width: viewport.width,
        height: viewport.height,
        aspectRatio: viewport.width / viewport.height,
        scale: this.getTerrainScaleOption().label,
        displayRadiusKm: this.getTerrainDisplayRadiusKm(),
        sourceRadiusKm: null,
        overscan: {
          x: TERRAIN_MAP_MAX_OFFSET_X,
          y: TERRAIN_MAP_MAX_OFFSET_Y
        }
      };
      const bounds = terrainData && terrainData.bounds;
      if (!bounds) return fallback;

      const north = Number(bounds.north);
      const south = Number(bounds.south);
      const east = Number(bounds.east);
      const west = Number(bounds.west);
      if (![north, south, east, west].every(Number.isFinite)) return fallback;

      const latitudeSpan = Math.abs(north - south);
      const longitudeSpan = Math.abs(east - west);
      const centerLatitude = (north + south) / 2;
      const latitudeRadians = Math.max(-89.9, Math.min(89.9, centerLatitude)) * Math.PI / 180;
      const heightKm = latitudeSpan * 111.32;
      const widthKm = longitudeSpan * 111.32 * Math.max(0.12, Math.cos(latitudeRadians));
      if (!Number.isFinite(widthKm) || !Number.isFinite(heightKm) || widthKm <= 0 || heightKm <= 0) return fallback;

      const terrainAspect = widthKm / heightKm;
      const viewportAspect = viewport.width / viewport.height;
      const width = terrainAspect >= viewportAspect ? viewport.height * terrainAspect : viewport.width;
      const height = terrainAspect >= viewportAspect ? viewport.height : viewport.width / terrainAspect;
      const sourceRadiusKm = Math.max(
        Number(bounds.radius_km) || this.getTerrainGridOptions().radius_km,
        this.getTerrainDisplayRadiusKm()
      );
      const displayRadiusKm = Math.min(sourceRadiusKm, this.getTerrainDisplayRadiusKm());
      const zoom = sourceRadiusKm / displayRadiusKm;
      const scaledWidth = width * zoom;
      const scaledHeight = height * zoom;

      return {
        mode: 'true_aspect_cover',
        x: viewport.x + (viewport.width - scaledWidth) / 2,
        y: viewport.y + (viewport.height - scaledHeight) / 2,
        width: scaledWidth,
        height: scaledHeight,
        aspectRatio: terrainAspect,
        scale: this.getTerrainScaleOption().label,
        displayRadiusKm,
        sourceRadiusKm,
        overscan: {
          x: TERRAIN_MAP_MAX_OFFSET_X,
          y: TERRAIN_MAP_MAX_OFFSET_Y
        }
      };
    }

    getTerrainMapProjectionKey(projection) {
      return [
        projection.mode,
        projection.scale,
        Math.round(projection.x * 10),
        Math.round(projection.y * 10),
        Math.round(projection.width * 10),
        Math.round(projection.height * 10)
      ].join('|');
    }

    getTerrainMapProjectionPayload(projection = this.getTerrainMapProjection()) {
      return {
        mode: projection.mode,
        x: Math.round(projection.x),
        y: Math.round(projection.y),
        width: Math.round(projection.width),
        height: Math.round(projection.height),
        aspect_ratio: Number(projection.aspectRatio.toFixed(4)),
        scale: projection.scale,
        display_radius_km: projection.displayRadiusKm,
        source_radius_km: projection.sourceRadiusKm,
        overscan: projection.overscan || {
          x: TERRAIN_MAP_MAX_OFFSET_X,
          y: TERRAIN_MAP_MAX_OFFSET_Y
        }
      };
    }

    getTerrainScaleBarData(projection = this.getTerrainMapProjection()) {
      const option = this.getTerrainScaleOption();
      const bounds = this.terrainData && this.terrainData.bounds;
      const totalKm = Number(option.scaleBarKm) || 10;
      const label = `SCALE BAR ${option.scaleRatioLabel || ''}`.trim();
      const fallbackHeight = 330;

      if (!bounds || !projection || !Number.isFinite(Number(projection.height)) || Number(projection.height) <= 0) {
        return {
          totalKm,
          tickValues: [0, totalKm * 0.25, totalKm * 0.5, totalKm * 0.75, totalKm],
          height: fallbackHeight,
          label
        };
      }

      const north = Number(bounds.north);
      const south = Number(bounds.south);
      const heightKm = Math.abs(north - south) * 111.32;
      const kmPerPixelY = heightKm / Number(projection.height);
      const barHeight = totalKm / kmPerPixelY;

      return {
        totalKm,
        tickValues: [0, totalKm * 0.25, totalKm * 0.5, totalKm * 0.75, totalKm],
        height: Number.isFinite(barHeight) && barHeight > 0 ? barHeight : fallbackHeight,
        label
      };
    }

    formatTerrainDistanceKm(value) {
      const distance = Number(value);
      if (!Number.isFinite(distance)) return '0';

      return Number.isInteger(distance)
        ? String(distance)
        : distance.toFixed(1).replace(/\.0$/, '');
    }

    getContourSeed() {
      if (this.shouldUseStandardInitialTerrainPattern()) {
        return this.hashString(STANDARD_RANDOM_PATTERN_SEED);
      }

      return this.hashString(`${this.getTemplateId()}|${this.getRegionText() || DEFAULT_REGION_TEXT}`);
    }

    hashString(value) {
      let hash = 2166136261;
      const text = String(value || '');

      for (let index = 0; index < text.length; index += 1) {
        hash ^= text.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
      }

      return hash >>> 0;
    }

    createSeededRandom(seed) {
      let state = seed >>> 0;

      return () => {
        state += 0x6D2B79F5;
        let value = state;
        value = Math.imul(value ^ (value >>> 15), value | 1);
        value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
        return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
      };
    }

    populateHardwareColorOptions() {
      this.caseColorId = this.caseColorId || (this.getCaseColors()[0] && this.getCaseColors()[0].id) || '';
      this.patchColorId = this.patchColorId || (this.getPatchColors()[0] && this.getPatchColors()[0].id) || '';
      this.buttonColorId = this.buttonColorId || (this.getButtonColors()[0] && this.getButtonColors()[0].id) || '';

      this.populateHardwareColorGroup(this.nodes.caseColors, this.getCaseColors(), 'case');
      this.populateHardwareColorGroup(this.nodes.patchColors, this.getPatchColors(), 'patch');
      this.populateHardwareColorGroup(this.nodes.buttonColors, this.getButtonColors(), 'button');
      this.populateHardwareColorGroup(this.nodes.standardButtonColors, this.getButtonColors(), 'button');
      this.updateHardwareColorButtons();
    }

    populateHardwareColorGroup(container, colors, type) {
      if (!container) return;

      container.innerHTML = '';
      colors.forEach((color) => {
        const button = document.createElement('button');
        button.className = 'smallsmore-patch-customizer__hardware-color-button';
        button.type = 'button';
        button.dataset.patchHardwareColorType = type;
        button.dataset.patchHardwareColor = color.id;
        button.dataset.patchHardwareColorLabel = color.label || color.id;
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', color.label || color.id);
        const swatchColor = (type === 'case' && color.outer_hex) || color.hex || '#ffffff';
        if (swatchColor) {
          button.style.setProperty('--sm-hardware-tooltip-bg', swatchColor);
          button.style.setProperty('--sm-hardware-tooltip-fg', this.getReadableColorForBackground(swatchColor));
        }

        const swatch = document.createElement('span');
        swatch.className = 'smallsmore-patch-customizer__hardware-color-swatch';
        swatch.style.background = swatchColor;
        swatch.setAttribute('aria-hidden', 'true');
        button.append(swatch);
        button.addEventListener('click', () => this.recordHistoryChange(() => this.setHardwareColor(type, color.id)));
        container.append(button);
      });
    }

    setHardwareColor(type, colorId) {
      if (type === 'case') {
        const color = this.getCaseColors().find((item) => item.id === colorId);
        this.caseColorId = colorId;
        if (color && color.optionValue) {
          this.selectVariantOption('Case Color', color.optionValue, { notifyDawn: false });
        }
      }
      if (type === 'button') {
        const color = this.getButtonColors().find((item) => item.id === colorId);
        this.buttonColorId = colorId;
        if (color && !this.isPureColorTemplate()) {
          this.selectVariantOption('Patch Color', color.label, { notifyDawn: false });
        }
      }
      if (type === 'patch') {
        const color = this.getPatchColors().find((item) => item.id === colorId);
        const currentCaseColorId = this.caseColorId;
        this.patchColorId = colorId;
        if (color) {
          this.selectVariantOption('Patch Color', color.label, { notifyDawn: false });
        }
        this.caseColorId = currentCaseColorId || this.caseColorId;
      }
      this.syncStandardInitialTerrainPalette();
      this.updateHardwareColorButtons();
      this.updatePatchSteps();
      this.render();
    }

    updateHardwareColorButtons() {
      [
        [this.nodes.caseColors, this.caseColorId],
        [this.nodes.patchColors, this.patchColorId],
        [this.nodes.buttonColors, this.buttonColorId],
        [this.nodes.standardButtonColors, this.buttonColorId]
      ].forEach(([container, activeId]) => {
        if (!container) return;

        container.querySelectorAll('[data-patch-hardware-color]').forEach((button) => {
          const isActive = button.dataset.patchHardwareColor === activeId;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });
      this.updateCaseColorCareNotice();
    }

    updateCaseColorCareNotice() {
      if (!this.nodes.caseColorCareNotice) return;

      const shouldShow = CASE_COLOR_CARE_NOTICE_COLOR_IDS.has(this.caseColorId);
      this.nodes.caseColorCareNotice.hidden = !shouldShow;
      this.nodes.caseColorCareNotice.classList.toggle('is-visible', shouldShow);
    }

    populatePalettes() {
      if (!this.nodes.palettes) return;

      this.nodes.palettes.innerHTML = '';
      this.getPalettes().forEach((palette) => {
        const button = document.createElement('button');
        button.className = 'smallsmore-patch-customizer__palette-button';
        button.type = 'button';
        button.dataset.patchPalette = palette.id;
        button.setAttribute('aria-pressed', 'false');

        const swatches = document.createElement('span');
        swatches.className = 'smallsmore-patch-customizer__swatches';
        const swatchColors = [
          palette.base || palette.black || palette.background,
          palette.pattern || palette.grid,
          palette.text || palette.white || palette.secondary || palette.primary,
          palette.accent || palette.red
        ];

        swatchColors.filter(Boolean).forEach((color) => {
          const swatch = document.createElement('span');
          swatch.className = 'smallsmore-patch-customizer__swatch';
          swatch.style.background = color;
          swatches.append(swatch);
        });

        const label = document.createElement('span');
        label.className = 'smallsmore-patch-customizer__palette-label';
        label.textContent = palette.label;

        button.append(swatches, label);
        button.addEventListener('click', () => this.recordHistoryChange(() => this.applyPalette(palette.id)));
        this.nodes.palettes.append(button);
      });
    }

    populateTerrainQuickPicks() {
      if (!this.nodes.regionQuickPicks) return;

      this.nodes.regionQuickPicks.innerHTML = '';
      CURATED_TERRAIN_LOCATIONS
        .filter((location) => location.featured && !STANDARD_TERRAIN_QUICK_PICK_EXCLUDED_IDS.has(location.id))
        .sort((locationA, locationB) => (Number(locationA.featuredOrder) || 999) - (Number(locationB.featuredOrder) || 999))
        .forEach((location) => {
          const button = document.createElement('button');
          button.className = 'smallsmore-patch-customizer__quick-pick';
          button.type = 'button';
          button.dataset.terrainQuickPick = location.id;
          button.textContent = location.name;
          button.addEventListener('click', () => this.recordHistoryChange(() => this.selectTerrainSuggestion({
            ...location,
            score: 260
          }, { autoLoad: true, clearOnFocus: true })));
          this.nodes.regionQuickPicks.append(button);
        });
    }

    bindInputHistoryCapture(input) {
      if (!input) return;

      input.addEventListener('pointerdown', () => this.beginHistoryCapture());
      input.addEventListener('focus', () => this.beginHistoryCapture());
      input.addEventListener('paste', () => this.beginHistoryCapture());
      input.addEventListener('keydown', (event) => {
        if (event.metaKey || event.ctrlKey || event.altKey || event.key === 'Tab') return;
        this.beginHistoryCapture();
      });
      input.addEventListener('blur', () => this.commitHistoryCapture());
    }

    isEditableHistoryTarget(target) {
      return target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target instanceof HTMLSelectElement ||
        (target && target.isContentEditable);
    }

    captureHistorySnapshot() {
      const palette = this.activePalette || this.getPalettes()[0];

      return {
        template: this.nodes.template ? this.nodes.template.value : this.getTemplateId(),
        mainText: this.nodes.mainText ? this.nodes.mainText.value : '',
        mainTextSecondary: this.nodes.mainTextSecondary ? this.nodes.mainTextSecondary.value : '',
        sideText: this.nodes.sideText ? this.nodes.sideText.value : '',
        bottomFont: this.getSelectedTextFont(),
        bottomText: this.nodes.bottomText ? this.nodes.bottomText.value : '',
        bottomTextSkipped: Boolean(this.bottomTextSkipped),
        textSizeId: this.textSizeId || 'm',
        textSizeScale: Number(this.textSizeScale) || 1,
        textAlign: this.getTextAlign(),
        textColor: this.textColor || '',
        textColorId: this.textColorId || 'palette',
        textStroke: this.textStroke || '',
        textStrokeWidth: Number(this.textStrokeWidth) || 0,
        textStrokeId: this.textStrokeId || 'none',
        locationMode: this.getLocationInputMode(),
        region: this.nodes.region ? this.nodes.region.value : '',
        showRegion: this.nodes.showRegion ? Boolean(this.nodes.showRegion.checked) : true,
        coordinates: this.nodes.coordinates ? this.nodes.coordinates.value : '',
        coordinateLabel: this.nodes.coordinateLabel ? this.nodes.coordinateLabel.value : '',
        customizationMode: this.getCustomizationMode(),
        standardTerrainId: this.standardTerrainId,
        caseColorId: this.caseColorId,
        patchColorId: this.patchColorId,
        buttonColorId: this.buttonColorId,
        paletteId: palette && palette.id,
        terrainScale: this.normalizeTerrainScale(this.terrainScale),
        terrainScaleBarVisible: this.shouldShowTerrainScaleBar(),
        selectedTerrainLocation: this.getSerializableTerrainLocation(this.selectedTerrainLocation),
        terrainData: this.terrainData,
        terrainDataRegion: this.terrainDataRegion || '',
        terrainMapOffset: this.getTerrainMapOffset(),
        terrainAnnotationOverride: this.terrainAnnotationOverride ? { ...this.terrainAnnotationOverride } : null
      };
    }

    areHistorySnapshotsEqual(first, second) {
      return JSON.stringify(first) === JSON.stringify(second);
    }

    beginHistoryCapture() {
      if (this.isRestoringHistory || this.pendingHistorySnapshot) return;
      this.pendingHistorySnapshot = this.captureHistorySnapshot();
    }

    commitHistoryCapture(snapshot = this.pendingHistorySnapshot) {
      this.pendingHistorySnapshot = null;
      if (this.isRestoringHistory || !snapshot) return;

      const nextSnapshot = this.captureHistorySnapshot();
      if (this.areHistorySnapshotsEqual(snapshot, nextSnapshot)) {
        this.updateHistoryButtons();
        return;
      }

      this.undoStack.push(snapshot);
      if (this.undoStack.length > PATCH_HISTORY_LIMIT) this.undoStack.shift();
      this.redoStack = [];
      this.updateHistoryButtons();
    }

    recordHistoryChange(callback) {
      this.commitHistoryCapture();
      const snapshot = this.captureHistorySnapshot();
      const result = callback();
      this.commitHistoryCapture(snapshot);
      return result;
    }

    async recordHistoryChangeAsync(callback) {
      this.commitHistoryCapture();
      const snapshot = this.captureHistorySnapshot();
      const result = await callback();
      this.commitHistoryCapture(snapshot);
      return result;
    }

    undoEdit() {
      this.commitHistoryCapture();
      if (!this.undoStack.length) return;

      const currentSnapshot = this.captureHistorySnapshot();
      const previousSnapshot = this.undoStack.pop();
      this.redoStack.push(currentSnapshot);
      this.restoreHistorySnapshot(previousSnapshot);
      this.updateHistoryButtons();
    }

    redoEdit() {
      this.commitHistoryCapture();
      if (!this.redoStack.length) return;

      const currentSnapshot = this.captureHistorySnapshot();
      const nextSnapshot = this.redoStack.pop();
      this.undoStack.push(currentSnapshot);
      this.restoreHistorySnapshot(nextSnapshot);
      this.updateHistoryButtons();
    }

    restoreHistorySnapshot(snapshot) {
      if (!snapshot) return;

      this.isRestoringHistory = true;

      try {
        if (this.nodes.template) this.nodes.template.value = snapshot.template || this.nodes.template.value;
        if (this.nodes.mainText) this.nodes.mainText.value = snapshot.mainText || '';
        if (this.nodes.mainTextSecondary) this.nodes.mainTextSecondary.value = snapshot.mainTextSecondary || '';
        if (this.nodes.sideText) this.nodes.sideText.value = snapshot.sideText || '';
        if (this.nodes.bottomFont) this.nodes.bottomFont.value = snapshot.bottomFont || DEFAULT_CUSTOM_TEXT_FONT;
        if (this.nodes.bottomText) this.nodes.bottomText.value = snapshot.bottomText || '';
        if (this.nodes.region) this.nodes.region.value = snapshot.region || '';
        if (this.nodes.showRegion) this.nodes.showRegion.checked = snapshot.showRegion !== false;
        if (this.nodes.coordinates) this.nodes.coordinates.value = snapshot.coordinates || '';
        if (this.nodes.coordinateLabel) this.nodes.coordinateLabel.value = snapshot.coordinateLabel || '';
        this.customizationMode = snapshot.customizationMode || this.customizationMode || 'Standard';
        this.standardTerrainId = snapshot.standardTerrainId || this.standardTerrainId || 'curated:el-capitan-yosemite';

        this.nodes.locationModes.forEach((control) => {
          control.checked = control.value === (snapshot.locationMode || 'search');
        });

        this.bottomTextSkipped = Boolean(snapshot.bottomTextSkipped);
        this.syncBottomTextSkipControls();

        this.textSizeId = snapshot.textSizeId || 'm';
        this.textSizeScale = Number(snapshot.textSizeScale) || 1;
        this.syncTextSizeControls();

        this.setTextAlign(snapshot.textAlign || 'center', { render: false });

        this.textColor = snapshot.textColor || '';
        this.textColorId = snapshot.textColorId || 'palette';
        this.textStroke = snapshot.textStroke || '';
        this.textStrokeWidth = Number(snapshot.textStrokeWidth) || 0;
        this.textStrokeId = snapshot.textStrokeId || 'none';
        this.syncBottomTextStyleControls();

        this.caseColorId = snapshot.caseColorId || (this.getCaseColors()[0] && this.getCaseColors()[0].id) || '';
        this.patchColorId = snapshot.patchColorId || snapshot.buttonColorId || snapshot.buttonOneColorId || snapshot.buttonTwoColorId || (this.getPatchColors()[0] && this.getPatchColors()[0].id) || '';
        this.buttonColorId = snapshot.buttonColorId || (this.getButtonColors()[0] && this.getButtonColors()[0].id) || '';
        this.restoreVariantOptionsFromSnapshot(snapshot);
        this.updateHardwareColorButtons();

        this.activePalette = this.getPalettes().find((palette) => palette.id === snapshot.paletteId) || this.getPalettes()[0];
        this.updatePaletteButtons();

        this.terrainScale = this.normalizeTerrainScale(snapshot.terrainScale);
        this.syncTerrainScaleControls();
        this.terrainScaleBarVisible = snapshot.terrainScaleBarVisible !== false;
        if (this.nodes.scaleBarToggle) this.nodes.scaleBarToggle.checked = this.shouldShowTerrainScaleBar();
        this.selectedTerrainLocation = snapshot.selectedTerrainLocation ? { ...snapshot.selectedTerrainLocation } : null;
        this.terrainData = snapshot.terrainData || null;
        this.terrainDataRegion = snapshot.terrainDataRegion || '';
        this.terrainPromise = null;
        this.terrainAnnotationOverride = snapshot.terrainAnnotationOverride ? { ...snapshot.terrainAnnotationOverride } : null;
        this.terrainMapOffset = this.resolveRestoredTerrainMapOffset(snapshot.terrainMapOffset);
        this.clearTerrainContourCache();

        this.syncLocationModeUi();
        this.syncCustomizationModeUi();
        this.syncRegionControls();
        this.updatePatchSteps();
        this.updateTerrainControls();
        this.updateTerrainQuickPicks();
        this.render();
      } finally {
        this.isRestoringHistory = false;
      }
    }

    restoreVariantOptionsFromSnapshot(snapshot = {}) {
      const customizationMode = snapshot.customizationMode || this.customizationMode || '';
      const caseColor = this.getHardwareColor('case', snapshot.caseColorId || this.caseColorId);
      const patchColor = this.getHardwareColor('patch', snapshot.patchColorId || snapshot.buttonColorId || snapshot.buttonOneColorId || snapshot.buttonTwoColorId || this.patchColorId);
      const buttonColor = this.getHardwareColor('button', snapshot.buttonColorId || this.buttonColorId);

      if (customizationMode) {
        this.selectCustomizationVariantOption(customizationMode, { notifyDawn: false });
      }

      if (caseColor) {
        this.selectVariantOption('Case Color', caseColor.optionValue || caseColor.label || caseColor.id, { notifyDawn: false });
      }

      if (patchColor) {
        this.selectVariantOption('Patch Color', patchColor.label || patchColor.id, { notifyDawn: false });
      }

      if (customizationMode) this.customizationMode = this.normalizeVariantOptionName(customizationMode) === 'standard' ? 'Standard' : 'Custom';
      if (caseColor) this.caseColorId = caseColor.id;
      if (patchColor) this.patchColorId = patchColor.id;
      if (buttonColor) this.buttonColorId = buttonColor.id;
    }

    async saveCurrentEditDraft(payload) {
      const id = this.editDraftId || this.createEditDraftId();
      const now = Date.now();
      const record = {
        id,
        version: 1,
        type: 'patch',
        createdAt: now,
        updatedAt: now,
        editPath: this.editPath || this.getCleanEditPath(),
        draft: {
          templateId: this.getTemplateId(),
          payload,
          history: this.captureHistorySnapshot()
        }
      };

      try {
        await this.saveDraftRecord(record);
        this.editDraftId = id;
        this.editPath = record.editPath;
        this.editDraftStorageUnavailable = false;
        this.pruneDraftRecords().catch(() => {});
        return record;
      } catch (error) {
        try {
          await this.pruneDraftRecords(Math.max(8, Math.floor(EDIT_DRAFT_MAX_COUNT / 2)));
          await this.saveDraftRecord(record);
          this.editDraftId = id;
          this.editPath = record.editPath;
          this.editDraftStorageUnavailable = false;
          return record;
        } catch (retryError) {
          this.editDraftStorageUnavailable = true;
          return null;
        }
      }
    }

    decoratePayloadForEdit(payload, draftRecord) {
      if (!payload) return payload;

      return {
        ...payload,
        edit_draft_id: draftRecord ? draftRecord.id : '',
        edit_path: draftRecord ? draftRecord.editPath : '',
        edit_cart_key: this.editCartKey || ''
      };
    }

    syncEditDraftProperties(draftRecord) {
      if (this.nodes.propertyEditDraftId) {
        this.nodes.propertyEditDraftId.value = draftRecord ? draftRecord.id : '';
      }
      if (this.nodes.propertyEditPath) {
        this.nodes.propertyEditPath.value = draftRecord ? draftRecord.editPath : '';
      }
    }

    setLineItemProperty(node, value, include = true) {
      if (!node) return;

      node.value = value || '';
      node.disabled = !include;
    }

    collectLineItemProperties() {
      if (!this.nodes.form) return {};

      const properties = {};
      new FormData(this.nodes.form).forEach((value, key) => {
        const match = String(key).match(/^properties\[(.+)\]$/);
        if (!match) return;
        if (value instanceof File) return;

        const propertyName = match[1];
        const propertyValue = String(value || '').trim();
        if (propertyValue) properties[propertyName] = propertyValue;
      });

      return properties;
    }

    validatePurchaseCartProperties(payload) {
      const properties = this.collectLineItemProperties();
      const buttons = properties.Buttons || properties.BUTTONS || '';
      const payloadText = properties._smallsmore_patch_customization || '';

      if (!buttons || !payloadText || !payload || !payload.button_color) {
        return false;
      }

      try {
        const savedPayload = JSON.parse(payloadText);
        return Boolean(savedPayload && savedPayload.button_color && (savedPayload.button_color.label || savedPayload.button_color.id));
      } catch {
        return false;
      }
    }

    getCartAddLogEndpoint() {
      return typeof this.config.cart_add_log_endpoint === 'string'
        ? this.config.cart_add_log_endpoint.trim()
        : '';
    }

    getProductTitleForCartLog(cartAddData) {
      if (cartAddData && cartAddData.product_title) return cartAddData.product_title;
      if (cartAddData && cartAddData.title) return cartAddData.title;
      if (this.nodes.commerceSummary) {
        const title = this.nodes.commerceSummary.querySelector('.smallsmore-patch-customizer__commerce-title');
        if (title && title.textContent) return title.textContent.trim();
      }
      return this.getTemplateLabel();
    }

    getQuantityForCartLog(cartAddData) {
      if (cartAddData && cartAddData.quantity) return Number(cartAddData.quantity) || 1;
      const quantityInput = this.nodes.form ? this.nodes.form.querySelector('[name="quantity"]') : null;
      return quantityInput ? Number(quantityInput.value) || 1 : 1;
    }

    async logCartAdd(payload, cartAddData, uploadedPrint) {
      const endpoint = this.getCartAddLogEndpoint();
      if (!endpoint) return null;

      const printUrl = uploadedPrint && uploadedPrint.url
        ? uploadedPrint.url
        : payload && payload.print_file && payload.print_file.url
          ? payload.print_file.url
          : payload && payload.preview_url
            ? payload.preview_url
            : '';

      const variant = this.getVariantFromSelectedControls() || this.getConfiguredVariant() || {};
      const body = {
        source: 'shopify-pure-edition',
        cartKey: cartAddData && cartAddData.key ? cartAddData.key : '',
        productTitle: this.getProductTitleForCartLog(cartAddData),
        sku: cartAddData && cartAddData.sku ? cartAddData.sku : (variant.sku || ''),
        quantity: this.getQuantityForCartLog(cartAddData),
        properties: this.collectLineItemProperties(),
        payload,
        productionLineId: payload && payload.production_line_id ? payload.production_line_id : '',
        printUrl
      };

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || (result && result.error)) {
          throw new Error(result && result.error && result.error.message ? result.error.message : `Cart-add log failed: ${response.status}`);
        }
        return result;
      } catch (error) {
        console.warn('[smallsmore] Cart-add log failed', error);
        return null;
      }
    }

    restoreEditDraftFromUrl() {
      if (!this.editDraftId) return;

      this.editDraftRestorePromise = this.restoreEditDraftFromStorage(this.editDraftId);
    }

    async restoreEditDraftFromStorage(draftId) {
      this.setStatus('Restoring your saved patch...', '');

      try {
        const record = await this.getDraftRecord(draftId);
        if (!record || !record.draft) throw new Error('Draft was not found.');

        this.restoreHistorySnapshot(record.draft.history || null);
        this.syncEditDraftProperties(record);
        this.setStatus('Patch restored. You can keep editing before updating the cart.', 'success');
      } catch (error) {
        this.syncEditDraftProperties(null);
        this.setStatus('This saved patch could not be restored. You can start a new patch here.', 'error');
      }
    }

    updateHistoryButtons() {
      const isStandard = this.isStandardCustomizationMode();
      const hasUndo = this.undoStack.length > 0;
      const hasRedo = this.redoStack.length > 0;

      if (this.nodes.historyTools) {
        this.nodes.historyTools.hidden = isStandard;
        this.nodes.historyTools.setAttribute('aria-hidden', isStandard ? 'true' : 'false');
      }
      if (this.nodes.undo) {
        this.nodes.undo.hidden = isStandard;
        this.nodes.undo.setAttribute('aria-hidden', isStandard ? 'true' : 'false');
        this.nodes.undo.disabled = isStandard || !hasUndo;
      }
      if (this.nodes.redo) {
        this.nodes.redo.hidden = isStandard;
        this.nodes.redo.setAttribute('aria-hidden', isStandard ? 'true' : 'false');
        this.nodes.redo.disabled = isStandard || !hasRedo;
      }
    }

    bindEvents() {
      window.addEventListener('smallsmore:edit-context', (event) => {
        this.applyEditContext(event.detail || {});
        if (this.editDraftId) this.restoreEditDraftFromUrl();
      });

      this.bindInputHistoryCapture(this.nodes.mainText);
      this.bindInputHistoryCapture(this.nodes.mainTextSecondary);
      this.bindInputHistoryCapture(this.nodes.sideText);
      this.bindInputHistoryCapture(this.nodes.bottomFont);
      this.bindInputHistoryCapture(this.nodes.bottomText);
      this.bindInputHistoryCapture(this.nodes.region);
      this.bindInputHistoryCapture(this.nodes.coordinates);
      this.bindInputHistoryCapture(this.nodes.coordinateLabel);
      this.bindInputHistoryCapture(this.nodes.template);
      this.bindInputHistoryCapture(this.nodes.showRegion);
      this.nodes.locationModes.forEach((control) => this.bindInputHistoryCapture(control));
      this.nodes.terrainScaleControls.forEach((control) => this.bindInputHistoryCapture(control));

      if (this.nodes.undo) {
        this.nodes.undo.addEventListener('click', () => this.undoEdit());
      }
      if (this.nodes.redo) {
        this.nodes.redo.addEventListener('click', () => this.redoEdit());
      }
      if (this.nodes.template) {
        this.nodes.template.addEventListener('change', () => this.recordHistoryChange(() => {
          this.updatePatchSteps();
          this.updateTerrainControls();
          this.render();
        }));
      }

      if (this.nodes.mainText) {
        this.nodes.mainText.addEventListener('input', () => {
          this.limitInputLength(this.nodes.mainText);
          this.limitMainTextInputWidth(this.nodes.mainText, MAIN_TEXT_AREA.topFontSize);
          this.updatePatchSteps();
          this.render();
        });
      }
      if (this.nodes.mainTextSecondary) {
        this.nodes.mainTextSecondary.addEventListener('input', () => {
          this.limitInputLength(this.nodes.mainTextSecondary);
          this.limitMainTextInputWidth(this.nodes.mainTextSecondary, MAIN_TEXT_AREA.bottomFontSize);
          this.updatePatchSteps();
          this.render();
        });
      }
      if (this.nodes.sideText) {
        this.nodes.sideText.addEventListener('input', () => {
          this.updatePatchSteps();
          this.render();
        });
      }
      if (this.nodes.bottomFont) {
        this.nodes.bottomFont.addEventListener('change', () => this.recordHistoryChange(() => {
          this.limitMainTextInputsWidth();
          this.render();
        }));
      }
      if (this.nodes.bottomText) {
        this.nodes.bottomText.addEventListener('input', () => {
          this.updatePatchSteps();
          this.render();
        });
      }
      this.nodes.textSizeButtons.forEach((button) => {
        button.addEventListener('click', () => this.recordHistoryChange(() => this.setTextSizeFromButton(button)));
      });
      this.nodes.textAlignButtons.forEach((button) => {
        button.addEventListener('click', () => this.recordHistoryChange(() => this.setTextAlignFromButton(button)));
      });
      this.nodes.textColorButtons.forEach((button) => {
        button.addEventListener('click', () => this.recordHistoryChange(() => this.setTextColorFromButton(button)));
      });
      this.nodes.textStrokeButtons.forEach((button) => {
        button.addEventListener('click', () => this.recordHistoryChange(() => this.setTextStrokeFromButton(button)));
      });
      if (this.nodes.bottomTextSkip) {
        this.nodes.bottomTextSkip.addEventListener('click', () => this.recordHistoryChange(() => this.setBottomTextSkipped(!this.bottomTextSkipped)));
      }
      this.nodes.locationModes.forEach((control) => {
        control.addEventListener('change', () => this.recordHistoryChange(() => this.handleLocationModeChange()));
      });
      if (this.nodes.region) {
        this.nodes.region.addEventListener('input', () => {
          this.handleRegionInput();
        });
        this.nodes.region.addEventListener('change', () => {
          this.handleRegionInput();
        });
        this.nodes.region.addEventListener('focus', () => {
          if (this.clearPresetRegionInputOnFocus()) return;
          this.queueTerrainSuggestions({ immediate: true });
        });
      }
      if (this.nodes.showRegion) {
        this.nodes.showRegion.addEventListener('change', () => this.recordHistoryChange(() => {
          this.syncRegionControls();
          this.updatePatchSteps();
          this.render();
        }));
      }
      if (this.nodes.coordinates) {
        this.nodes.coordinates.addEventListener('input', () => this.handleCoordinateInput());
      }
      if (this.nodes.coordinateLabel) {
        this.nodes.coordinateLabel.addEventListener('input', () => this.handleCoordinateLabelInput());
      }
      if (this.nodes.getMapButton) {
        this.nodes.getMapButton.addEventListener('click', () => this.recordHistoryChangeAsync(() => this.handleGetMapClick()));
      }
      if (this.nodes.guideOpenButton) {
        this.nodes.guideOpenButton.addEventListener('click', () => this.openGuideDialog());
      }
      if (this.nodes.coordinateGuideOpenButton) {
        this.nodes.coordinateGuideOpenButton.addEventListener('click', () => this.openCoordinateGuideDialog());
      }
      if (this.nodes.previewButton) {
        this.nodes.previewButton.addEventListener('click', () => this.handlePreviewClick());
      }
      this.nodes.standardPreviewViewButtons.forEach((button) => {
        button.addEventListener('click', () => this.setStandardPreviewView(button.dataset.standardPreviewView));
      });
      if (this.nodes.specToggle) {
        this.nodes.specToggle.addEventListener('click', () => this.toggleSpecBlock());
      }
      this.nodes.guideCloseButtons.forEach((button) => {
        button.addEventListener('click', () => this.closeGuideDialog());
      });
      this.nodes.coordinateGuideCloseButtons.forEach((button) => {
        button.addEventListener('click', () => this.closeCoordinateGuideDialog());
      });
      this.nodes.terrainReminderCloseButtons.forEach((button) => {
        button.addEventListener('click', () => this.closeTerrainReminderDialog());
      });
      if (this.nodes.terrainReminderGetMapButton) {
        this.nodes.terrainReminderGetMapButton.addEventListener('click', () => {
          this.closeTerrainReminderDialog({ restoreFocus: false });
          this.recordHistoryChangeAsync(() => this.handleGetMapClick());
        });
      }
      if (this.nodes.centerMapButton) {
        this.nodes.centerMapButton.addEventListener('click', () => this.recordHistoryChange(() => this.resetTerrainMapOffset()));
      }
      if (this.nodes.resetPointButton) {
        this.nodes.resetPointButton.addEventListener('click', () => this.recordHistoryChange(() => this.resetTerrainAnnotationPoint()));
      }
      this.nodes.terrainScaleControls.forEach((control) => {
        control.addEventListener('change', () => this.recordHistoryChange(() => this.handleTerrainScaleChange(control)));
      });
      this.nodes.customizationModeButtons.forEach((button) => {
        button.addEventListener('click', () => this.preserveWindowScrollDuring(() => (
          this.recordHistoryChange(() => this.handleCustomizationModeClick(button.dataset.patchCustomizationMode))
        )));
      });
      this.nodes.standardComboButtons.forEach((button) => {
        button.addEventListener('click', () => this.preserveWindowScrollDuring(() => (
          this.recordHistoryChange(() => this.applyStandardCombo(button.dataset.patchStandardCombo))
        )));
      });
      this.nodes.standardTerrainButtons.forEach((button) => {
        button.addEventListener('click', () => this.recordHistoryChangeAsync(() => this.handleStandardTerrainClick(button.dataset.patchStandardTerrain)));
      });
      this.nodes.randomTerrainButtons.forEach((button) => {
        button.addEventListener('click', () => this.recordHistoryChangeAsync(() => this.handleRandomTerrainClick()));
      });
      if (this.nodes.scaleBarToggle) {
        this.nodes.scaleBarToggle.addEventListener('change', () => this.recordHistoryChange(() => this.handleScaleBarToggleChange()));
      }
      if (this.nodes.shareButton) {
        this.nodes.shareButton.addEventListener('click', () => this.handleShareClick());
      }
      if (this.nodes.shareDownload) {
        this.nodes.shareDownload.addEventListener('click', () => this.handleShareDownloadClick());
      }
      if (this.nodes.shareSystem) {
        this.nodes.shareSystem.addEventListener('click', () => this.handleSystemShareClick());
      }
      this.nodes.form.addEventListener('keydown', (event) => this.handleFormKeydown(event));
      if (this.nodes.submitButton) {
        this.nodes.submitButton.addEventListener('click', () => {
          this.isAddSubmitIntent = true;
        });
      }
      this.bindVariantChangeEvents();
      this.nodes.form.addEventListener('submit', (event) => this.prepareSubmit(event));
      document.addEventListener('click', (event) => {
        if (!this.nodes.shareControl || this.nodes.shareControl.contains(event.target)) return;
        this.closeShareMenu();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeShareMenu();
          this.closePreviewDialog();
          this.closeGuideDialog();
          this.closeTerrainReminderDialog();
        }
        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'z' && this.root.contains(document.activeElement)) {
          if (this.isEditableHistoryTarget(document.activeElement)) return;
          event.preventDefault();
          if (event.shiftKey) {
            this.redoEdit();
          } else {
            this.undoEdit();
          }
        }
      });
      window.addEventListener('resize', () => this.fitStage());
    }

    bindVariantChangeEvents() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
        if (!data) return;
        if (this.nodes.productInfo && data.sectionId && data.sectionId !== this.nodes.productInfo.dataset.section) return;

        this.handleProductVariantChange(data.variant);
      });
    }

    handleProductVariantChange(variant) {
      if (!variant) {
        this.config.variant_id = '';
        if (this.nodes.variantId) {
          this.nodes.variantId.value = '';
          this.nodes.variantId.disabled = true;
        }
        this.updateCommercePrice(null);
        this.syncPurchaseAvailability(null);
        this.setSubmitButtonAvailability(false, this.getSubmitButtonLabel('unavailable'));
        return;
      }

      if (this.isHiddenCaseVariant(variant) && this.selectVisibleCaseColorFallback()) return;

      this.config.variant_id = variant.id;
      this.syncVariantOptionState();
      this.populateHardwareColorOptions();
      this.syncCustomizationModeUi({ loadStandardTerrain: this.isStandardCustomizationMode() && !this.hasTerrainForCurrentSelection() });
      if (this.nodes.variantId) {
        this.nodes.variantId.value = variant.id;
        this.nodes.variantId.disabled = !variant.available;
        this.nodes.variantId.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.updateCommercePrice(variant);
      this.syncPurchaseAvailability(variant);
      this.setSubmitButtonAvailability(
        Boolean(variant.available),
        variant.available ? this.getSubmitButtonLabel('default') : this.getSubmitButtonLabel('soldOut')
      );
    }

    formatVariantMoney(cents) {
      const amount = Number(cents);
      if (!Number.isFinite(amount)) return '';

      const currency = this.config.currency || 'USD';
      try {
        return `${new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency
        }).format(amount / 100)} ${currency}`;
      } catch (error) {
        return `$${(amount / 100).toFixed(2)} ${currency}`;
      }
    }

    updateCommercePrice(variant) {
      if (!this.nodes.commercePrice) return;

      if (!variant) {
        this.nodes.commercePrice.innerHTML = '';
        return;
      }

      const price = this.formatVariantMoney(variant.price);
      const compareAtPrice = Number(variant.compare_at_price || 0) > Number(variant.price || 0)
        ? this.formatVariantMoney(variant.compare_at_price)
        : '';
      const isAvailable = Boolean(variant.available);
      const soldOutBadge = isAvailable ? '' : '<span class="badge price__badge-sold-out color-scheme-3">Sold out</span>';
      const compareMarkup = compareAtPrice
        ? `<span class="visually-hidden visually-hidden--inline">Regular price</span><span><s class="price-item price-item--regular">${compareAtPrice}</s></span>`
        : '';

      this.nodes.commercePrice.innerHTML = `
        <div class="price price--large${compareAtPrice ? ' price--on-sale' : ''}${isAvailable ? '' : ' price--sold-out'}">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span class="price-item price-item--regular">${price}</span>
            </div>
            <div class="price__sale">
              ${compareMarkup}
              <span class="visually-hidden visually-hidden--inline">Sale price</span>
              <span class="price-item price-item--sale price-item--last">${price}</span>
            </div>
          </div>
          ${soldOutBadge}
        </div>
      `;
    }

    syncPurchaseAvailability(variant) {
      const isAvailable = Boolean(variant && variant.available);
      const state = isAvailable ? 'available' : 'sold-out';

      if (this.nodes.purchaseRow) {
        this.nodes.purchaseRow.dataset.patchPurchaseState = state;
      }
      if (this.nodes.commerceControls) {
        this.nodes.commerceControls.dataset.patchPurchaseState = state;
      }
      if (this.nodes.quantity) {
        const shouldShowQuantity = Boolean(variant);
        this.nodes.quantity.hidden = !shouldShowQuantity;
        if (shouldShowQuantity) {
          this.nodes.quantity.querySelectorAll('button, input').forEach((control) => {
            control.disabled = !isAvailable;
            control.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
          });
        }
      }
      if (this.nodes.inventory) {
        this.nodes.inventory.hidden = !isAvailable;
      }
    }

    getSubmitButtonLabel(state) {
      if (!this.nodes.submitButton) return '';

      if (state === 'soldOut') {
        return this.nodes.submitButton.dataset.patchSoldOutLabel || 'Sold out';
      }
      if (state === 'unavailable') {
        return this.nodes.submitButton.dataset.patchUnavailableLabel || 'Unavailable';
      }

      return this.nodes.submitButton.dataset.patchSubmitLabel || 'Add to Cart';
    }

    setSubmitButtonAvailability(isAvailable, label) {
      if (!this.nodes.submitButton) return;

      this.nodes.submitButton.disabled = !isAvailable;
      if (!isAvailable) {
        this.nodes.submitButton.setAttribute('aria-disabled', 'true');
      } else {
        this.nodes.submitButton.removeAttribute('aria-disabled');
      }
      if (this.nodes.submitButtonText && label) {
        this.nodes.submitButtonText.textContent = label;
      }
    }

    openGuideDialog() {
      if (!this.nodes.guideDialog) return;

      this.nodes.guideDialog.hidden = false;
      if (this.nodes.guideOpenButton) {
        this.nodes.guideOpenButton.setAttribute('aria-expanded', 'true');
      }

      const closeButton = this.nodes.guideCloseButtons.find((button) => button.classList.contains('smallsmore-patch-customizer__guide-close'));
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    closeGuideDialog(options = {}) {
      if (!this.nodes.guideDialog || this.nodes.guideDialog.hidden) return;

      this.nodes.guideDialog.hidden = true;
      if (this.nodes.guideOpenButton) {
        this.nodes.guideOpenButton.setAttribute('aria-expanded', 'false');
        if (options.restoreFocus !== false) this.nodes.guideOpenButton.focus({ preventScroll: true });
      }
    }

    openCoordinateGuideDialog() {
      if (!this.nodes.coordinateGuideDialog) return;

      this.closeGuideDialog({ restoreFocus: false });
      this.closeTerrainReminderDialog({ restoreFocus: false });
      this.nodes.coordinateGuideDialog.hidden = false;
      if (this.nodes.coordinateGuideOpenButton) {
        this.nodes.coordinateGuideOpenButton.setAttribute('aria-expanded', 'true');
      }

      const closeButton = this.nodes.coordinateGuideCloseButtons.find((button) => button.classList.contains('smallsmore-patch-customizer__guide-close'));
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    closeCoordinateGuideDialog(options = {}) {
      if (!this.nodes.coordinateGuideDialog || this.nodes.coordinateGuideDialog.hidden) return;

      this.nodes.coordinateGuideDialog.hidden = true;
      if (this.nodes.coordinateGuideOpenButton) {
        this.nodes.coordinateGuideOpenButton.setAttribute('aria-expanded', 'false');
        if (options.restoreFocus !== false) this.nodes.coordinateGuideOpenButton.focus({ preventScroll: true });
      }
    }

    openTerrainReminderDialog() {
      if (!this.nodes.terrainReminderDialog) return;

      this.closeGuideDialog({ restoreFocus: false });
      this.closeCoordinateGuideDialog({ restoreFocus: false });
      this.closeShareMenu();
      this.nodes.terrainReminderDialog.hidden = false;

      if (this.nodes.terrainReminderGetMapButton) {
        this.nodes.terrainReminderGetMapButton.disabled = Boolean(this.terrainPromise);
        this.nodes.terrainReminderGetMapButton.focus({ preventScroll: true });
      }
    }

    closeTerrainReminderDialog(options = {}) {
      if (!this.nodes.terrainReminderDialog || this.nodes.terrainReminderDialog.hidden) return;

      this.nodes.terrainReminderDialog.hidden = true;
      if (options.restoreFocus !== false && this.nodes.submitButton) {
        this.nodes.submitButton.focus({ preventScroll: true });
      }
    }

    toggleSpecBlock() {
      if (!this.nodes.specBlock || !this.nodes.specToggle) return;
      const isExpanded = !this.nodes.specBlock.classList.contains('is-expanded');
      this.nodes.specBlock.classList.toggle('is-expanded', isExpanded);
      this.nodes.specToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      this.nodes.specToggle.setAttribute('aria-label', isExpanded ? 'Show less technical details' : 'Show all technical details');
    }

    handleShareClick() {
      this.toggleShareMenu();
    }

    toggleShareMenu() {
      if (!this.nodes.shareMenu || !this.nodes.shareButton) return;

      const shouldOpen = this.nodes.shareMenu.hidden;
      this.nodes.shareMenu.hidden = !shouldOpen;
      this.nodes.shareButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      if (shouldOpen) {
        const firstItem = this.nodes.shareMenu.querySelector('button, [href], [tabindex]:not([tabindex="-1"])');
        if (firstItem) firstItem.focus({ preventScroll: true });
      } else if (this.nodes.shareControl && this.nodes.shareControl.contains(document.activeElement)) {
        this.nodes.shareButton.focus({ preventScroll: true });
      }
    }

    closeShareMenu() {
      const shouldRestoreFocus = Boolean(this.nodes.shareMenu && !this.nodes.shareMenu.hidden && this.nodes.shareControl && this.nodes.shareControl.contains(document.activeElement));
      if (this.nodes.shareMenu) this.nodes.shareMenu.hidden = true;
      if (this.nodes.shareButton) this.nodes.shareButton.setAttribute('aria-expanded', 'false');
      if (shouldRestoreFocus && this.nodes.shareButton) this.nodes.shareButton.focus({ preventScroll: true });
    }

    async handlePreviewClick() {
      if (!this.nodes.previewButton) return;

      this.closeShareMenu();
      this.closeGuideDialog({ restoreFocus: false });
      this.closeTerrainReminderDialog({ restoreFocus: false });

      const buttonLabel = this.nodes.previewButton.textContent;
      this.nodes.previewButton.disabled = true;
      this.nodes.previewButton.textContent = 'Preparing...';

      try {
        const blob = await this.prepareSharePreviewBlob(SHARE_PREVIEW_SIZE);
        this.openPreviewDialog(blob);
      } catch (error) {
        this.setShareStatus('Could not prepare preview.');
      } finally {
        this.nodes.previewButton.disabled = false;
        this.nodes.previewButton.textContent = buttonLabel;
      }
    }

    getPreviewDialog() {
      if (this.previewDialog) return this.previewDialog;

      const dialog = document.createElement('div');
      dialog.className = 'smallsmore-patch-customizer__preview-dialog';
      dialog.hidden = true;
      dialog.setAttribute('data-patch-preview-dialog', '');
      dialog.innerHTML = [
        '<button class="smallsmore-patch-customizer__preview-dialog-backdrop" type="button" aria-label="Close preview" data-patch-preview-close></button>',
        '<div class="smallsmore-patch-customizer__preview-dialog-panel" role="dialog" aria-modal="true" aria-label="Custom case preview">',
        '<button class="smallsmore-patch-customizer__preview-dialog-close" type="button" aria-label="Close preview" data-patch-preview-close>&times;</button>',
        '<img class="smallsmore-patch-customizer__preview-dialog-image" alt="Customized case preview" data-patch-preview-image>',
        '</div>'
      ].join('');
      dialog.querySelectorAll('[data-patch-preview-close]').forEach((button) => {
        button.addEventListener('click', () => this.closePreviewDialog());
      });
      document.body.append(dialog);
      this.previewDialog = dialog;
      return dialog;
    }

    openPreviewDialog(blob) {
      const dialog = this.getPreviewDialog();
      const image = dialog.querySelector('[data-patch-preview-image]');
      if (!image || !blob) return;

      this.revokePreviewImageUrl();
      this.previewImageUrl = URL.createObjectURL(blob);
      image.src = this.previewImageUrl;
      dialog.hidden = false;
      const closeButton = dialog.querySelector('[data-patch-preview-close]:not(.smallsmore-patch-customizer__preview-dialog-backdrop)');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    closePreviewDialog(options = {}) {
      if (!this.previewDialog || this.previewDialog.hidden) return;

      this.previewDialog.hidden = true;
      const image = this.previewDialog.querySelector('[data-patch-preview-image]');
      if (image) image.removeAttribute('src');
      this.revokePreviewImageUrl();
      if (options.restoreFocus !== false && this.nodes.previewButton) {
        this.nodes.previewButton.focus({ preventScroll: true });
      }
    }

    revokePreviewImageUrl() {
      if (!this.previewImageUrl) return;

      URL.revokeObjectURL(this.previewImageUrl);
      this.previewImageUrl = '';
    }

    async handleShareDownloadClick() {
      this.closeShareMenu();
      this.setShareStatus('Preparing image...');

      try {
        const blob = await this.prepareSharePreviewBlob(SHARE_DOWNLOAD_SIZE);
        this.downloadSharePreview(blob);
        this.setShareStatus('Image downloaded.');
      } catch (error) {
        this.setShareStatus('Could not prepare image.');
      }
    }

    async handleSystemShareClick() {
      this.closeShareMenu();
      this.setShareStatus('Preparing image...');

      try {
        const blob = await this.prepareSharePreviewBlob(SHARE_PREVIEW_SIZE);

        if (typeof File === 'function' && navigator.canShare && navigator.share) {
          const file = new File([blob], 'smallsmore-custom-case.png', { type: 'image/png' });

          if (navigator.canShare({ files: [file] })) {
            await navigator.share({
              files: [file],
              title: 'smallsmore custom case',
              text: SHARE_COPY
            });
            this.setShareStatus('Ready to share.');
            return;
          }
        }

        const downloadBlob = await this.prepareSharePreviewBlob(SHARE_DOWNLOAD_SIZE);
        this.downloadSharePreview(downloadBlob);
        this.setShareStatus('Image downloaded.');
      } catch (error) {
        if (error && error.name === 'AbortError') {
          this.setShareStatus('');
          return;
        }
        this.setShareStatus('Could not prepare image.');
      }
    }

    async prepareSharePreviewBlob(outputSize = SHARE_PREVIEW_SIZE) {
      await this.ensureEditorFontsLoaded();

      const container = document.createElement('div');
      container.style.left = '-99999px';
      container.style.position = 'fixed';
      container.style.top = '0';
      document.body.append(container);

      const shareStage = new Konva.Stage({
        container,
        width: PREVIEW_WIDTH,
        height: PREVIEW_HEIGHT
      });
      const shareLayer = new Konva.Layer();
      shareStage.add(shareLayer);

      const previousLayer = this.layer;
      try {
        this.layer = shareLayer;
        this.drawHardwarePreview();
        this.drawPreviewPatch({ showTextGuide: false });
        shareLayer.draw();

        const dataUrl = shareStage.toDataURL({
          mimeType: 'image/png',
          pixelRatio: outputSize / PREVIEW_WIDTH
        });
        const response = await fetch(dataUrl);
        return response.blob();
      } finally {
        this.layer = previousLayer;
        shareStage.destroy();
        container.remove();
      }
    }

    downloadSharePreview(blob) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `smallsmore-custom-case-${Date.now().toString(36)}.png`;
      document.body.append(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    setShareStatus(message) {
      if (!this.nodes.shareStatus) return;

      window.clearTimeout(this.shareStatusTimer);
      this.nodes.shareStatus.textContent = message || '';
      if (message) {
        this.shareStatusTimer = window.setTimeout(() => {
          this.nodes.shareStatus.textContent = '';
        }, 3200);
      }
    }

    handleRegionInput() {
      this.clearPresetRegionInputValue();
      this.selectedTerrainLocation = null;
      this.terrainData = null;
      this.terrainDataRegion = '';
      this.terrainPromise = null;
      this.clearTerrainContourCache();
      this.clearTerrainAnnotationOverride();
      this.resetTerrainMapOffset({ silent: true });
      this.clearPreviewOverlay();
      this.updatePatchSteps();
      this.updateTerrainControls();
      this.updateTerrainQuickPicks();
      this.syncStandardInitialTerrainPalette();
      this.render();
      this.queueTerrainSuggestions();
    }

    syncRegionControls() {
      if (!this.nodes.showRegion || !this.nodes.region || this.isContourTemplate()) return;

      const isVisible = this.shouldShowRegionMark();
      this.nodes.region.disabled = !isVisible;
      this.nodes.region.setAttribute('aria-disabled', isVisible ? 'false' : 'true');
    }

    handleFormKeydown(event) {
      if (event.key !== 'Enter') return;

      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (['button', 'checkbox', 'color', 'file', 'hidden', 'radio', 'range', 'reset', 'submit'].includes(target.type)) return;

      event.preventDefault();
      target.blur();
    }

    createStage() {
      const previewSize = this.getPreviewSize();

      this.stage = new Konva.Stage({
        container: this.nodes.stage,
        width: previewSize.width,
        height: previewSize.height
      });
      this.layer = new Konva.Layer();
      this.stage.add(this.layer);
      this.bindTerrainDragEvents();
      this.fitStage();
    }

    handleLocationModeChange() {
      this.selectedTerrainLocation = null;
      this.terrainData = null;
      this.terrainDataRegion = '';
      this.terrainPromise = null;
      this.clearTerrainContourCache();
      this.clearTerrainAnnotationOverride();
      this.resetTerrainMapOffset({ silent: true });
      this.terrainSuggestions = [];
      this.renderTerrainSuggestions();
      this.syncLocationModeUi();
      this.clearPreviewOverlay();
      this.updatePatchSteps();
      this.updateTerrainControls();
      this.updateTerrainQuickPicks();
      this.syncStandardInitialTerrainPalette();
      this.render();

      if (this.isCoordinateInputMode()) {
        this.updateSuggestionStatus(this.getCoordinateTerrainLocation() ? 'Click Get the map to generate contours.' : '');
        return;
      }

      this.updateSuggestionStatus('');
      this.queueTerrainSuggestions({ immediate: true });
    }

    handleCoordinateInput() {
      if (!this.isCoordinateInputMode()) return;

      this.selectedTerrainLocation = null;
      this.terrainData = null;
      this.terrainDataRegion = '';
      this.terrainPromise = null;
      this.clearTerrainContourCache();
      this.clearTerrainAnnotationOverride();
      this.resetTerrainMapOffset({ silent: true });
      this.clearPreviewOverlay();
      this.updateSuggestionStatus(this.getCoordinateTerrainLocation() ? 'Click Get the map to generate contours.' : (this.nodes.coordinates.value.trim() ? 'Use a valid decimal format, for example 52.764514, -1.231579.' : ''));
      this.updatePatchSteps();
      this.updateTerrainControls();
      this.syncStandardInitialTerrainPalette();
      this.render();
    }

    handleCoordinateLabelInput() {
      if (!this.isCoordinateInputMode()) return;

      const label = this.getCoordinateLabelText();
      if (this.selectedTerrainLocation && this.selectedTerrainLocation.feature_code === 'COORD') {
        this.selectedTerrainLocation.name = label;
        this.selectedTerrainLocation.display_name = this.getCoordinateDisplayName(this.selectedTerrainLocation.latitude, this.selectedTerrainLocation.longitude, label);
      }
      if (this.terrainData && this.terrainData.location && this.terrainData.location.feature_code === 'COORD') {
        this.terrainData.location.name = label;
        this.terrainData.location.display_name = this.getCoordinateDisplayName(this.terrainData.location.latitude, this.terrainData.location.longitude, label);
        this.terrainData.query = this.terrainData.location.display_name;
      }

      this.clearTerrainContourCache();
      this.updatePatchSteps();
      this.updateTerrainControls();
      this.render();
    }

    handleTerrainScaleChange(control) {
      const nextScale = this.normalizeTerrainScale(control && control.value);
      if (nextScale === this.terrainScale) {
        this.syncTerrainScaleControls();
        return;
      }

      this.terrainScale = nextScale;
      this.syncTerrainScaleControls();
      this.clearTerrainContourCache();
      this.updateTerrainControls();
      this.render();

      if (this.hasTerrainForCurrentSelection()) {
        this.updateSuggestionStatus('Map scale updated. Drag the terrain to adjust placement.');
      }
    }

    handleScaleBarToggleChange() {
      this.terrainScaleBarVisible = Boolean(this.nodes.scaleBarToggle && this.nodes.scaleBarToggle.checked);
      this.render();
    }

    bindTerrainDragEvents() {
      if (!this.stage) return;

      this.stage.on('mousedown touchstart', (event) => this.handleTerrainDragStart(event));
      this.stage.on('mousemove touchmove', (event) => this.handleTerrainDragMove(event));
      this.stage.on('mouseup touchend touchcancel mouseleave', () => this.handleTerrainDragEnd());
    }

    handleTerrainDragStart(event) {
      if (!this.canMoveTerrainMap()) return;

      const point = this.getPatchPointerPosition();
      if (!this.isPointInTerrainDragArea(point)) return;

      const annotation = this.getTerrainDisplayAnnotation();
      if (this.isPointNearTerrainAnnotation(point, annotation)) {
        this.terrainDrag = {
          type: 'annotation',
          historySnapshot: this.captureHistorySnapshot(),
          hasMoved: false
        };
        if (this.nodes.stage) this.nodes.stage.classList.add('is-terrain-annotation-dragging');
        if (event && event.evt && typeof event.evt.preventDefault === 'function') {
          event.evt.preventDefault();
        }
        return;
      }

      this.terrainDrag = {
        type: 'map',
        historySnapshot: this.captureHistorySnapshot(),
        startPoint: point,
        startOffset: this.getTerrainMapOffset()
      };
      if (this.nodes.stage) this.nodes.stage.classList.add('is-terrain-dragging');
      if (event && event.evt && typeof event.evt.preventDefault === 'function') {
        event.evt.preventDefault();
      }
    }

    handleTerrainDragMove(event) {
      if (!this.terrainDrag) return;

      const point = this.getPatchPointerPosition();
      if (!point) return;

      if (this.terrainDrag.type === 'annotation') {
        if (!this.isPointInTerrainDragArea(point)) return;
        if (this.setTerrainAnnotationOverrideFromPoint(point)) {
          this.terrainDrag.hasMoved = true;
        }
        if (event && event.evt && typeof event.evt.preventDefault === 'function') {
          event.evt.preventDefault();
        }
        return;
      }

      const nextOffset = {
        x: this.terrainDrag.startOffset.x + point.x - this.terrainDrag.startPoint.x,
        y: this.terrainDrag.startOffset.y + point.y - this.terrainDrag.startPoint.y
      };
      this.setTerrainMapOffset(nextOffset);
      if (event && event.evt && typeof event.evt.preventDefault === 'function') {
        event.evt.preventDefault();
      }
    }

    handleTerrainDragEnd() {
      if (!this.terrainDrag) return;

      const wasAnnotationDrag = this.terrainDrag.type === 'annotation';
      const didMoveAnnotation = wasAnnotationDrag && this.terrainDrag.hasMoved;
      const historySnapshot = this.terrainDrag.historySnapshot;
      this.terrainDrag = null;
      if (this.nodes.stage) {
        this.nodes.stage.classList.remove('is-terrain-dragging');
        this.nodes.stage.classList.remove('is-terrain-annotation-dragging');
      }
      if (didMoveAnnotation) {
        this.updateSuggestionStatus('Point adjusted. Use Reset point to restore the selected location.');
      }
      this.commitHistoryCapture(historySnapshot);
    }

    getPatchPointerPosition() {
      if (!this.stage) return null;

      const pointer = this.stage.getPointerPosition();
      if (!pointer) return null;

      const stageScaleX = this.stage.scaleX() || 1;
      const stageScaleY = this.stage.scaleY() || stageScaleX;
      const placement = this.getPatchPlacement();
      const previewX = pointer.x / stageScaleX;
      const previewY = pointer.y / stageScaleY;
      const patchScaleX = placement.width / BASE_WIDTH;
      const patchScaleY = placement.height / BASE_HEIGHT;

      return {
        x: (previewX - placement.x) / patchScaleX,
        y: (previewY - placement.y) / patchScaleY
      };
    }

    isPointInTerrainDragArea(point) {
      if (!point) return false;
      if (point.x < 0 || point.x > BASE_WIDTH || point.y < 0 || point.y > BASE_HEIGHT) return false;

      return !this.isPointInTransparentWindow(point);
    }

    isPointInTransparentWindow(point) {
      return point.x >= 224 && point.x <= 1012 && point.y <= 837;
    }

    fitStage() {
      if (!this.stage || !this.nodes.stage) return;

      const previewSize = this.getPreviewSize();
      const width = this.nodes.stage.clientWidth || 480;
      const scale = width / previewSize.width;
      const height = previewSize.height * scale;

      this.nodes.stage.style.height = `${height}px`;
      this.stage.width(width);
      this.stage.height(height);
      this.stage.scale({ x: scale, y: scale });
      this.stage.draw();
      this.updatePreviewOverlayBounds();
    }

    loadEditorFonts() {
      this.ensureEditorFontsLoaded().then(() => {
        this.render();
      }).catch(() => {});
    }

    ensureEditorFontsLoaded() {
      if (!document.fonts || typeof document.fonts.load !== 'function') return Promise.resolve();

      if (!this.editorFontsLoadPromise) {
        this.editorFontsLoadPromise = Promise.allSettled(
          CUSTOM_TEXT_FONT_LOADS.map((font) => document.fonts.load(font))
        ).then((results) => {
          const failedFonts = results
            .map((result, index) => (result.status === 'rejected' ? CUSTOM_TEXT_FONT_LOADS[index] : ''))
            .filter(Boolean);

          if (failedFonts.length && window.console && typeof window.console.warn === 'function') {
            window.console.warn('smallsmore patch customizer fonts failed to load:', failedFonts);
          }

          return results;
        });
      }

      return this.editorFontsLoadPromise;
    }

    applyPalette(paletteId, options = {}) {
      const nextPalette = this.getPalettes().find((palette) => palette.id === paletteId) || this.getPalettes()[0];
      this.activePalette = nextPalette;
      if (this.root) this.root.style.setProperty('--sm-patch-current-text-color', this.getPaletteColor('text'));
      this.updatePaletteButtons();
      this.updatePatchSteps();
      if (options.render !== false) this.render();
    }

    updatePaletteButtons() {
      if (!this.nodes.palettes || !this.activePalette) return;

      this.nodes.palettes.querySelectorAll('[data-patch-palette]').forEach((button) => {
        const isActive = button.dataset.patchPalette === this.activePalette.id;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    updatePatchSteps() {
      if (!this.nodes.steps || !this.nodes.steps.length) return;

      const completedSteps = {
        theme: Boolean(this.getTemplateId()),
        'main-text': Boolean(this.getMainText()),
        'bottom-font': Boolean(this.getSelectedTextFont()),
        'side-text': Boolean(this.getSideText()),
        'bottom-text': this.bottomTextSkipped || Boolean(this.getBottomText()),
        region: this.isContourTemplate() ? Boolean(this.selectedTerrainLocation || this.getCoordinateTerrainLocation() || this.hasTerrainForCurrentSelection()) : (!this.shouldShowRegionMark() || Boolean(this.getRegionText())),
        'standard-terrain': this.isStandardCustomizationMode() ? Boolean(this.hasTerrainForCurrentSelection()) : Boolean(this.selectedTerrainLocation || this.isRandomPatternTerrain()),
        'terrain-choice': this.isStandardCustomizationMode() ? true : Boolean(this.selectedTerrainLocation || this.isRandomPatternTerrain() || this.hasPendingTerrainInput()),
        'hardware-colors': Boolean(this.getActiveCaseColor() && this.getActivePatchColor() && this.getActiveButtonColor()),
        palette: Boolean(this.activePalette)
      };

      this.nodes.steps.forEach((step) => {
        const stepId = step.dataset.patchStep;
        const isComplete = Boolean(completedSteps[stepId]);
        step.classList.toggle('is-complete', isComplete);
      });
      this.updatePatchStepCollapseUi();
    }

    setupPatchStepToggles() {
      if (!this.nodes.steps || !this.nodes.steps.length) return;

      this.nodes.steps.forEach((step) => {
        const stepId = step.dataset.patchStep;
        if (!this.collapsiblePatchStepIds.includes(stepId)) return;
        if (step.querySelector(':scope > [data-patch-step-toggle]')) return;

        const label = step.querySelector(':scope > .smallsmore-patch-customizer__label');
        const labelText = (label ? label.textContent : 'Step').trim().replace(/\s+/g, ' ');
        const toggle = document.createElement('button');
        toggle.className = 'smallsmore-patch-customizer__step-toggle';
        toggle.type = 'button';
        toggle.dataset.patchStepToggle = stepId;
        toggle.setAttribute('aria-expanded', 'true');

        const title = document.createElement('span');
        title.className = 'smallsmore-patch-customizer__step-toggle-title';
        title.textContent = labelText;

        const summary = document.createElement('span');
        summary.className = 'smallsmore-patch-customizer__step-summary';
        summary.dataset.patchStepSummary = stepId;

        const icon = document.createElement('span');
        icon.className = 'smallsmore-patch-customizer__step-toggle-icon';
        icon.setAttribute('aria-hidden', 'true');

        toggle.append(title, summary, icon);
        toggle.addEventListener('click', () => this.togglePatchStep(stepId));
        step.classList.add('has-collapse-toggle');
        step.insertBefore(toggle, step.firstChild);
      });

      this.initializePatchStepAccordion();
    }

    initializePatchStepAccordion() {
      const activeStepId = this.activePatchStepId || this.collapsiblePatchStepIds[0];
      this.setActivePatchStep(activeStepId, { silent: true });
    }

    togglePatchStep(stepId) {
      if (!this.collapsiblePatchStepIds.includes(stepId)) return;
      this.setActivePatchStep(stepId);
    }

    setActivePatchStep(stepId, options = {}) {
      if (!this.collapsiblePatchStepIds.includes(stepId)) return;
      this.activePatchStepId = stepId;
      this.collapsedPatchSteps = new Set(this.collapsiblePatchStepIds.filter((id) => id !== stepId));
      if (!options.silent) this.updatePatchStepCollapseUi();
    }

    getPatchStepSummary(stepId) {
      if (stepId === 'hardware-colors') {
        const caseColor = this.getActiveCaseColor();
        const patchColor = this.getActivePatchColor();
        const buttonColor = this.getActiveButtonColor();
        if (this.isPureColorTemplate()) {
          return [
            caseColor && `${caseColor.label} case frame`,
            patchColor && `${patchColor.label} back design`,
            buttonColor && `${buttonColor.label} buttons`
          ].filter(Boolean).join(' / ');
        }
        return [caseColor && `${caseColor.label} case frame`, buttonColor && `${buttonColor.label} buttons`].filter(Boolean).join(' / ');
      }

      if (stepId === 'palette') {
        return this.activePalette && this.activePalette.label ? this.activePalette.label : '';
      }

      if (stepId === 'terrain-choice') {
        if (this.isRandomPatternTerrain()) return RANDOM_TERRAIN_PATTERN_LABEL;
        if (!this.isStandardCustomizationMode() && this.selectedTerrainLocation) return this.selectedTerrainLocation.name || this.selectedTerrainLocation.display_name || '';
        if (!this.isStandardCustomizationMode()) return this.hasPendingTerrainInput() ? 'Custom location' : '';
        const location = this.getStandardTerrainLocation();
        return location && location.name ? location.name : '';
      }

      return '';
    }

    updatePatchStepCollapseUi() {
      if (!this.nodes.steps || !this.nodes.steps.length) return;

      this.nodes.steps.forEach((step) => {
        const stepId = step.dataset.patchStep;
        if (!this.collapsiblePatchStepIds.includes(stepId)) return;

        const isCollapsed = this.collapsedPatchSteps.has(stepId);
        const toggle = step.querySelector(':scope > [data-patch-step-toggle]');
        const summary = step.querySelector(':scope > [data-patch-step-toggle] [data-patch-step-summary]');
        const icon = step.querySelector(':scope > [data-patch-step-toggle] .smallsmore-patch-customizer__step-toggle-icon');

        step.classList.toggle('is-collapsed', isCollapsed);
        if (toggle) toggle.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
        if (summary) summary.textContent = this.getPatchStepSummary(stepId);
        if (icon) icon.textContent = isCollapsed ? '+' : '-';
      });
    }

    getMainText() {
      const lines = this.getMainTextLines();
      return lines.filter(Boolean).join('\n');
    }

    getMainTextLines() {
      const primary = this.getMainTextPrimary();
      const secondary = this.getMainTextSecondary();
      return [primary, secondary];
    }

    getMainTextPrimary() {
      if (!this.nodes.mainText) return DEFAULT_MAIN_TEXT;
      const value = this.nodes.mainText.value.trim().replace(/\s+/g, ' ');
      return value || DEFAULT_MAIN_TEXT;
    }

    getMainTextSecondary() {
      if (!this.nodes.mainTextSecondary) return '';
      const value = this.nodes.mainTextSecondary.value.trim().replace(/\s+/g, ' ');
      return value || DEFAULT_MAIN_TEXT_SECONDARY;
    }

    normalizeMainTextInputs() {
      if (!this.nodes.mainText) return;

      const primary = this.nodes.mainText.value.trim().replace(/\s+/g, ' ');
      const secondary = this.nodes.mainTextSecondary ? this.nodes.mainTextSecondary.value.trim().replace(/\s+/g, ' ') : '';
      if (this.nodes.mainTextSecondary && primary === 'Portable Input Terminal' && secondary === DEFAULT_MAIN_TEXT_SECONDARY) {
        this.nodes.mainText.value = DEFAULT_MAIN_TEXT;
      }

      this.limitInputLength(this.nodes.mainText);
      this.limitMainTextInputsWidth();
      if (this.nodes.mainTextSecondary) this.limitInputLength(this.nodes.mainTextSecondary);
    }

    limitInputLength(input) {
      if (!input || !Number.isFinite(input.maxLength) || input.maxLength < 0) return;
      if (input.value.length > input.maxLength) {
        input.value = input.value.slice(0, input.maxLength);
      }
    }

    limitMainTextInputWidth(input, fontSize) {
      if (!input) return;
      const fontFamily = this.getSelectedTextFont();
      const fontStyle = this.getSelectedTextFontStyle();
      let value = input.value.trimStart().replace(/\s+/g, ' ');

      while (
        value.length > 1
        && this.measureTextWidth(value.trim(), fontSize, fontFamily, fontStyle) > MAIN_TEXT_AREA.width
      ) {
        value = value.slice(0, -1);
      }

      if (input.value !== value) input.value = value;
    }

    limitMainTextInputsWidth() {
      this.limitMainTextInputWidth(this.nodes.mainText, MAIN_TEXT_AREA.topFontSize);
      this.limitMainTextInputWidth(this.nodes.mainTextSecondary, MAIN_TEXT_AREA.bottomFontSize);
    }

    getSideText() {
      if (!this.nodes.sideText) return DEFAULT_SIDE_TEXT;
      const value = this.nodes.sideText.value.trim().replace(/\s+/g, ' ');
      return value || DEFAULT_SIDE_TEXT;
    }

    getBottomText() {
      if (this.isStandardCustomizationMode()) return this.isPureColorTemplate() ? '' : 'smallsmore';
      if (this.bottomTextSkipped) return '';
      if (!this.nodes.bottomText) return '';
      return this.nodes.bottomText.value
        .trim()
        .split(/\n+/)
        .map((line) => line.trim().replace(/\s+/g, ' '))
        .filter(Boolean)
        .slice(0, 3)
        .join('\n');
    }

    syncBottomTextSkipControls() {
      if (this.nodes.bottomTextControls) {
        this.nodes.bottomTextControls.hidden = this.bottomTextSkipped;
        this.nodes.bottomTextControls.setAttribute('aria-hidden', this.bottomTextSkipped ? 'true' : 'false');
      }

      if (this.nodes.bottomTextSkip) {
        this.nodes.bottomTextSkip.textContent = this.bottomTextSkipped ? 'Add text' : 'Skip';
        this.nodes.bottomTextSkip.setAttribute('aria-pressed', this.bottomTextSkipped ? 'true' : 'false');
      }
    }

    setBottomTextSkipped(isSkipped) {
      this.bottomTextSkipped = Boolean(isSkipped);
      this.syncBottomTextSkipControls();

      if (this.bottomTextSkipped && this.nodes.bottomText) {
        this.nodes.bottomText.value = '';
      }

      this.updatePatchSteps();
      this.render();

      if (!this.bottomTextSkipped && this.nodes.bottomText) {
        this.nodes.bottomText.focus();
      }
    }

    needsBottomTextBeforeSubmit() {
      return Boolean(
        this.isBottomTextTemplate()
          && !this.isStandardCustomizationMode()
          && this.nodes.bottomText
          && this.nodes.bottomTextSkip
          && !this.bottomTextSkipped
          && !this.getBottomText()
      );
    }

    promptForBottomTextBeforeSubmit() {
      if (!this.needsBottomTextBeforeSubmit()) return false;

      this.setStatus('Add bottom text, or click Skip if you do not want bottom text.', 'error');
      this.updatePatchSteps();
      this.render();
      this.nodes.bottomText.focus();
      return true;
    }

    syncTextSizeControls() {
      this.nodes.textSizeButtons.forEach((control) => {
        const isActive = (control.dataset.patchTextSize || 'm') === this.textSizeId;
        control.classList.toggle('is-active', isActive);
        control.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    setTextSizeFromButton(button) {
      if (!button) return;

      this.textSizeId = button.dataset.patchTextSize || 'm';
      this.textSizeScale = Number(button.dataset.patchTextSizeScale) || 1;
      this.syncTextSizeControls();

      this.render();
    }

    getTextSizePayload() {
      return {
        id: this.textSizeId || 'm',
        scale: Number(this.textSizeScale) || 1
      };
    }

    getTextAlign() {
      return ['left', 'center', 'right'].includes(this.textAlign) ? this.textAlign : 'center';
    }

    getVisibleBottomTextLineCount() {
      const text = this.getBottomText();
      if (!text) return 0;
      return text.split('\n').filter(Boolean).length;
    }

    setTextAlignFromButton(button) {
      if (!button) return;

      const lineCount = this.getVisibleBottomTextLineCount();
      if (lineCount === 0) {
        this.clearTextAlignSingleLineTip();
        return;
      }

      if (lineCount === 1) {
        this.setTextAlign('center');
        this.showTextAlignSingleLineTip(button);
        return;
      }

      this.clearTextAlignSingleLineTip();
      this.setTextAlign(button.dataset.patchTextAlign || 'center');
    }

    clearTextAlignSingleLineTip() {
      window.clearTimeout(this.textAlignTipTimer);
      this.textAlignTipTimer = null;
      if (this.nodes.textAlignTipStatus) this.nodes.textAlignTipStatus.textContent = '';

      this.nodes.textAlignButtons.forEach((textAlignButton) => {
        textAlignButton.classList.remove('is-showing-align-tip', 'is-align-tap-feedback');
        textAlignButton.removeAttribute('data-patch-text-align-tip');
        textAlignButton.removeAttribute('aria-describedby');
      });
    }

    ensureTextAlignTipStatus() {
      if (this.nodes.textAlignTipStatus && this.nodes.textAlignTipStatus.isConnected) {
        return this.nodes.textAlignTipStatus;
      }

      const status = document.createElement('span');
      const textId = this.nodes.bottomText && this.nodes.bottomText.id ? this.nodes.bottomText.id : `smallsmore-patch-customizer-${Math.random().toString(36).slice(2)}`;
      status.id = `${textId}-align-tip`;
      status.className = 'smallsmore-patch-customizer__text-align-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      this.root.appendChild(status);
      this.nodes.textAlignTipStatus = status;
      return status;
    }

    showTextAlignSingleLineTip(button) {
      const message = 'Add a second line to use alignment.';

      this.clearTextAlignSingleLineTip();

      const status = this.ensureTextAlignTipStatus();
      button.setAttribute('data-patch-text-align-tip', message);
      button.setAttribute('aria-describedby', status.id);
      button.classList.add('is-showing-align-tip', 'is-align-tap-feedback');
      window.setTimeout(() => {
        if (this.nodes.textAlignTipStatus === status) status.textContent = message;
      }, 0);

      window.setTimeout(() => {
        button.classList.remove('is-align-tap-feedback');
      }, 360);

      this.textAlignTipTimer = window.setTimeout(() => {
        button.classList.remove('is-showing-align-tip');
        button.removeAttribute('data-patch-text-align-tip');
      }, 1800);
    }

    setTextAlign(align = 'center', options = {}) {
      this.textAlign = ['left', 'center', 'right'].includes(align) ? align : 'center';
      this.nodes.textAlignButtons.forEach((button) => {
        const isActive = (button.dataset.patchTextAlign || 'center') === this.textAlign;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (options.render !== false) this.render();
    }

    getBottomTextStyle() {
      const stroke = this.textStroke || '';
      return {
        align: this.getTextAlign(),
        colorId: this.textColorId || 'palette',
        fill: this.textColor || this.getPaletteColor('text'),
        stroke,
        strokeWidth: stroke ? Number(this.textStrokeWidth) || 5 : 0,
        strokeId: this.textStrokeId || 'none'
      };
    }

    getEffectiveBottomTextStyle() {
      if (!this.isStandardCustomizationMode()) return this.getBottomTextStyle();

      return {
        align: 'center',
        colorId: this.isPureColorTemplate() ? 'pure-color-standard-brand' : 'standard-bottom-brand',
        fill: this.getStandardBottomBrandFill(),
        stroke: '',
        strokeWidth: 0,
        strokeId: 'none'
      };
    }

    syncBottomTextStyleControls() {
      this.nodes.textColorButtons.forEach((button) => {
        const colorId = button.dataset.patchTextColorId || button.dataset.patchTextColor || 'palette';
        const fill = button.dataset.patchTextColor || '';
        const isActive = colorId === this.textColorId || (fill && fill.toLowerCase() === (this.textColor || '').toLowerCase());
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.nodes.textStrokeButtons.forEach((button) => {
        const strokeId = button.dataset.patchTextStrokeOption || 'none';
        const stroke = button.dataset.patchTextStroke || '';
        const strokeWidth = stroke ? Number(button.dataset.patchTextStrokeWidth) || 5 : 0;
        const isActive = strokeId === this.textStrokeId ||
          (stroke.toLowerCase() === (this.textStroke || '').toLowerCase() && strokeWidth === (Number(this.textStrokeWidth) || 0));
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    setTextColorFromButton(button) {
      if (!button) return;

      const colorId = button.dataset.patchTextColorId || '';
      const color = button.dataset.patchTextColor || '';
      this.textColorId = colorId || color || 'palette';
      this.textColor = colorId === 'palette' ? '' : color;
      this.syncBottomTextStyleControls();
      this.render();
    }

    setTextStrokeFromButton(button) {
      if (!button) return;

      const stroke = button.dataset.patchTextStroke || '';
      this.textStroke = stroke;
      this.textStrokeWidth = stroke ? Number(button.dataset.patchTextStrokeWidth) || 5 : 0;
      this.textStrokeId = button.dataset.patchTextStrokeOption || 'none';
      this.syncBottomTextStyleControls();
      this.render();
    }

    getLocationInputMode() {
      const selected = this.nodes.locationModes.find((control) => control.checked);
      return selected && selected.value === 'coordinates' ? 'coordinates' : 'search';
    }

    isCoordinateInputMode() {
      return this.getLocationInputMode() === 'coordinates';
    }

    syncLocationModeUi() {
      const coordinateMode = this.isCoordinateInputMode();
      if (this.nodes.searchPanel) this.nodes.searchPanel.hidden = coordinateMode;
      if (this.nodes.coordinatePanel) this.nodes.coordinatePanel.hidden = !coordinateMode;
      if (coordinateMode) {
        this.terrainSuggestions = [];
        this.renderTerrainSuggestions();
      }
    }

    getRegionInputText() {
      if (!this.nodes.region) return '';
      return this.nodes.region.value.trim().replace(/\s+/g, ' ');
    }

    setPresetRegionInputValue(value) {
      this.presetRegionInputValue = String(value || '');
    }

    clearPresetRegionInputValue() {
      this.presetRegionInputValue = '';
    }

    clearPresetRegionInputOnFocus() {
      if (!this.nodes.region || !this.presetRegionInputValue) return false;
      if (this.nodes.region.value !== this.presetRegionInputValue) {
        this.clearPresetRegionInputValue();
        return false;
      }

      this.nodes.region.value = '';
      this.handleRegionInput();
      return true;
    }

    shouldShowRegionMark() {
      return !this.nodes.showRegion || this.nodes.showRegion.checked;
    }

    getCoordinateInputText() {
      const location = this.getCoordinateTerrainLocation();
      return location ? location.display_name : '';
    }

    getRegionText() {
      if (this.isCoordinateInputMode()) {
        const coordinateText = this.getCoordinateInputText();
        if (coordinateText) return coordinateText;
      }

      const value = this.getRegionInputText();
      return value || DEFAULT_REGION_TEXT;
    }

    hasPendingTerrainInput() {
      if (!this.isContourTemplate()) return false;

      if (this.isCoordinateInputMode()) {
        return Boolean(
          (this.nodes.coordinates && this.nodes.coordinates.value.trim()) ||
          this.getCoordinateTerrainLocation()
        );
      }

      return Boolean(
        this.selectedTerrainLocation ||
        this.parseTerrainCoordinates(this.getRegionInputText()) ||
        this.getRegionInputText().length >= 2
      );
    }

    getRegionCountryText() {
      if (!this.shouldShowRegionMark()) return '';

      const location = (this.terrainData && this.terrainData.location) || this.selectedTerrainLocation;
      const country = location && String(location.country || '').trim();
      if (country) return country;
      if (location && location.feature_code === 'COORD') return 'Coordinates';

      const regionText = this.getRegionText();
      if (this.parseTerrainCoordinates(regionText)) return 'Coordinates';
      const parts = regionText.split(',').map((part) => part.trim()).filter(Boolean);
      return parts.length > 1 ? parts[parts.length - 1] : regionText;
    }

    splitMainText(value) {
      const words = value.split(' ').filter(Boolean);
      if (words.length <= 1) return [value, ''];

      return [words[0], words.slice(1).join(' ')];
    }

    fitFontSize(text, fontSize, maxWidth, minSize, fontFamily, fontWeight = '800') {
      const measure = document.createElement('canvas').getContext('2d');
      let size = fontSize;

      while (size > minSize) {
        measure.font = `${fontWeight} ${size}px ${formatCanvasFontFamily(fontFamily)}`;
        if (measure.measureText(text).width <= maxWidth) return size;
        size -= 2;
      }

      return minSize;
    }

    getPreviewSize() {
      const preview = this.config.preview || {};
      const width = Number(preview.width) || PREVIEW_WIDTH;
      const height = Number(preview.height) || PREVIEW_HEIGHT;

      return { width, height };
    }

    getPatchPlacement() {
      const patch = (this.config.preview && this.config.preview.patch) || {};
      const placement = {
        x: Number(patch.x),
        y: Number(patch.y),
        width: Number(patch.width),
        height: Number(patch.height)
      };

      if (
        Number.isFinite(placement.x) &&
        Number.isFinite(placement.y) &&
        placement.width > 0 &&
        placement.height > 0
      ) {
        return placement;
      }

      return DEFAULT_PATCH_PLACEMENT;
    }

    measureTextWidth(text, fontSize, fontFamily, fontWeight = '800') {
      const measure = document.createElement('canvas').getContext('2d');
      measure.font = `${fontWeight} ${fontSize}px ${formatCanvasFontFamily(fontFamily)}`;
      return measure.measureText(text).width;
    }

    getBottomTextBlockWidth(lines, fontSize, fontFamily, fontWeight) {
      const measuredWidth = (Array.isArray(lines) ? lines : [])
        .reduce((width, line) => Math.max(width, this.measureTextWidth(line, fontSize, fontFamily, fontWeight)), 0);

      return Math.max(1, Math.min(BOTTOM_TEXT_AREA.width, Math.ceil(measuredWidth)));
    }

    getSelectedTextFont() {
      if (!this.nodes.bottomFont) return DEFAULT_CUSTOM_TEXT_FONT;
      return CUSTOM_TEXT_FONTS[this.nodes.bottomFont.value] ? this.nodes.bottomFont.value : DEFAULT_CUSTOM_TEXT_FONT;
    }

    getSelectedTextFontStyle() {
      const font = this.getSelectedTextFont();
      return CUSTOM_TEXT_FONTS[font] ? CUSTOM_TEXT_FONTS[font].fontStyle : '400';
    }

    getPrintPixelRatio() {
      const configuredRatio = Number(this.config.print_pixel_ratio);
      return configuredRatio > 0 ? configuredRatio : DEFAULT_PRINT_PIXEL_RATIO;
    }

    getPrintDimensions() {
      const ratio = this.getPrintPixelRatio();
      const canvasDimensions = this.getProductionCanvasDimensions();

      return {
        width: Math.round(canvasDimensions.width * ratio),
        height: Math.round(canvasDimensions.height * ratio),
        canvas_width_units: Number(canvasDimensions.width.toFixed(4)),
        canvas_height_units: Number(canvasDimensions.height.toFixed(4)),
        pixelRatio: ratio
      };
    }

    getThemeBleedUnits() {
      return {
        x: (BASE_WIDTH * THEME_BLEED_MM) / THEME_FINISHED_SIZE_MM.width,
        y: (BASE_HEIGHT * THEME_BLEED_MM) / THEME_FINISHED_SIZE_MM.height
      };
    }

    getProductionCanvasDimensions() {
      if (!this.hasThemeBleed()) {
        return {
          width: BASE_WIDTH,
          height: BASE_HEIGHT
        };
      }

      const bleed = this.getThemeBleedUnits();
      return {
        width: BASE_WIDTH + bleed.x * 2,
        height: BASE_HEIGHT + bleed.y * 2
      };
    }

    getThemePrintMetadata() {
      const bleed = this.getThemeBleedUnits();
      const theme = this.getThemeId();
      const printSize = {
        width: THEME_FINISHED_SIZE_MM.width + THEME_BLEED_MM * 2,
        height: THEME_FINISHED_SIZE_MM.height + THEME_BLEED_MM * 2
      };

      return {
        bleed_mm: THEME_BLEED_MM,
        bleed_units: {
          x: Number(bleed.x.toFixed(4)),
          y: Number(bleed.y.toFixed(4))
        },
        finished_size_mm: { ...THEME_FINISHED_SIZE_MM },
        print_size_mm: printSize,
        production_clip: 'bleed',
        preview_clip_path_version: THEME_PREVIEW_CLIP_PATH_VERSION,
        clip_path_version: theme === 'terrain'
          ? TERRAIN_THEME_CLIP_PATH_VERSION
          : (theme === 'pure-color' ? PURE_COLOR_CLIP_PATH_VERSION : TECH_THEME_CLIP_PATH_VERSION)
      };
    }

    render() {
      if (!this.layer || !this.activePalette) return;

      this.syncTerrainInitialPreviewState();
      this.layer.destroyChildren();
      this.drawHardwarePreview();
      this.drawPreviewPatch();
      this.layer.draw();
    }

    drawHardwarePreview() {
      const previewSize = this.getPreviewSize();
      const scale = Math.min(previewSize.width, previewSize.height) / HARDWARE_PREVIEW_BASE_SIZE;
      const offsetX = (previewSize.width - HARDWARE_PREVIEW_BASE_SIZE * scale) / 2;
      const offsetY = (previewSize.height - HARDWARE_PREVIEW_BASE_SIZE * scale) / 2;
      const caseColor = this.getActiveCaseColor();
      const buttonColor = this.getActiveButtonColor();
      const caseHex = (caseColor && caseColor.hex) || '#7d7c7c';
      const caseOuterHex = (caseColor && caseColor.outer_hex) || caseHex;
      const caseShadeMid = (caseColor && caseColor.shade_mid_hex) || this.mixHexColors(caseHex, '#111111', 0.12);
      const caseShadeDark = (caseColor && caseColor.shade_dark_hex) || this.mixHexColors(caseHex, '#111111', 0.24);

      HARDWARE_VECTOR_LAYERS.forEach((layer) => {
        const fill = layer.role === 'case'
          ? (layer.id === 'outer-frame' ? caseOuterHex : caseHex)
          : (layer.role === 'buttonOne' || layer.role === 'buttonTwo')
            ? (buttonColor && buttonColor.hex) || layer.fill
            : (layer.role === 'caseShadeDark' ? caseShadeDark : (layer.role === 'caseShadeMid' ? caseShadeMid : layer.fill));

        this.layer.add(new Konva.Path({
          x: offsetX + layer.x * scale,
          y: offsetY + layer.y * scale,
          data: layer.path,
          fill,
          scaleX: scale,
          scaleY: scale,
          listening: false
        }));
      });
    }

    drawPreviewPatch(options = {}) {
      const placement = this.getPatchPlacement();
      const group = new Konva.Group({
        x: placement.x,
        y: placement.y,
        scaleX: placement.width / BASE_WIDTH,
        scaleY: placement.height / BASE_HEIGHT,
        listening: false
      });

      this.drawPatchArtwork(group, { showTextGuide: options.showTextGuide !== false });
      const previousLayer = this.layer;
      this.layer = group;
      this.drawWindowBrandCopy();
      this.layer = previousLayer;
      this.layer.add(group);
    }

    drawPatchArtwork(target, options = {}) {
      const previousLayer = this.layer;
      const useBleed = options.clipMode === 'bleed' && this.hasThemeBleed();
      const bleedOffset = useBleed ? this.getThemeBleedUnits() : { x: 0, y: 0 };
      const clipGroup = new Konva.Group({
        listening: false,
        clipFunc: (context) => {
          if (useBleed) {
            drawImageCustomizerBleedClipPath(context, bleedOffset);
            return;
          }

          drawImageCustomizerPrintClipPath(context);
        }
      });
      const contentGroup = useBleed
        ? new Konva.Group({
          x: bleedOffset.x,
          y: bleedOffset.y,
          listening: false
        })
        : clipGroup;

      this.layer = contentGroup;
      this.drawPatchBase({
        bleedOffset: useBleed ? bleedOffset : null,
        omitBase: options.omitPatchBase === true
      });
      if (this.isContourTemplate()) {
        this.drawContourMapPattern({ bleedOffset: useBleed ? bleedOffset : null, clipMode: useBleed ? 'bleed' : 'preview' });
        if (this.shouldShowTerrainScaleBar()) this.drawTerrainScaleMark();
        this.drawBottomText({ showGuide: Boolean(options.showTextGuide) });
      } else if (this.isPureColorTemplate()) {
        this.drawBottomText({ showGuide: Boolean(options.showTextGuide) });
      } else {
        this.drawPattern({ bleedOffset: useBleed ? bleedOffset : null });
        this.drawStatusMarks();
        this.drawText();
      }
      this.layer = previousLayer;
      if (contentGroup !== clipGroup) clipGroup.add(contentGroup);
      target.add(clipGroup);
    }

    drawPatchBase(options = {}) {
      if (options.omitBase === true) return;

      const bleed = options.bleedOffset || { x: 0, y: 0 };
      this.layer.add(new Konva.Rect({
        x: -bleed.x,
        y: -bleed.y,
        width: BASE_WIDTH + bleed.x * 2,
        height: BASE_HEIGHT + bleed.y * 2,
        fill: this.isPureColorTemplate()
          ? ((this.getActivePatchColor() && this.getActivePatchColor().hex) || this.getPaletteColor('base'))
          : this.getPaletteColor('base'),
        listening: false
      }));
    }

    drawPattern(options = {}) {
      const group = new Konva.Group({ listening: false });
      const spacingX = 145;
      const size = 34;
      const spacingY = (BASE_HEIGHT - size * 2) / 13;
      const strokeWidth = 7;
      const bleed = options.bleedOffset || { x: 0, y: 0 };
      let startX = 38;
      let startY = size;

      while (startX - size > -bleed.x) startX -= spacingX;
      while (startY - size > -bleed.y) startY -= spacingY;

      for (let x = startX; x < BASE_WIDTH + bleed.x + size; x += spacingX) {
        for (let y = startY; y < BASE_HEIGHT + bleed.y + size; y += spacingY) {
          group.add(new Konva.Line({
            points: [x - size, y, x + size, y],
            stroke: this.getPaletteColor('pattern'),
            strokeWidth,
            lineCap: 'square'
          }));
          group.add(new Konva.Line({
            points: [x, y - size, x, y + size],
            stroke: this.getPaletteColor('pattern'),
            strokeWidth,
            lineCap: 'square'
          }));
        }
      }

      this.layer.add(group);
    }

    drawContourMapPattern(options = {}) {
      if (this.drawRealTerrainContourMapPattern(options)) return;

      const seed = this.getContourSeed();
      const random = this.createSeededRandom(seed);
      const field = this.createContourField(random);
      const step = 34;
      const bleed = options.bleedOffset || { x: 0, y: 0 };
      const startX = -bleed.x;
      const startY = -bleed.y;
      const endX = BASE_WIDTH + bleed.x;
      const endY = BASE_HEIGHT + bleed.y;
      const columns = Math.ceil((endX - startX) / step) + 1;
      const rows = Math.ceil((endY - startY) / step) + 1;
      const values = [];
      let min = Infinity;
      let max = -Infinity;

      for (let row = 0; row <= rows; row += 1) {
        const y = Math.min(startY + row * step, endY);
        const rowValues = [];

        for (let column = 0; column <= columns; column += 1) {
          const x = Math.min(startX + column * step, endX);
          const value = field(x, y);
          rowValues.push({ x, y, value });
          min = Math.min(min, value);
          max = Math.max(max, value);
        }

        values.push(rowValues);
      }

      const range = max - min || 1;
      this.drawContourLines(values, rows, columns, min, min + range, 16);
    }

    drawRealTerrainContourMapPattern(options = {}) {
      const terrainData = this.getDrawableTerrainData();
      const terrainValues = this.getTerrainContourValues(terrainData);
      if (!terrainValues) return false;
      const offset = this.getDrawableTerrainMapOffset();
      const terrainGroup = new Konva.Group({
        listening: false,
        clipFunc: (context) => this.drawPatchClipPath(context, { clipMode: options.clipMode })
      });
      const previousLayer = this.layer;
      this.layer = terrainGroup;

      this.drawContourLines(
        terrainValues.values,
        terrainValues.rows - 1,
        terrainValues.columns - 1,
        terrainValues.min,
        terrainValues.max,
        18,
        { offset }
      );
      this.drawTerrainPeakAnnotation(
        terrainData && terrainData.source === 'smallsmore-random-pattern' ? null : this.getTerrainDisplayAnnotation(terrainValues),
        offset
      );
      this.layer = previousLayer;
      this.layer.add(terrainGroup);

      return true;
    }

    getTerrainDisplayAnnotation(terrainValues = this.getTerrainContourValues()) {
      if (this.isRandomPatternTerrain()) return null;

      return this.getManualTerrainAnnotationInfo() || this.getTerrainAnnotationInfo() || this.getTerrainPreferredPeakAnnotation(terrainValues);
    }

    getManualTerrainAnnotationInfo() {
      const override = this.terrainAnnotationOverride;
      if (!override) return null;

      const xRatio = Number(override.xRatio);
      const yRatio = Number(override.yRatio);
      const latitude = Number(override.latitude);
      const longitude = Number(override.longitude);
      const elevation = Number(override.elevation);
      if (![xRatio, yRatio, latitude, longitude, elevation].every(Number.isFinite)) return null;

      const projection = this.getTerrainMapProjection();
      return {
        elevation,
        latitude,
        longitude,
        label: this.getTerrainAnnotationLabel(this.getTerrainAnnotationLocation() || {}),
        x: projection.x + xRatio * projection.width,
        y: projection.y + yRatio * projection.height
      };
    }

    getTerrainPreferredPeakAnnotation(terrainValues) {
      if (!terrainValues) return null;

      const peak = terrainValues.peak;
      if (!peak) return terrainValues.annotation || null;

      const annotation = terrainValues.annotation;
      const label = annotation && annotation.label;
      const peakElevation = Number(peak.elevation);
      const annotationElevation = Number(annotation && annotation.elevation);
      const elevation = (
        Number.isFinite(annotationElevation) &&
        Number.isFinite(peakElevation) &&
        annotationElevation > peakElevation &&
        this.isTerrainAnnotationNearPeak(annotation, peak)
      ) ? annotationElevation : peak.elevation;

      return {
        ...peak,
        elevation,
        label: label || peak.label
      };
    }

    isTerrainAnnotationNearPeak(annotation, peak) {
      const annotationLatitude = Number(annotation && annotation.latitude);
      const annotationLongitude = Number(annotation && annotation.longitude);
      const peakLatitude = Number(peak && peak.latitude);
      const peakLongitude = Number(peak && peak.longitude);
      if (![annotationLatitude, annotationLongitude, peakLatitude, peakLongitude].every(Number.isFinite)) return false;

      return this.getTerrainDistanceKm(annotationLatitude, annotationLongitude, peakLatitude, peakLongitude) <= 3;
    }

    isPointNearTerrainAnnotation(point, annotation) {
      if (!point || !annotation) return false;

      const displayPoint = this.getTerrainAnnotationDisplayPoint(annotation);
      if (!displayPoint) return false;

      const dx = point.x - displayPoint.x;
      const dy = point.y - displayPoint.y;
      return Math.sqrt(dx * dx + dy * dy) <= TERRAIN_ANNOTATION_HIT_RADIUS;
    }

    getTerrainAnnotationDisplayPoint(annotation) {
      if (!annotation || !Number.isFinite(Number(annotation.x)) || !Number.isFinite(Number(annotation.y))) return null;

      const offset = this.getTerrainMapOffset();
      return {
        x: Math.min(BASE_WIDTH - 54, Math.max(54, Number(annotation.x) + offset.x)),
        y: Math.min(BASE_HEIGHT - 54, Math.max(54, Number(annotation.y) + offset.y))
      };
    }

    drawPatchClipPath(context, options = {}) {
      if (options.clipMode === 'bleed') {
        drawImageCustomizerBleedClipPath(context);
        return;
      }

      drawImageCustomizerPrintClipPath(context);
    }

    drawContourLines(values, cellRows, cellColumns, min, max, levels, options = {}) {
      const range = max - min || 1;
      const group = new Konva.Group({ listening: false });
      const offset = options.offset || {};
      const offsetX = Number(offset.x) || 0;
      const offsetY = Number(offset.y) || 0;

      for (let level = 1; level <= levels; level += 1) {
        const threshold = min + range * (level / (levels + 1));
        const chains = this.getContourLineChains(values, cellRows, cellColumns, threshold);

        if (!chains.length) continue;

        const isIndexLine = level % 4 === 0;
        const isSecondaryLine = !isIndexLine && level % 2 === 0;
        const lineColor = isIndexLine ? this.getContourAccentColor() : this.getContourLineColor(isSecondaryLine);
        chains.forEach((chain) => {
          if (chain.length < 2) return;

          group.add(new Konva.Line({
            points: chain.flatMap((point) => [point.x + offsetX, point.y + offsetY]),
            stroke: lineColor,
            strokeWidth: isIndexLine ? 4 : 2.6,
            opacity: isIndexLine ? 0.46 : 0.52,
            lineCap: 'round',
            lineJoin: 'round',
            tension: chain.length > 2 ? 0.28 : 0,
            closed: this.isClosedContourChain(chain),
            listening: false
          }));
        });
      }

      this.layer.add(group);
    }

    drawTerrainPeakAnnotation(peak, offset = {}) {
      if (!peak || !Number.isFinite(Number(peak.x)) || !Number.isFinite(Number(peak.y))) return;

      const offsetX = Number(offset.x) || 0;
      const offsetY = Number(offset.y) || 0;
      const pointX = Math.min(BASE_WIDTH - 54, Math.max(54, Number(peak.x) + offsetX));
      const pointY = Math.min(BASE_HEIGHT - 54, Math.max(54, Number(peak.y) + offsetY));
      const elevation = Number(peak.elevation);
      const latitudeLabel = this.formatTerrainCoordinate(peak.latitude, 'latitude');
      const longitudeLabel = this.formatTerrainCoordinate(peak.longitude, 'longitude');
      if (!Number.isFinite(elevation) || !latitudeLabel || !longitudeLabel) return;
      const title = String(peak.label || 'HIGH POINT').trim().toUpperCase();

      const labelWidth = 460;
      const labelHeight = 168;
      const marginX = 72;
      const maxLabelX = BASE_WIDTH - labelWidth - 72;
      const labelOnRight = pointX < BASE_WIDTH * 0.52;
      const rawLabelX = labelOnRight ? pointX + 112 : pointX - labelWidth - 112;
      const labelX = Math.min(maxLabelX, Math.max(marginX, rawLabelX));
      const rawLabelY = pointY > 1280 ? pointY - labelHeight - 88 : pointY + 78;
      const labelY = Math.min(1396, Math.max(844, rawLabelY));
      const anchorX = labelOnRight ? labelX : labelX + labelWidth;
      const anchorY = labelY + 72;
      const bendX = pointX + (anchorX > pointX ? 46 : -46);
      const textColor = this.getPaletteColor('text');
      const accentColor = this.getPaletteColor('accent');
      const baseColor = this.getPaletteColor('base');
      const group = new Konva.Group({ listening: false });

      group.add(new Konva.Line({
        points: [pointX, pointY, bendX, pointY, anchorX, anchorY],
        stroke: textColor,
        strokeWidth: 2.4,
        opacity: 0.48,
        lineCap: 'round',
        lineJoin: 'round',
        listening: false
      }));

      group.add(new Konva.Circle({
        x: pointX,
        y: pointY,
        radius: 24,
        stroke: textColor,
        strokeWidth: 3.2,
        opacity: 0.82,
        listening: false
      }));

      group.add(new Konva.Circle({
        x: pointX,
        y: pointY,
        radius: 7.8,
        fill: accentColor,
        opacity: 0.92,
        listening: false
      }));

      group.add(new Konva.Rect({
        x: labelX,
        y: labelY,
        width: labelWidth,
        height: labelHeight,
        cornerRadius: 14,
        fill: baseColor,
        opacity: 0.72,
        listening: false
      }));

      group.add(new Konva.Rect({
        x: labelX,
        y: labelY,
        width: labelWidth,
        height: labelHeight,
        cornerRadius: 14,
        stroke: textColor,
        strokeWidth: 1.9,
        opacity: 0.3,
        listening: false
      }));

      group.add(new Konva.Rect({
        x: labelX + 24,
        y: labelY + 27,
        width: 48,
        height: 3.4,
        fill: accentColor,
        opacity: 0.9,
        listening: false
      }));

      group.add(new Konva.Text({
        x: labelX + 86,
        y: labelY + 16,
        text: `${Math.round(elevation)} M`,
        fontFamily: MONO_FONT_FAMILY,
        fontSize: TERRAIN_PEAK_LABEL_FONT_SIZE - 5,
        fill: textColor,
        opacity: 0.78,
        listening: false
      }));

      group.add(new Konva.Text({
        x: labelX + 24,
        y: labelY + 58,
        text: title,
        fontFamily: 'Outfit',
        fontSize: this.fitFontSize(title, 58, labelWidth - 48, 26, 'Outfit'),
        fontStyle: '800',
        fill: textColor,
        width: labelWidth - 48,
        wrap: 'none',
        ellipsis: false,
        listening: false
      }));

      group.add(new Konva.Text({
        x: labelX + 24,
        y: labelY + 124,
        text: `${latitudeLabel}  ${longitudeLabel}`,
        fontFamily: MONO_FONT_FAMILY,
        fontSize: TERRAIN_PEAK_LABEL_FONT_SIZE - 4,
        fill: textColor,
        opacity: 0.66,
        listening: false
      }));

      this.layer.add(group);
    }

    drawTerrainScaleMark() {
      if (!this.hasTerrainForCurrentSelection()) return;

      const projection = this.getTerrainMapProjection();
      const scaleBar = this.getTerrainScaleBarData(projection);
      const textColor = this.getPaletteColor('text');
      const baseColor = this.getPaletteColor('base');
      const x = BASE_WIDTH - 126;
      const y = 142;
      const barWidth = 17;
      const barHeight = scaleBar.height;
      const labelSize = 30;
      const numberSize = 22;
      const labelText = scaleBar.label;
      const labelWidth = this.measureTextWidth(labelText, labelSize, SCALE_BAR_FONT_FAMILY, '400');
      const valueToY = (value) => y + barHeight * (1 - value / scaleBar.totalKm);
      const tickValues = scaleBar.tickValues;
      const group = new Konva.Group({
        listening: false,
        opacity: 0.9
      });

      tickValues.slice(0, -1).forEach((value, index) => {
        const nextValue = tickValues[index + 1];
        const segmentY = valueToY(nextValue);
        const segmentHeight = valueToY(value) - segmentY;

        group.add(new Konva.Rect({
          x,
          y: segmentY,
          width: barWidth,
          height: segmentHeight,
          fill: index % 2 === 0 ? textColor : baseColor,
          stroke: textColor,
          strokeWidth: 2.4,
          opacity: index % 2 === 0 ? 0.95 : 0.82,
          listening: false
        }));
      });

      tickValues.forEach((value) => {
        const tickY = valueToY(value);
        const tickText = this.formatTerrainDistanceKm(value);
        const tickTextWidth = this.measureTextWidth(tickText, numberSize, SCALE_BAR_FONT_FAMILY, '400');

        group.add(new Konva.Line({
          points: [x - 8, tickY, x + barWidth + 8, tickY],
          stroke: textColor,
          strokeWidth: value === 0 || value === scaleBar.totalKm ? 3 : 2.4,
          opacity: 0.88,
          lineCap: 'square',
          listening: false
        }));

        group.add(new Konva.Text({
          x: x + barWidth + 18,
          y: tickY + tickTextWidth / 2,
          text: tickText,
          fontFamily: SCALE_BAR_FONT_FAMILY,
          fontSize: numberSize,
          fill: textColor,
          opacity: 0.82,
          rotation: -90,
          width: tickTextWidth + 4,
          listening: false
        }));
      });

      group.add(new Konva.Text({
        x: x - 50,
        y: y + barHeight,
        text: labelText,
        fontFamily: SCALE_BAR_FONT_FAMILY,
        fontSize: labelSize,
        fill: textColor,
        opacity: 0.82,
        rotation: -90,
        width: labelWidth + 10,
        listening: false
      }));

      this.layer.add(group);
    }

    getTerrainContourValues(terrainData = this.terrainData) {
      const grid = terrainData && terrainData.grid;
      if (!grid || !Array.isArray(grid.elevations)) return null;

      const sourceRows = Number(grid.rows);
      const sourceColumns = Number(grid.columns);
      if (!Number.isFinite(sourceRows) || !Number.isFinite(sourceColumns) || sourceRows < 2 || sourceColumns < 2) return null;
      const projection = this.getTerrainMapProjection(terrainData);
      const projectionKey = this.getTerrainMapProjectionKey(projection);
      if (this.terrainContourCache && this.terrainContourCache.grid === grid && this.terrainContourCache.projectionKey === projectionKey) {
        return this.terrainContourCache.values;
      }

      const targetRows = Math.min(TERRAIN_CONTOUR_MAX_ROWS, Math.max(2, Math.ceil(projection.height / TERRAIN_CONTOUR_SAMPLE_SPACING) + 1));
      const targetColumns = Math.min(TERRAIN_CONTOUR_MAX_COLUMNS, Math.max(2, Math.ceil(projection.width / TERRAIN_CONTOUR_SAMPLE_SPACING) + 1));
      const values = [];
      let min = Infinity;
      let max = -Infinity;

      for (let row = 0; row < targetRows; row += 1) {
        const yRatio = row / (targetRows - 1);
        const rowValues = [];

        for (let column = 0; column < targetColumns; column += 1) {
          const xRatio = column / (targetColumns - 1);
          const value = this.getInterpolatedElevation(grid, xRatio, yRatio);
          rowValues.push({
            x: projection.x + xRatio * projection.width,
            y: projection.y + yRatio * projection.height,
            value
          });
          min = Math.min(min, value);
          max = Math.max(max, value);
        }

        values.push(rowValues);
      }

      const smoothed = this.smoothContourValues(values, 2);
      values.splice(0, values.length, ...smoothed.values);
      min = smoothed.min;
      max = smoothed.max;

      if (!Number.isFinite(min) || !Number.isFinite(max) || max - min < 1) return null;

      const terrainValues = {
        values,
        rows: targetRows,
        columns: targetColumns,
        min,
        max,
        projection,
        annotation: terrainData === this.terrainData ? this.getTerrainAnnotationInfo(projection) : null,
        peak: this.getTerrainPeakInfo(grid, projection, terrainData)
      };
      this.terrainContourCache = {
        grid,
        projectionKey,
        values: terrainValues
      };

      return terrainValues;
    }

    getTerrainPeakInfo(grid, projection = this.getTerrainMapProjection(), terrainData = this.terrainData) {
      if (!grid || !Array.isArray(grid.elevations)) return null;

      if (grid.peak && Number.isFinite(Number(grid.peak.elevation))) {
        const row = Number(grid.peak.row);
        const column = Number(grid.peak.column);
        const rowRatio = Number.isFinite(row) && grid.rows > 1 ? row / (grid.rows - 1) : 0.5;
        const columnRatio = Number.isFinite(column) && grid.columns > 1 ? column / (grid.columns - 1) : 0.5;

        return {
          elevation: Number(grid.peak.elevation),
          latitude: Number(grid.peak.latitude),
          longitude: Number(grid.peak.longitude),
          label: 'HIGH POINT',
          x: projection.x + columnRatio * projection.width,
          y: projection.y + rowRatio * projection.height
        };
      }

      const bounds = terrainData && terrainData.bounds;
      let peak = null;

      grid.elevations.forEach((rowValues, row) => {
        rowValues.forEach((elevation, column) => {
          const value = Number(elevation);
          if (!Number.isFinite(value) || (peak && value <= peak.elevation)) return;

          const rowRatio = grid.rows > 1 ? row / (grid.rows - 1) : 0.5;
          const columnRatio = grid.columns > 1 ? column / (grid.columns - 1) : 0.5;
          const latitude = bounds
            ? Number(bounds.north) - (Number(bounds.north) - Number(bounds.south)) * rowRatio
            : null;
          const longitude = bounds
            ? Number(bounds.west) + (Number(bounds.east) - Number(bounds.west)) * columnRatio
            : null;

          peak = {
            elevation: value,
            latitude,
            longitude,
            label: 'HIGH POINT',
            x: projection.x + columnRatio * projection.width,
            y: projection.y + rowRatio * projection.height
          };
        });
      });

      return peak;
    }

    getTerrainAnnotationInfo(projection = this.getTerrainMapProjection()) {
      const location = this.getTerrainAnnotationLocation();
      if (!location) return null;

      const projected = this.projectTerrainCoordinateToMap(location.latitude, location.longitude, projection);
      if (!projected) return null;

      const elevation = this.getTerrainAnnotationElevation(location);
      if (!Number.isFinite(elevation)) return null;

      return {
        elevation,
        latitude: Number(location.latitude),
        longitude: Number(location.longitude),
        label: this.getTerrainAnnotationLabel(location),
        x: projected.x,
        y: projected.y
      };
    }

    getTerrainAnnotationLocation() {
      const location = (this.terrainData && this.terrainData.location) || this.selectedTerrainLocation;
      const latitude = Number(location && location.latitude);
      const longitude = Number(location && location.longitude);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

      return {
        ...location,
        latitude,
        longitude
      };
    }

    getTerrainAnnotationLabel(location) {
      const name = String(location.name || location.display_name || '').split(',')[0].trim();
      return name || 'PEAK LOCATION';
    }

    getTerrainAnnotationElevation(location) {
      const rawElevation = location && location.elevation;
      const locationElevation = Number(rawElevation);
      if (rawElevation !== null && rawElevation !== undefined && rawElevation !== '' && Number.isFinite(locationElevation)) return locationElevation;

      const grid = this.terrainData && this.terrainData.grid;
      const ratios = this.getTerrainCoordinateRatios(location && location.latitude, location && location.longitude);
      if (!grid || !ratios) return null;

      return this.getInterpolatedElevation(grid, ratios.x, ratios.y);
    }

    projectTerrainCoordinateToMap(latitude, longitude, projection = this.getTerrainMapProjection()) {
      const ratios = this.getTerrainCoordinateRatios(latitude, longitude);
      if (!ratios) return null;

      return {
        x: projection.x + ratios.x * projection.width,
        y: projection.y + ratios.y * projection.height
      };
    }

    getTerrainCoordinateRatios(latitude, longitude) {
      const bounds = this.terrainData && this.terrainData.bounds;
      if (!bounds) return null;

      const north = Number(bounds.north);
      const south = Number(bounds.south);
      const east = Number(bounds.east);
      const west = Number(bounds.west);
      const lat = Number(latitude);
      const lon = Number(longitude);
      if (![north, south, east, west, lat, lon].every(Number.isFinite)) return null;

      const latitudeSpan = north - south;
      const longitudeSpan = east - west;
      if (!latitudeSpan || !longitudeSpan) return null;

      const y = (north - lat) / latitudeSpan;
      const x = (lon - west) / longitudeSpan;
      if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

      return {
        x: Math.min(1, Math.max(0, x)),
        y: Math.min(1, Math.max(0, y))
      };
    }

    getTerrainAnnotationFromVisiblePoint(point) {
      if (!point || !this.hasTerrainForCurrentSelection()) return null;

      const grid = this.terrainData && this.terrainData.grid;
      const projection = this.getTerrainMapProjection();
      const offset = this.getTerrainMapOffset();
      if (!grid || !projection || !Number.isFinite(Number(projection.width)) || !Number.isFinite(Number(projection.height)) || projection.width <= 0 || projection.height <= 0) return null;

      const xRatio = (Number(point.x) - offset.x - projection.x) / projection.width;
      const yRatio = (Number(point.y) - offset.y - projection.y) / projection.height;
      if (!Number.isFinite(xRatio) || !Number.isFinite(yRatio)) return null;

      const ratios = {
        x: Math.min(1, Math.max(0, xRatio)),
        y: Math.min(1, Math.max(0, yRatio))
      };
      const coordinates = this.getTerrainCoordinatesFromRatios(ratios.x, ratios.y);
      if (!coordinates) return null;

      const elevation = this.getInterpolatedElevation(grid, ratios.x, ratios.y);
      if (!Number.isFinite(elevation)) return null;

      return {
        xRatio: ratios.x,
        yRatio: ratios.y,
        latitude: this.roundTerrainCoordinate(coordinates.latitude),
        longitude: this.roundTerrainCoordinate(coordinates.longitude),
        elevation: Math.round(elevation)
      };
    }

    getTerrainCoordinatesFromRatios(xRatio, yRatio) {
      const bounds = this.terrainData && this.terrainData.bounds;
      if (!bounds) return null;

      const north = Number(bounds.north);
      const south = Number(bounds.south);
      const east = Number(bounds.east);
      const west = Number(bounds.west);
      const x = Number(xRatio);
      const y = Number(yRatio);
      if (![north, south, east, west, x, y].every(Number.isFinite)) return null;

      return {
        latitude: north - (north - south) * Math.min(1, Math.max(0, y)),
        longitude: west + (east - west) * Math.min(1, Math.max(0, x))
      };
    }

    formatTerrainCoordinate(value, axis) {
      const coordinate = Number(value);
      if (!Number.isFinite(coordinate)) return '';

      const suffix = axis === 'latitude'
        ? (coordinate >= 0 ? 'N' : 'S')
        : (coordinate >= 0 ? 'E' : 'W');

      return `${Math.abs(coordinate).toFixed(3)}${suffix}`;
    }

    getInterpolatedElevation(grid, xRatio, yRatio) {
      const sourceRows = grid.rows;
      const sourceColumns = grid.columns;
      const sourceX = xRatio * (sourceColumns - 1);
      const sourceY = yRatio * (sourceRows - 1);
      const baseX = Math.floor(sourceX);
      const baseY = Math.floor(sourceY);
      const tx = sourceX - baseX;
      const ty = sourceY - baseY;
      const rowValues = [];

      for (let y = -1; y <= 2; y += 1) {
        rowValues.push(this.cubicInterpolate(
          this.getClampedElevationCell(grid, baseX - 1, baseY + y),
          this.getClampedElevationCell(grid, baseX, baseY + y),
          this.getClampedElevationCell(grid, baseX + 1, baseY + y),
          this.getClampedElevationCell(grid, baseX + 2, baseY + y),
          tx
        ));
      }

      const interpolated = this.cubicInterpolate(rowValues[0], rowValues[1], rowValues[2], rowValues[3], ty);
      const min = Number(grid.min);
      const max = Number(grid.max);
      if (Number.isFinite(min) && Number.isFinite(max) && max > min) {
        return Math.min(max, Math.max(min, interpolated));
      }

      return interpolated;
    }

    cubicInterpolate(p0, p1, p2, p3, t) {
      const t2 = t * t;
      const t3 = t2 * t;

      return 0.5 * (
        (2 * p1) +
        (-p0 + p2) * t +
        (2 * p0 - 5 * p1 + 4 * p2 - p3) * t2 +
        (-p0 + 3 * p1 - 3 * p2 + p3) * t3
      );
    }

    getClampedElevationCell(grid, column, row) {
      const clampedColumn = Math.min(grid.columns - 1, Math.max(0, column));
      const clampedRow = Math.min(grid.rows - 1, Math.max(0, row));

      return this.getElevationCell(grid, clampedColumn, clampedRow);
    }

    getElevationCell(grid, column, row) {
      const rowValues = grid.elevations[row] || [];
      const value = Number(rowValues[column]);
      if (Number.isFinite(value)) return value;

      for (let radius = 1; radius < Math.max(grid.rows, grid.columns); radius += 1) {
        for (let y = Math.max(0, row - radius); y <= Math.min(grid.rows - 1, row + radius); y += 1) {
          for (let x = Math.max(0, column - radius); x <= Math.min(grid.columns - 1, column + radius); x += 1) {
            const nearby = Number((grid.elevations[y] || [])[x]);
            if (Number.isFinite(nearby)) return nearby;
          }
        }
      }

      return 0;
    }

    smoothContourValues(values, passes = 1) {
      let currentValues = values.map((row) => row.map((point) => ({ ...point })));

      for (let pass = 0; pass < passes; pass += 1) {
        currentValues = currentValues.map((row, rowIndex) => {
          return row.map((point, columnIndex) => {
            let total = 0;
            let weightTotal = 0;

            for (let y = rowIndex - 1; y <= rowIndex + 1; y += 1) {
              for (let x = columnIndex - 1; x <= columnIndex + 1; x += 1) {
                const neighbor = currentValues[y] && currentValues[y][x];
                if (!neighbor) continue;

                const isCenter = y === rowIndex && x === columnIndex;
                const isCardinal = y === rowIndex || x === columnIndex;
                const weight = isCenter ? 4 : (isCardinal ? 2 : 1);
                total += neighbor.value * weight;
                weightTotal += weight;
              }
            }

            return {
              ...point,
              value: weightTotal ? total / weightTotal : point.value
            };
          });
        });
      }

      let min = Infinity;
      let max = -Infinity;
      currentValues.forEach((row) => {
        row.forEach((point) => {
          min = Math.min(min, point.value);
          max = Math.max(max, point.value);
        });
      });

      return {
        values: currentValues,
        min,
        max
      };
    }

    queueTerrainSuggestions(options = {}) {
      if (!this.isContourTemplate() || !this.nodes.regionSuggestions) return;
      if (this.isCoordinateInputMode()) {
        window.clearTimeout(this.terrainSuggestionTimer);
        this.terrainSuggestions = [];
        this.renderTerrainSuggestions();
        return;
      }

      window.clearTimeout(this.terrainSuggestionTimer);
      const delay = options.immediate ? 0 : TERRAIN_SUGGESTION_DELAY_MS;

      this.terrainSuggestionTimer = window.setTimeout(() => {
        this.loadTerrainSuggestions(this.getRegionInputText()).catch(() => null);
      }, delay);
    }

    async loadTerrainSuggestions(region) {
      const query = String(region || '').trim();
      const requestId = this.terrainSuggestionRequestId + 1;
      this.terrainSuggestionRequestId = requestId;

      if (query.length < 2) {
        this.terrainSuggestions = [];
        this.renderTerrainSuggestions();
        this.updateSuggestionStatus('');
        return [];
      }

      const cached = this.terrainSuggestionCache.get(query.toLowerCase());
      if (cached) {
        this.terrainSuggestions = cached;
        this.renderTerrainSuggestions();
        return cached;
      }

      this.updateSuggestionStatus('Finding matching terrain...');

      try {
        const suggestions = await this.fetchTerrainSuggestions(query);
        if (requestId !== this.terrainSuggestionRequestId || query !== this.getRegionInputText()) return [];

        this.terrainSuggestionCache.set(query.toLowerCase(), suggestions);
        this.terrainSuggestions = suggestions;
        this.renderTerrainSuggestions();
        this.updateSuggestionStatus(suggestions.length ? '' : 'No matching terrain found yet.');
        return suggestions;
      } catch (error) {
        if (requestId === this.terrainSuggestionRequestId) {
          this.terrainSuggestions = [];
          this.renderTerrainSuggestions();
          this.updateSuggestionStatus('Could not load recommendations yet.');
        }

        return [];
      }
    }

    async fetchTerrainSuggestions(query) {
      const curatedSuggestions = this.getCuratedTerrainSuggestions(query);
      const url = new URL('/v1/search', this.getTerrainProviderUrl('geocoding'));
      url.searchParams.set('name', query);
      url.searchParams.set('count', '10');
      url.searchParams.set('language', 'en');
      url.searchParams.set('format', 'json');

      const data = await this.fetchTerrainJson(url).catch((error) => {
        if (curatedSuggestions.length) return { results: [] };
        throw error;
      });
      const results = Array.isArray(data.results) ? data.results : [];

      const providerSuggestions = results
        .map((result, index) => this.normalizeTerrainSuggestion(query, result, index))
        .filter(Boolean)
        .filter((suggestion) => !curatedSuggestions.some((curated) => curated.id === suggestion.id));

      return curatedSuggestions
        .concat(providerSuggestions)
        .sort((a, b) => b.score - a.score)
        .slice(0, TERRAIN_SUGGESTION_LIMIT);
    }

    getCuratedTerrainSuggestions(query) {
      const normalizedQuery = this.normalizeTerrainSearchText(query);
      if (!normalizedQuery) return [];

      return CURATED_TERRAIN_LOCATIONS
        .filter((location) => {
          return location.aliases.some((alias) => {
            const normalizedAlias = this.normalizeTerrainSearchText(alias);
            return normalizedAlias.includes(normalizedQuery) || normalizedQuery.includes(normalizedAlias);
          });
        })
        .map((location) => ({
          ...location,
          score: 240
        }));
    }

    normalizeTerrainSearchText(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/^ei(\s|$)/, 'el$1')
        .replace(/[^a-z0-9\u3400-\u9fff]+/g, ' ')
        .trim();
    }

    normalizeTerrainSuggestion(query, result, index) {
      const latitude = Number(result && result.latitude);
      const longitude = Number(result && result.longitude);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

      const displayName = [result.name, result.admin1, result.country].filter(Boolean).join(', ');
      const featureCode = result.feature_code || '';
      const elevation = Number(result.elevation);
      const normalizedQuery = String(query || '').toLowerCase();
      const normalizedName = String(result.name || '').toLowerCase();
      let score = 40 - index;

      if (TERRAIN_FEATURE_CODES.has(featureCode)) score += 60;
      if (normalizedName === normalizedQuery) score += 24;
      if (normalizedName.includes(normalizedQuery)) score += 12;
      if (Number.isFinite(elevation)) score += Math.min(18, Math.max(0, elevation) / 450);

      return {
        id: `${this.roundTerrainCoordinate(latitude)}:${this.roundTerrainCoordinate(longitude)}:${displayName}`,
        name: result.name || displayName,
        display_name: displayName || `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`,
        latitude,
        longitude,
        elevation: Number.isFinite(elevation) ? elevation : null,
        country: result.country || '',
        admin1: result.admin1 || '',
        feature_code: featureCode,
        score
      };
    }

    renderTerrainSuggestions() {
      if (!this.nodes.regionSuggestions) return;

      this.nodes.regionSuggestions.innerHTML = '';
      this.nodes.regionSuggestions.hidden = !this.terrainSuggestions.length;

      this.terrainSuggestions.forEach((suggestion) => {
        const button = document.createElement('button');
        button.className = 'smallsmore-patch-customizer__suggestion';
        button.type = 'button';
        button.dataset.terrainSuggestionId = suggestion.id;

        const label = document.createElement('span');
        label.className = 'smallsmore-patch-customizer__suggestion-label';
        label.textContent = suggestion.display_name;

        const meta = document.createElement('span');
        meta.className = 'smallsmore-patch-customizer__suggestion-meta';
        meta.textContent = this.getTerrainSuggestionMeta(suggestion);

        button.append(label, meta);
        button.addEventListener('click', () => this.recordHistoryChange(() => this.selectTerrainSuggestion(suggestion)));
        this.nodes.regionSuggestions.append(button);
      });
    }

    getTerrainSuggestionMeta(suggestion) {
      const parts = [];
      const feature = this.getTerrainFeatureLabel(suggestion.feature_code);
      if (feature) parts.push(feature);
      if (Number.isFinite(Number(suggestion.elevation))) parts.push(`${Math.round(Number(suggestion.elevation))} m`);
      if (suggestion.latitude && suggestion.longitude) {
        parts.push(`${Number(suggestion.latitude).toFixed(3)}, ${Number(suggestion.longitude).toFixed(3)}`);
      }

      return parts.join(' · ');
    }

    getSerializableTerrainLocation(location) {
      if (!location) return null;

      return {
        id: location.id || '',
        name: location.name || location.display_name || '',
        display_name: location.display_name || location.name || '',
        latitude: Number(location.latitude),
        longitude: Number(location.longitude),
        elevation: Number.isFinite(Number(location.elevation)) ? Number(location.elevation) : null,
        country: location.country || '',
        admin1: location.admin1 || '',
        feature_code: location.feature_code || ''
      };
    }

    getTerrainFeatureLabel(featureCode) {
      const labels = {
        MT: 'Mountain',
        MTS: 'Mountains',
        PK: 'Peak',
        PKS: 'Peaks',
        HLL: 'Hill',
        HLLS: 'Hills',
        RDGE: 'Ridge',
        VAL: 'Valley',
        CLF: 'Cliff',
        PPL: 'Place'
      };

      return labels[featureCode] || '';
    }

    selectTerrainSuggestion(suggestion, options = {}) {
      this.selectedTerrainLocation = { ...suggestion };
      this.nodes.region.value = suggestion.display_name;
      if (options.clearOnFocus) {
        this.setPresetRegionInputValue(this.nodes.region.value);
      } else {
        this.clearPresetRegionInputValue();
      }
      this.terrainData = null;
      this.terrainDataRegion = '';
      this.terrainPromise = null;
      this.clearTerrainContourCache();
      this.clearTerrainAnnotationOverride();
      this.resetTerrainMapOffset({ silent: true });
      this.terrainSuggestions = [];
      this.renderTerrainSuggestions();
      this.updateSuggestionStatus(options.autoLoad ? 'Getting terrain contours...' : '');
      this.updateTerrainControls();
      this.updateTerrainQuickPicks();
      this.updatePatchSteps();
      this.clearPreviewOverlay();
      this.setStatus('', '');
      this.render();

      if (options.autoLoad) {
        const location = this.selectedTerrainLocation;
        const preloaded = this.loadPreloadedTerrainData(this.getRegionText(), location);
        if (preloaded) {
          this.updateSuggestionStatus('Map ready. Drag the terrain to adjust placement.');
          this.updateTerrainControls();
          this.updatePatchSteps();
          return;
        }

        this.startTerrainLoad(this.getRegionText(), { location })
          .then((data) => {
            if (data) this.updateSuggestionStatus('Map ready. Drag the terrain to adjust placement.');
          })
          .finally(() => {
            this.updateTerrainControls();
            this.updatePatchSteps();
          });
      }
    }

    updateTerrainQuickPicks() {
      if (!this.nodes.regionQuickPicks) return;

      const selectedId = this.selectedTerrainLocation && this.selectedTerrainLocation.id;
      this.nodes.regionQuickPicks.querySelectorAll('[data-terrain-quick-pick]').forEach((button) => {
        const isActive = Boolean(selectedId && button.dataset.terrainQuickPick === selectedId);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    updateSuggestionStatus(message) {
      if (!this.nodes.regionSuggestionStatus) return;

      this.nodes.regionSuggestionStatus.textContent = message || '';
      this.nodes.regionSuggestionStatus.hidden = !message;
    }

    updateTerrainControls() {
      if (this.nodes.getMapButton) {
        const region = this.getRegionInputText();
        const hasCoordinates = Boolean(this.parseTerrainCoordinates(region));
        const hasCoordinateFields = Boolean(this.getCoordinateTerrainLocation());
        const hasSelectedLocation = Boolean(this.selectedTerrainLocation);
        const hasLoadedTerrain = this.hasTerrainForCurrentSelection();
        const hasRegionText = region.trim().length >= 2;
        const hasPendingTerrainLocation = (
          this.isCoordinateInputMode()
            ? hasCoordinateFields
            : (hasSelectedLocation || hasCoordinates || hasRegionText)
        );
        const canGenerate = this.isContourTemplate() && hasPendingTerrainLocation && !hasLoadedTerrain;
        const shouldShowGetMap = this.isContourTemplate();
        this.nodes.getMapButton.hidden = !shouldShowGetMap;
        this.nodes.getMapButton.disabled = !canGenerate || Boolean(this.terrainPromise);
        this.nodes.getMapButton.textContent = this.terrainPromise ? 'Getting map' : 'Get the map';
        if (this.nodes.mapActions) this.nodes.mapActions.hidden = !shouldShowGetMap;
      }
      if (this.nodes.centerMapButton) {
        const canMove = !this.isStandardCustomizationMode() && this.canMoveTerrainMap();
        this.nodes.centerMapButton.hidden = !canMove;
        this.nodes.centerMapButton.disabled = !canMove;
      }
      if (this.nodes.guideOpenButton) {
        const canShowGuide = !this.isStandardCustomizationMode() && this.canMoveTerrainMap();
        this.nodes.guideOpenButton.hidden = !canShowGuide;
        this.nodes.guideOpenButton.disabled = !canShowGuide;
        if (!canShowGuide) this.closeGuideDialog({ restoreFocus: false });
      }
      if (this.nodes.resetPointButton) {
        const canShowResetPoint = !this.isStandardCustomizationMode() && this.canMoveTerrainMap();
        const canResetPoint = canShowResetPoint && this.canResetTerrainAnnotationPoint();
        this.nodes.resetPointButton.hidden = !canShowResetPoint;
        this.nodes.resetPointButton.disabled = !canResetPoint;
      }
      if (this.nodes.terrainScaleControl) {
        const canShowScaleControl = !this.isStandardCustomizationMode() && this.canMoveTerrainMap();
        this.nodes.terrainScaleControl.hidden = !canShowScaleControl;
        this.nodes.terrainScaleControls.forEach((control) => {
          control.disabled = !canShowScaleControl;
        });
      }
      if (this.nodes.stage) {
        this.nodes.stage.classList.toggle('is-terrain-draggable', this.canMoveTerrainMap());
        if (!this.canMoveTerrainMap()) {
          this.nodes.stage.classList.remove('is-terrain-dragging');
          this.nodes.stage.classList.remove('is-terrain-annotation-dragging');
        }
      }
    }

    startTerrainLoad(region, options = {}) {
      const promise = this.loadTerrainData(region, options);
      this.terrainPromise = promise;
      this.updateTerrainControls();
      promise.finally(() => {
        if (this.terrainPromise === promise) {
          this.terrainPromise = null;
          this.updateTerrainControls();
        }
      });

      return promise;
    }

    async ensureTerrainData() {
      if (!this.isContourTemplate() || (!this.getTerrainEndpoint() && !this.shouldUseTerrainProviderFallback())) return null;
      if (this.hasTerrainForCurrentSelection()) return this.terrainData;
      if (this.terrainPromise) return this.terrainPromise;

      return null;
    }

    async handleGetMapClick() {
      if (!this.isContourTemplate()) return;
      if (this.hasTerrainForCurrentSelection()) return;

      if (this.isCoordinateInputMode()) {
        const location = this.getCoordinateTerrainLocation();
        if (!location) {
          this.setStatus('Paste valid coordinates first.', 'error');
          this.setPreviewStatus('CHECK COORDINATES', 'error');
          return;
        }

        this.clearPreviewOverlay();
        const data = await this.startTerrainLoad(location.display_name, { location });
        if (data) this.updateSuggestionStatus('Map ready. Drag the terrain to adjust placement.');
        this.updateTerrainControls();
        this.updatePatchSteps();
        return;
      }

      const region = this.getRegionInputText();
      if (region.length < 2) {
        this.setStatus('Enter a mountain or region name first.', 'error');
        return;
      }

      this.clearPreviewOverlay();

      try {
        let location = this.selectedTerrainLocation;
        if (!location) {
          location = this.parseTerrainCoordinates(region);
        }

        if (!location) {
          const suggestions = await this.loadTerrainSuggestions(region);
          location = suggestions[0] ? { ...suggestions[0] } : null;
          if (!location) {
            this.setStatus('Could not find that terrain. Try a more specific mountain name.', 'error');
            this.setPreviewStatus('MAP FAILED', 'error');
            return;
          }
          this.selectedTerrainLocation = { ...location };
          this.nodes.region.value = location.display_name || location.name || region;
          this.terrainSuggestions = [];
          this.renderTerrainSuggestions();
          this.updateTerrainQuickPicks();
        }

        const data = await this.startTerrainLoad(location.display_name || location.name || this.getRegionText(), { location });
        if (data) this.updateSuggestionStatus('Map ready. Drag the terrain to adjust placement.');
      } catch (error) {
        this.setPreviewLoading(false);
        this.setStatus('Could not find that terrain. Try a more specific mountain name.', 'error');
        this.setPreviewStatus('MAP FAILED', 'error');
      } finally {
        this.updateTerrainControls();
        this.updatePatchSteps();
      }
    }

    async loadTerrainData(region, options = {}) {
      const requestId = this.terrainRequestId + 1;
      this.terrainRequestId = requestId;
      const location = options.location || this.selectedTerrainLocation;
      const selectionKey = this.getTerrainSelectionKey(location, region);
      const cacheKey = this.getTerrainCacheKey(region, location);
      const cached = this.terrainCache.get(cacheKey);
      if (cached) {
        this.terrainData = cached;
        this.terrainDataRegion = selectionKey;
        this.resetTerrainMapOffset({ silent: true });
        this.render();
        this.setPreviewStatus('MAP READY', 'success');
        this.setStatus(`Loaded terrain near ${cached.location.display_name || region}.`, 'success');
        return cached;
      }

      const preloaded = this.loadPreloadedTerrainData(region, location, { selectionKey, cacheKey });
      if (preloaded) {
        return preloaded;
      }

      if (!this.getTerrainEndpoint() && !this.shouldUseTerrainProviderFallback()) return null;

      this.setPreviewLoading(true, 'GETTING MAP');
      this.setStatus('Getting real terrain contours...', '');

      try {
        const data = await this.fetchTerrainData(region, location);

        if (requestId !== this.terrainRequestId || selectionKey !== this.getTerrainSelectionKey(location, this.getRegionText())) return null;
        if (!this.isValidTerrainData(data)) throw new Error('Terrain lookup returned an unusable grid.');

        this.terrainData = data;
        this.terrainDataRegion = selectionKey;
        this.selectedTerrainLocation = data.location || location || this.selectedTerrainLocation;
        this.clearTerrainContourCache();
        this.resetTerrainMapOffset({ silent: true });
        this.terrainCache.set(cacheKey, data);
        this.render();
        this.setPreviewStatus('MAP READY', 'success');
        this.setStatus(`Loaded terrain near ${data.location.display_name || region}.`, 'success');
        return data;
      } catch (error) {
        if (requestId === this.terrainRequestId) {
          this.terrainData = null;
          this.terrainDataRegion = '';
          this.clearTerrainContourCache();
          this.resetTerrainMapOffset({ silent: true });
          this.render();
          this.setPreviewStatus('MAP FAILED', 'error');
          this.setStatus('Terrain service is busy. Please try Get the map again in a moment.', 'error');
        }

        return null;
      } finally {
        this.setPreviewLoading(false);
      }
    }

    loadPreloadedTerrainData(region, location, options = {}) {
      const preloadedLocation = this.getPreloadedTerrainLocation(region, location);
      const preloaded = this.getPreloadedTerrainData(region, preloadedLocation || location);
      if (!preloaded) return null;

      const selectionKey = options.selectionKey || this.getTerrainSelectionKey(location, region);
      const cacheKey = options.cacheKey || this.getTerrainCacheKey(region, location);
      this.terrainData = preloaded;
      this.terrainDataRegion = selectionKey;
      this.selectedTerrainLocation = location || preloadedLocation || preloaded.location || this.selectedTerrainLocation;
      this.clearTerrainContourCache();
      this.resetTerrainMapOffset({ silent: true });
      this.terrainCache.set(cacheKey, preloaded);
      this.render();
      this.setPreviewStatus('MAP READY', 'success');
      this.setStatus(`Loaded terrain near ${preloaded.location.display_name || region}.`, 'success');

      return preloaded;
    }

    getPreloadedTerrainData(region, location) {
      const matchedLocation = this.getPreloadedTerrainLocation(region, location);
      if (!matchedLocation || !matchedLocation.id) return null;

      const preloaded = PRELOADED_TERRAIN_OVERRIDES[matchedLocation.id] || PRELOADED_TERRAIN_DATA[matchedLocation.id];
      if (!preloaded || !preloaded.grid || !preloaded.bounds || !this.hasTerrainGridRelief(preloaded.grid)) return null;

      const gridOptions = this.getTerrainGridOptions();
      const grid = preloaded.grid;
      const bounds = preloaded.bounds;
      if (Number(bounds.radius_km) !== gridOptions.radius_km) {
        return null;
      }
      const resolvedGrid = this.resampleTerrainGrid(grid, gridOptions.columns, gridOptions.rows);

      return {
        ok: true,
        source: preloaded.source || 'preloaded',
        delivery: 'preloaded',
        attribution: preloaded.attribution || '',
        query: region,
        location: this.getSerializableTerrainLocation(location || matchedLocation),
        bounds: { ...bounds },
        grid: {
          columns: resolvedGrid.columns,
          rows: resolvedGrid.rows,
          min: resolvedGrid.min,
          max: resolvedGrid.max,
          elevations: resolvedGrid.elevations
        },
        created_at: 'preloaded'
      };
    }

    resampleTerrainGrid(grid, targetColumns, targetRows) {
      const columns = Math.max(3, Math.round(Number(targetColumns) || Number(grid.columns) || TERRAIN_DEFAULT_COLUMNS));
      const rows = Math.max(3, Math.round(Number(targetRows) || Number(grid.rows) || TERRAIN_DEFAULT_ROWS));

      if (Number(grid.columns) === columns && Number(grid.rows) === rows) {
        return {
          columns,
          rows,
          min: grid.min,
          max: grid.max,
          elevations: grid.elevations.map((row) => row.slice())
        };
      }

      const sourceGrid = {
        columns: Number(grid.columns),
        rows: Number(grid.rows),
        elevations: grid.elevations
      };
      const elevations = [];
      let min = Infinity;
      let max = -Infinity;

      for (let row = 0; row < rows; row += 1) {
        const yRatio = rows > 1 ? row / (rows - 1) : 0.5;
        const rowValues = [];

        for (let column = 0; column < columns; column += 1) {
          const xRatio = columns > 1 ? column / (columns - 1) : 0.5;
          const value = Math.round(this.getInterpolatedElevation(sourceGrid, xRatio, yRatio));
          rowValues.push(value);
          if (Number.isFinite(value)) {
            min = Math.min(min, value);
            max = Math.max(max, value);
          }
        }

        elevations.push(rowValues);
      }

      return {
        columns,
        rows,
        min,
        max,
        elevations
      };
    }

    getPreloadedTerrainLocation(region, location) {
      if (location && location.id && (PRELOADED_TERRAIN_OVERRIDES[location.id] || PRELOADED_TERRAIN_DATA[location.id])) {
        return CURATED_TERRAIN_LOCATIONS.find((curated) => curated.id === location.id) || location;
      }

      const normalizedText = this.normalizeTerrainSearchText([
        region,
        location && location.name,
        location && location.display_name
      ].filter(Boolean).join(' '));
      const latitude = Number(location && location.latitude);
      const longitude = Number(location && location.longitude);
      const hasCoordinates = Number.isFinite(latitude) && Number.isFinite(longitude);

      return CURATED_TERRAIN_LOCATIONS.find((curated) => {
        if (!(PRELOADED_TERRAIN_OVERRIDES[curated.id] || PRELOADED_TERRAIN_DATA[curated.id])) return false;

        const aliases = [curated.name, curated.display_name].concat(curated.aliases || []);
        const hasAliasMatch = aliases.some((alias) => {
          const normalizedAlias = this.normalizeTerrainSearchText(alias);
          if (!normalizedAlias || !normalizedText) return false;
          return normalizedText.includes(normalizedAlias) || (normalizedText.length >= 4 && normalizedAlias.includes(normalizedText));
        });
        if (hasAliasMatch) return true;

        if (!hasCoordinates) return false;
        return this.getTerrainDistanceKm(
          latitude,
          longitude,
          Number(curated.latitude),
          Number(curated.longitude)
        ) <= 2.5;
      }) || null;
    }

    async fetchTerrainData(region, location) {
      let providerError = null;
      let endpointError = null;

      if (this.getTerrainEndpoint()) {
        try {
          return await this.fetchTerrainFromEndpoint(region, location);
        } catch (error) {
          endpointError = error;
        }
      }

      if (this.shouldUseTerrainProviderFallback()) {
        try {
          if (endpointError) this.setStatus('Terrain endpoint is slow; trying direct terrain data...', '');
          return await this.fetchTerrainFromOpenMeteo(region, location);
        } catch (error) {
          providerError = error;
        }
      }

      throw endpointError || providerError || new Error('Terrain lookup failed.');
    }

    async fetchTerrainFromEndpoint(region, location) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), this.getTerrainEndpointTimeoutMs());

      try {
        const response = await fetch(this.getTerrainEndpoint(), {
          method: 'POST',
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            region,
            location: location ? this.getSerializableTerrainLocation(location) : null,
            ...this.getTerrainGridOptions()
          })
        });
        const data = await response.json().catch(() => null);

        if (!response.ok) {
          throw new Error(data && data.message ? data.message : 'Terrain lookup failed.');
        }

        return data;
      } finally {
        window.clearTimeout(timeout);
      }
    }

    async fetchTerrainFromOpenMeteo(region, location) {
      const resolvedLocation = location || await this.geocodeTerrainRegion(region);
      const sample = await this.fetchTerrainElevationGrid(resolvedLocation, this.getTerrainGridOptions());

      return {
        ok: true,
        source: sample.source || 'open-meteo',
        delivery: 'client',
        attribution: sample.attribution || 'Geocoding and elevation data from Open-Meteo.com',
        query: region,
        location: resolvedLocation,
        grid: sample.grid,
        bounds: sample.bounds,
        created_at: new Date().toISOString()
      };
    }

    async geocodeTerrainRegion(region) {
      const coordinates = this.parseTerrainCoordinates(region);
      if (coordinates) return coordinates;
      const curatedLocation = this.getCuratedTerrainSuggestions(region)[0];
      if (curatedLocation) return this.getSerializableTerrainLocation(curatedLocation);

      const url = new URL('/v1/search', this.getTerrainProviderUrl('geocoding'));
      url.searchParams.set('name', region);
      url.searchParams.set('count', '10');
      url.searchParams.set('language', 'en');
      url.searchParams.set('format', 'json');

      const data = await this.fetchTerrainJson(url);
      const results = Array.isArray(data.results) ? data.results : [];
      if (!results.length) {
        throw new Error(`No terrain location was found for "${region}".`);
      }

      const best = this.pickBestTerrainLocation(region, results);

      return {
        name: best.name,
        display_name: [best.name, best.admin1, best.country].filter(Boolean).join(', '),
        latitude: best.latitude,
        longitude: best.longitude,
        elevation: best.elevation,
        country: best.country || '',
        admin1: best.admin1 || '',
        feature_code: best.feature_code || ''
      };
    }

    parseTerrainCoordinates(region) {
      const match = String(region || '').match(/^\s*(-?\d+(?:\.\d+)?)\s*[,，]\s*(-?\d+(?:\.\d+)?)\s*$/);
      if (!match) return null;

      const latitude = Number(match[1]);
      const longitude = Number(match[2]);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
      if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) return null;

      const label = `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
      return {
        name: label,
        display_name: label,
        latitude,
        longitude,
        country: '',
        admin1: '',
        feature_code: 'COORD'
      };
    }

    getCoordinateTerrainLocation() {
      if (!this.nodes.coordinates) return null;

      const coordinates = this.parseTerrainCoordinates(this.nodes.coordinates.value);
      if (!coordinates) return null;

      const latitude = Number(coordinates.latitude);
      const longitude = Number(coordinates.longitude);
      const latitudeLabel = latitude.toFixed(5);
      const longitudeLabel = longitude.toFixed(5);
      const label = this.getCoordinateLabelText();

      return {
        id: `coord:${latitudeLabel}:${longitudeLabel}`,
        name: label,
        display_name: this.getCoordinateDisplayName(latitude, longitude, label),
        latitude,
        longitude,
        elevation: null,
        country: '',
        admin1: '',
        feature_code: 'COORD'
      };
    }

    getCoordinateLabelText() {
      const label = this.nodes.coordinateLabel ? this.nodes.coordinateLabel.value.trim().replace(/\s+/g, ' ') : '';
      return label || 'Custom coordinates';
    }

    getCoordinateDisplayName(latitude, longitude, label = this.getCoordinateLabelText()) {
      const latitudeNumber = Number(latitude);
      const longitudeNumber = Number(longitude);
      if (!Number.isFinite(latitudeNumber) || !Number.isFinite(longitudeNumber)) return label;

      return `${label}, ${latitudeNumber.toFixed(5)}, ${longitudeNumber.toFixed(5)}`;
    }

    pickBestTerrainLocation(region, results) {
      const normalizedRegion = String(region || '').toLowerCase();

      return results
        .map((result, index) => {
          let score = 0;
          const featureCode = result.feature_code || '';
          const country = String(result.country || '').toLowerCase();
          const admin = String(result.admin1 || '').toLowerCase();
          const name = String(result.name || '').toLowerCase();

          if (TERRAIN_FEATURE_CODES.has(featureCode)) score += 45;
          if (normalizedRegion.includes(country) && country) score += 18;
          if (normalizedRegion.includes(admin) && admin) score += 12;
          if (normalizedRegion.includes(name) || name.includes(normalizedRegion)) score += 8;
          if (Number.isFinite(result.elevation)) score += Math.min(18, Math.max(0, Number(result.elevation)) / 450);
          score -= index * 0.8;

          return { result, score };
        })
        .sort((a, b) => b.score - a.score)[0].result;
    }

    async fetchTerrainElevationGrid(location, options) {
      const columns = Math.min(31, Math.max(3, Math.round(Number(options.columns) || 17)));
      const rows = Math.min(31, Math.max(3, Math.round(Number(options.rows) || 23)));
      const radiusKm = Math.min(120, Math.max(5, Number(options.radius_km) || 28));
      const halfHeightKm = radiusKm;
      const halfWidthKm = radiusKm * 0.62;
      const centerLatitude = Number(location.latitude);
      const centerLongitude = Number(location.longitude);
      const latitudeSpan = this.kmToLatitudeDegrees(halfHeightKm);
      const longitudeSpan = this.kmToLongitudeDegrees(halfWidthKm, centerLatitude);
      const latitudes = [];
      const longitudes = [];
      const points = [];

      for (let row = 0; row < rows; row += 1) {
        const y = rows === 1 ? 0.5 : row / (rows - 1);
        const latitude = centerLatitude + latitudeSpan - y * latitudeSpan * 2;

        for (let column = 0; column < columns; column += 1) {
          const x = columns === 1 ? 0.5 : column / (columns - 1);
          const longitude = centerLongitude - longitudeSpan + x * longitudeSpan * 2;
          const roundedLatitude = this.roundTerrainCoordinate(latitude);
          const roundedLongitude = this.roundTerrainCoordinate(longitude);
          latitudes.push(roundedLatitude);
          longitudes.push(roundedLongitude);
          points.push({ row, column, latitude: roundedLatitude, longitude: roundedLongitude });
        }
      }

      let elevationSample;
      try {
        elevationSample = await this.fetchOpenMeteoElevations(latitudes, longitudes);
      } catch (error) {
        this.setStatus('Primary terrain data is busy; using fallback elevation data...', '');
        elevationSample = await this.fetchOpenZenithElevations(points);
      }

      const elevations = elevationSample.elevations;
      if (elevations.length !== points.length) {
        throw new Error('Elevation provider returned an unexpected grid.');
      }

      const matrix = Array.from({ length: rows }, () => Array(columns).fill(null));
      let min = Infinity;
      let max = -Infinity;

      elevations.forEach((elevation, index) => {
        const point = points[index];
        const value = Number(elevation);
        matrix[point.row][point.column] = Number.isFinite(value) ? value : null;

        if (Number.isFinite(value)) {
          min = Math.min(min, value);
          max = Math.max(max, value);
        }
      });

      if (!Number.isFinite(min) || !Number.isFinite(max)) {
        throw new Error('Elevation provider did not return usable terrain data.');
      }

      return {
        source: elevationSample.source,
        attribution: elevationSample.attribution,
        bounds: {
          north: this.roundTerrainCoordinate(centerLatitude + latitudeSpan),
          south: this.roundTerrainCoordinate(centerLatitude - latitudeSpan),
          east: this.roundTerrainCoordinate(centerLongitude + longitudeSpan),
          west: this.roundTerrainCoordinate(centerLongitude - longitudeSpan),
          radius_km: radiusKm
        },
        grid: {
          columns,
          rows,
          elevations: matrix,
          min,
          max
        }
      };
    }

    async fetchOpenMeteoElevations(latitudes, longitudes) {
      const batches = [];

      for (let index = 0; index < latitudes.length; index += TERRAIN_ELEVATION_BATCH_SIZE) {
        const latitudeBatch = latitudes.slice(index, index + TERRAIN_ELEVATION_BATCH_SIZE);
        const longitudeBatch = longitudes.slice(index, index + TERRAIN_ELEVATION_BATCH_SIZE);
        const url = this.getOpenMeteoElevationUrl(latitudeBatch, longitudeBatch);

        batches.push({ index, url, latitudeBatch });
      }

      const batchResults = [];
      for (let index = 0; index < batches.length; index += 1) {
        const batchInfo = batches[index];
        batchResults.push(await this.fetchOpenMeteoElevationBatch(batchInfo, { retries: 2, allowSplit: true }));
        if (index < batches.length - 1) await this.waitForTerrainRetry(420);
      }

      return {
        elevations: batchResults
          .sort((a, b) => a.index - b.index)
          .flatMap((result) => result.elevations),
        source: 'open-meteo',
        attribution: 'Geocoding and elevation data from Open-Meteo.com'
      };
    }

    async fetchOpenMeteoElevationBatch(batchInfo, options = {}) {
      try {
        const data = await this.fetchTerrainJson(batchInfo.url, { retries: Math.max(1, Number(options.retries) || 1) });
        const batch = Array.isArray(data.elevation) ? data.elevation : [];
        if (batch.length !== batchInfo.latitudeBatch.length) {
          throw new Error('Elevation provider returned an unexpected grid.');
        }

        return {
          index: batchInfo.index,
          elevations: batch
        };
      } catch (error) {
        if (Number(error && error.status) === 429) throw error;
        if (!options.allowSplit || batchInfo.latitudeBatch.length <= 1) throw error;

        const midpoint = Math.ceil(batchInfo.latitudeBatch.length / 2);
        const firstLatitudes = batchInfo.latitudeBatch.slice(0, midpoint);
        const secondLatitudes = batchInfo.latitudeBatch.slice(midpoint);
        const firstLongitudes = this.getTerrainBatchLongitudes(batchInfo.url).slice(0, midpoint);
        const secondLongitudes = this.getTerrainBatchLongitudes(batchInfo.url).slice(midpoint);
        const first = await this.fetchOpenMeteoElevationBatch({
          index: batchInfo.index,
          url: this.getOpenMeteoElevationUrl(firstLatitudes, firstLongitudes),
          latitudeBatch: firstLatitudes
        }, { retries: 2, allowSplit: true });
        const second = await this.fetchOpenMeteoElevationBatch({
          index: batchInfo.index + midpoint,
          url: this.getOpenMeteoElevationUrl(secondLatitudes, secondLongitudes),
          latitudeBatch: secondLatitudes
        }, { retries: 2, allowSplit: true });

        return {
          index: batchInfo.index,
          elevations: first.elevations.concat(second.elevations)
        };
      }
    }

    getOpenMeteoElevationUrl(latitudes, longitudes) {
      const url = new URL('/v1/elevation', this.getTerrainProviderUrl('elevation'));
      url.searchParams.set('latitude', latitudes.join(','));
      url.searchParams.set('longitude', longitudes.join(','));
      return url;
    }

    getTerrainBatchLongitudes(url) {
      return String(url.searchParams.get('longitude') || '')
        .split(',')
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value));
    }

    async fetchOpenElevationElevations(points) {
      const url = new URL('/api/v1/lookup', this.getTerrainProviderUrl('backupElevation'));
      const elevations = [];

      for (let index = 0; index < points.length; index += TERRAIN_BACKUP_ELEVATION_BATCH_SIZE) {
        const pointBatch = points.slice(index, index + TERRAIN_BACKUP_ELEVATION_BATCH_SIZE);
        const data = await this.fetchTerrainPostJson(url, {
          locations: pointBatch.map((point) => ({
            latitude: point.latitude,
            longitude: point.longitude
          }))
        }, { retries: 1 });
        const results = Array.isArray(data.results) ? data.results : [];
        if (results.length !== pointBatch.length) {
          throw new Error('Backup elevation provider returned an unexpected grid.');
        }
        elevations.push(...results.map((result) => result && result.elevation));
      }

      return {
        elevations,
        source: 'open-elevation',
        attribution: 'Geocoding data from Open-Meteo.com; elevation data from Open-Elevation.com'
      };
    }

    async fetchOpenZenithElevations(points) {
      const elevations = new Array(points.length);
      const concurrency = Math.min(8, points.length);
      let cursor = 0;

      const workers = Array.from({ length: concurrency }, async () => {
        while (cursor < points.length) {
          const index = cursor;
          cursor += 1;
          elevations[index] = await this.fetchOpenZenithElevationPoint(points[index]);
        }
      });

      await Promise.all(workers);

      return {
        elevations,
        source: 'openzenith',
        attribution: 'Geocoding data from Open-Meteo.com; elevation data from OpenZenith.org'
      };
    }

    async fetchOpenZenithElevationPoint(point) {
      const url = new URL('/api/elevation', this.getTerrainProviderUrl('zenithElevation'));
      url.searchParams.set('lat', this.roundTerrainCoordinate(point.latitude));
      url.searchParams.set('lon', this.roundTerrainCoordinate(point.longitude));

      const data = await this.fetchTerrainJson(url, { retries: 1 });
      const elevation = Number(data && data.elevation);
      if (!Number.isFinite(elevation)) throw new Error('Fallback elevation provider returned an unusable value.');

      return elevation;
    }

    async fetchTerrainJson(url, options = {}) {
      const retries = Math.max(0, Number(options.retries) || 0);
      let lastError = null;

      for (let attempt = 0; attempt <= retries; attempt += 1) {
        const controller = new AbortController();
        const timeoutMs = this.getTerrainTimeoutMs() + attempt * 4000;
        const timeout = window.setTimeout(() => controller.abort(), timeoutMs);

        try {
          const response = await fetch(url.toString(), {
            signal: controller.signal,
            headers: {
              'Accept': 'application/json'
            }
          });
          const data = await response.json().catch(() => null);

          if (!response.ok) {
            const error = new Error(`Terrain provider returned HTTP ${response.status}.`);
            error.status = response.status;
            throw error;
          }

          return data || {};
        } catch (error) {
          lastError = error;
          if (!this.shouldRetryTerrainRequest(error, attempt, retries)) throw error;
          await this.waitForTerrainRetry(500 * (attempt + 1));
        } finally {
          window.clearTimeout(timeout);
        }
      }

      throw lastError || new Error('Terrain provider request failed.');
    }

    async fetchTerrainPostJson(url, payload, options = {}) {
      const retries = Math.max(0, Number(options.retries) || 0);
      let lastError = null;

      for (let attempt = 0; attempt <= retries; attempt += 1) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), this.getTerrainTimeoutMs());

        try {
          const response = await fetch(url.toString(), {
            method: 'POST',
            signal: controller.signal,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          });
          const data = await response.json().catch(() => null);

          if (!response.ok) {
            const error = new Error(`Backup terrain provider returned HTTP ${response.status}.`);
            error.status = response.status;
            throw error;
          }

          return data || {};
        } catch (error) {
          lastError = error;
          if (!this.shouldRetryTerrainRequest(error, attempt, retries)) throw error;
          await this.waitForTerrainRetry(650 * (attempt + 1));
        } finally {
          window.clearTimeout(timeout);
        }
      }

      throw lastError || new Error('Backup terrain provider request failed.');
    }

    shouldRetryTerrainRequest(error, attempt, retries) {
      if (attempt >= retries) return false;

      const status = Number(error && error.status);
      if (!Number.isFinite(status)) return true;
      return status === 408 || status >= 500;
    }

    waitForTerrainRetry(delay) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, delay);
      });
    }

    kmToLatitudeDegrees(km) {
      return km / 111.32;
    }

    kmToLongitudeDegrees(km, latitude) {
      const latitudeRadians = Math.max(-89.9, Math.min(89.9, latitude)) * Math.PI / 180;
      const kmPerDegree = 111.32 * Math.max(0.12, Math.cos(latitudeRadians));
      return km / kmPerDegree;
    }

    getTerrainDistanceKm(latitudeA, longitudeA, latitudeB, longitudeB) {
      if (![latitudeA, longitudeA, latitudeB, longitudeB].every((value) => Number.isFinite(Number(value)))) return Infinity;

      const toRadians = (degrees) => Number(degrees) * Math.PI / 180;
      const earthRadiusKm = 6371;
      const dLat = toRadians(latitudeB - latitudeA);
      const dLon = toRadians(longitudeB - longitudeA);
      const lat1 = toRadians(latitudeA);
      const lat2 = toRadians(latitudeB);
      const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;

      return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    roundTerrainCoordinate(value) {
      return Math.round(value * 100000) / 100000;
    }

    hasTerrainGridRelief(grid) {
      const rows = Number(grid && grid.rows);
      const columns = Number(grid && grid.columns);
      if (!grid || !Array.isArray(grid.elevations)) return false;
      if (!Number.isFinite(rows) || !Number.isFinite(columns)) return false;
      if (grid.elevations.length !== rows) return false;

      let min = Infinity;
      let max = -Infinity;
      let finiteCount = 0;

      for (const row of grid.elevations) {
        if (!Array.isArray(row) || row.length !== columns) return false;
        for (const elevation of row) {
          const value = Number(elevation);
          if (!Number.isFinite(value)) continue;
          finiteCount += 1;
          min = Math.min(min, value);
          max = Math.max(max, value);
        }
      }

      return finiteCount > 0 && max > min;
    }

    isValidTerrainData(data) {
      const grid = data && data.grid;
      const rows = Number(grid && grid.rows);
      const columns = Number(grid && grid.columns);

      if (!grid || !Array.isArray(grid.elevations)) return false;
      if (!Number.isFinite(rows) || !Number.isFinite(columns)) return false;
      return grid.elevations.length === rows && grid.elevations.every((row) => Array.isArray(row) && row.length === columns);
    }

    getTerrainPayload() {
      if (!this.hasTerrainForCurrentSelection()) return null;

      const grid = this.terrainData.grid || {};
      const projection = this.getTerrainMapProjection();
      const terrainValues = this.getTerrainContourValues();
      const isRandomPattern = this.isRandomPatternTerrain();
      const peak = isRandomPattern ? null : (this.getTerrainDisplayAnnotation(terrainValues) || this.getTerrainPeakInfo(grid, projection) || this.getTerrainAnnotationInfo(projection));
      const offset = this.getTerrainMapOffset();
      return {
        source: this.terrainData.source || '',
        attribution: this.terrainData.attribution || '',
        query: this.terrainData.query || this.getRegionText(),
        resolved_location: this.terrainData.location || null,
        bounds: this.terrainData.bounds || null,
        map_scale: this.getTerrainScalePayload(),
        map_fit: this.getTerrainMapProjectionPayload(projection),
        map_position: {
          x: offset.x,
          y: offset.y
        },
        peak: peak ? {
          elevation: Math.round(Number(peak.elevation)),
          latitude: this.roundTerrainCoordinate(peak.latitude),
          longitude: this.roundTerrainCoordinate(peak.longitude)
        } : null,
        grid: {
          rows: grid.rows,
          columns: grid.columns,
          min: grid.min,
          max: grid.max
        }
      };
    }

    createRandomPatternTerrainData(seed) {
      const gridOptions = this.getTerrainGridOptions();
      const columns = Math.max(5, Math.round(Number(gridOptions.columns) || TERRAIN_DEFAULT_COLUMNS));
      const rows = Math.max(5, Math.round(Number(gridOptions.rows) || TERRAIN_DEFAULT_ROWS));
      const random = this.createSeededRandom(seed);
      const field = this.createContourField(random);
      const elevations = [];
      let min = Infinity;
      let max = -Infinity;

      for (let row = 0; row < rows; row += 1) {
        const yRatio = rows > 1 ? row / (rows - 1) : 0.5;
        const rowValues = [];

        for (let column = 0; column < columns; column += 1) {
          const xRatio = columns > 1 ? column / (columns - 1) : 0.5;
          const rawValue = field(xRatio * BASE_WIDTH, yRatio * BASE_HEIGHT);
          const elevation = Math.round((rawValue + 3) * 520);
          rowValues.push(elevation);
          min = Math.min(min, elevation);
          max = Math.max(max, elevation);
        }

        elevations.push(rowValues);
      }

      return {
        ok: true,
        source: 'smallsmore-random-pattern',
        delivery: 'local',
        attribution: '',
        query: RANDOM_TERRAIN_PATTERN_LABEL,
        location: null,
        bounds: null,
        grid: {
          columns,
          rows,
          min,
          max,
          elevations
        },
        created_at: new Date().toISOString()
      };
    }

    createContourField(random) {
      const hillCount = 7;
      const hills = Array.from({ length: hillCount }, () => {
        const polarity = random() > 0.28 ? 1 : -1;

        return {
          x: random() * BASE_WIDTH,
          y: random() * BASE_HEIGHT,
          amplitude: polarity * (0.7 + random() * 1.4),
          radiusX: 170 + random() * 390,
          radiusY: 210 + random() * 520
        };
      });
      const waveOne = {
        x: 0.0035 + random() * 0.003,
        y: 0.0015 + random() * 0.0025,
        phase: random() * Math.PI * 2
      };
      const waveTwo = {
        x: 0.0012 + random() * 0.0024,
        y: 0.003 + random() * 0.0024,
        phase: random() * Math.PI * 2
      };
      const slope = {
        x: random() * 1.2 - 0.6,
        y: random() * 1.2 - 0.6
      };

      return (x, y) => {
        const normalizedX = x / BASE_WIDTH - 0.5;
        const normalizedY = y / BASE_HEIGHT - 0.5;
        let value = normalizedX * slope.x + normalizedY * slope.y;

        hills.forEach((hill) => {
          const dx = (x - hill.x) / hill.radiusX;
          const dy = (y - hill.y) / hill.radiusY;
          value += hill.amplitude * Math.exp(-(dx * dx + dy * dy));
        });

        value += Math.sin(x * waveOne.x + y * waveOne.y + waveOne.phase) * 0.28;
        value += Math.cos(x * waveTwo.x - y * waveTwo.y + waveTwo.phase) * 0.22;

        return value;
      };
    }

    getContourLineChains(values, rows, columns, threshold) {
      const segments = [];

      for (let row = 0; row < rows; row += 1) {
        for (let column = 0; column < columns; column += 1) {
          const topLeft = values[row][column];
          const topRight = values[row][column + 1];
          const bottomRight = values[row + 1][column + 1];
          const bottomLeft = values[row + 1][column];

          segments.push(...this.getContourSegments(topLeft, topRight, bottomRight, bottomLeft, threshold));
        }
      }

      return this.buildContourChains(segments);
    }

    buildContourChains(segments) {
      if (!segments.length) return [];

      const unused = new Set(segments.map((_, index) => index));
      const endpointMap = new Map();
      segments.forEach((segment, index) => {
        segment.forEach((point) => {
          const key = this.getContourPointKey(point);
          if (!endpointMap.has(key)) endpointMap.set(key, new Set());
          endpointMap.get(key).add(index);
        });
      });

      const takeNextSegment = (point) => {
        const linked = endpointMap.get(this.getContourPointKey(point));
        if (!linked) return null;

        for (const index of linked) {
          if (unused.has(index)) return index;
        }

        return null;
      };

      const chains = [];
      while (unused.size) {
        const firstIndex = unused.values().next().value;
        unused.delete(firstIndex);
        const chain = [segments[firstIndex][0], segments[firstIndex][1]];

        const extend = (append) => {
          while (true) {
            const targetPoint = append ? chain[chain.length - 1] : chain[0];
            const nextIndex = takeNextSegment(targetPoint);
            if (nextIndex === null) break;

            unused.delete(nextIndex);
            const [from, to] = segments[nextIndex];
            const nextPoint = this.getContourPointKey(from) === this.getContourPointKey(targetPoint) ? to : from;

            if (append) {
              chain.push(nextPoint);
            } else {
              chain.unshift(nextPoint);
            }
          }
        };

        extend(true);
        extend(false);
        if (chain.length > 1) chains.push(chain);
      }

      return chains;
    }

    getContourPointKey(point) {
      return `${point.x.toFixed(1)}:${point.y.toFixed(1)}`;
    }

    isClosedContourChain(chain) {
      if (chain.length < 4) return false;

      const first = chain[0];
      const last = chain[chain.length - 1];
      return Math.hypot(first.x - last.x, first.y - last.y) < 6;
    }

    getContourSegments(topLeft, topRight, bottomRight, bottomLeft, threshold) {
      const edges = [
        [topLeft, topRight],
        [topRight, bottomRight],
        [bottomRight, bottomLeft],
        [bottomLeft, topLeft]
      ];
      const intersections = [];

      edges.forEach(([from, to]) => {
        const fromAbove = from.value >= threshold;
        const toAbove = to.value >= threshold;

        if (fromAbove === toAbove) return;

        const amount = (threshold - from.value) / (to.value - from.value || 1);
        intersections.push({
          x: from.x + (to.x - from.x) * amount,
          y: from.y + (to.y - from.y) * amount
        });
      });

      if (intersections.length === 2) {
        return [[intersections[0], intersections[1]]];
      }

      if (intersections.length === 4) {
        return [
          [intersections[0], intersections[1]],
          [intersections[2], intersections[3]]
        ];
      }

      return [];
    }

    drawTransparentWindow() {
      this.layer.add(new Konva.Shape({
        fill: '#000000',
        globalCompositeOperation: 'destination-out',
        listening: false,
        sceneFunc: (context, shape) => {
          context.beginPath();
          context.moveTo(224, -60);
          context.lineTo(1012, -60);
          context.lineTo(1012, 766);
          context.quadraticCurveTo(1012, 837, 938, 837);
          context.lineTo(298, 837);
          context.quadraticCurveTo(224, 837, 224, 766);
          context.closePath();
          context.fillStrokeShape(shape);
        }
      }));
    }

    drawWindowBrandCopy() {
      const copyGroups = [
        { label: 'Designed', y: 236, strong: 'smallsmore' },
        { label: 'Shaped', y: 448, strong: 'you' }
      ];
      const labelFontSize = 51;
      const strongFontSize = 43;
      const byColumnWidth = 74;
      const byLineOffset = 74;
      const strongLineOffset = 77;
      const blockWidth = Math.max(
        ...copyGroups.flatMap((copy) => [
          this.measureTextWidth(copy.label, labelFontSize, WINDOW_COPY_FONT_FAMILY, 'italic'),
          byColumnWidth + this.measureTextWidth(copy.strong, strongFontSize, 'Outfit', '800')
        ])
      );
      const blockX = WINDOW_COPY_AREA.x + (WINDOW_COPY_AREA.width - blockWidth) / 2;

      copyGroups.forEach((copy) => {
        this.layer.add(new Konva.Text({
          x: blockX,
          y: copy.y,
          text: copy.label,
          fontFamily: WINDOW_COPY_FONT_FAMILY,
          fontSize: labelFontSize,
          fontStyle: 'italic',
          fill: WINDOW_COPY_INK,
          listening: false
        }));

        this.layer.add(new Konva.Text({
          x: blockX,
          y: copy.y + byLineOffset,
          text: 'by',
          fontFamily: WINDOW_COPY_FONT_FAMILY,
          fontSize: labelFontSize,
          fontStyle: 'italic',
          fill: WINDOW_COPY_INK,
          listening: false
        }));

        this.layer.add(new Konva.Text({
          x: blockX + byColumnWidth,
          y: copy.y + strongLineOffset,
          text: copy.strong,
          fontFamily: 'Outfit',
          fontSize: strongFontSize,
          fontStyle: '800',
          fill: WINDOW_COPY_INK,
          listening: false
        }));
      });

      this.drawWindowShopUrl();
    }

    drawWindowShopUrl() {
      if (!this.hasThemeBleed()) return;

      const fontSize = 42;
      const iconSize = 39;
      const iconScale = iconSize / 24;
      const gap = 22;
      const markY = 699;
      const textWidth = this.measureTextWidth(WINDOW_SHOP_URL_TEXT, fontSize, WINDOW_COPY_FONT_FAMILY, 'italic');
      const markWidth = iconSize + gap + textWidth;
      const markX = WINDOW_COPY_AREA.x + (WINDOW_COPY_AREA.width - markWidth) / 2;

      const iconGroup = new Konva.Group({
        x: markX,
        y: markY + 2,
        scaleX: iconScale,
        scaleY: iconScale,
        listening: false
      });
      iconGroup.add(new Konva.Path({
        data: WINDOW_SHOP_ICON_PATH,
        stroke: WINDOW_SHOP_URL_INK,
        strokeWidth: 1.8,
        lineCap: 'round',
        lineJoin: 'round',
        fillEnabled: false,
        listening: false
      }));
      [9, 20].forEach((x) => {
        iconGroup.add(new Konva.Circle({
          x,
          y: 21,
          radius: 1,
          stroke: WINDOW_SHOP_URL_INK,
          strokeWidth: 1.8,
          fillEnabled: false,
          listening: false
        }));
      });

      this.layer.add(iconGroup);
      this.layer.add(new Konva.Text({
        x: markX + iconSize + gap,
        y: markY - 1,
        text: WINDOW_SHOP_URL_TEXT,
        fontFamily: WINDOW_COPY_FONT_FAMILY,
        fontSize,
        fontStyle: 'italic',
        fill: WINDOW_SHOP_URL_INK,
        listening: false
      }));
    }

    drawStatusMarks() {
      const accent = this.getPaletteColor('accent');
      const secondary = this.getPaletteColor('text');
      const mutedLine = this.getPaletteColor('pattern');

      [0, 9, 18, 27].forEach((offset) => {
        this.layer.add(new Konva.Rect({
          x: 107,
          y: 1876 + offset,
          width: 34,
          height: 5,
          fill: accent,
          listening: false
        }));
      });

      this.layer.add(new Konva.Text({
        x: 149,
        y: 1877,
        text: 'TYPE.  CONNECT.  CREATE.',
        fontFamily: MONO_FONT_FAMILY,
        fontSize: 30,
        fill: secondary,
        listening: false
      }));

      const regionCountryText = this.isStandardCustomizationMode() ? '' : this.getRegionCountryText();
      const shouldDrawGlobe = this.isStandardCustomizationMode() || this.shouldShowRegionMark();
      const globeCenterY = 1892.9;
      if (regionCountryText) {
        const regionCountryNode = new Konva.Text({
          x: 758,
          y: 0,
          text: regionCountryText,
          fontFamily: SCALE_BAR_FONT_FAMILY,
          fontSize: 44,
          width: 340,
          align: 'right',
          fill: secondary,
          listening: false
        });
        regionCountryNode.y(globeCenterY - (regionCountryNode.height() / 2));
        this.layer.add(regionCountryNode);
      }

      if (shouldDrawGlobe) {
        this.drawGlobe(1144.9, globeCenterY, 27.9, secondary);
      }

      this.layer.add(new Konva.Rect({
        x: 1171,
        y: 280,
        width: 32,
        height: 32,
        fill: accent,
        listening: false
      }));

      [190, 235].forEach((y) => {
        this.layer.add(new Konva.Rect({
          x: 1171,
          y,
          width: 32,
          height: 32,
          stroke: secondary,
          strokeWidth: 4,
          listening: false
        }));
      });
    }

    drawGlobe(x, y, radius, color) {
      this.layer.add(new Konva.Circle({
        x,
        y,
        radius,
        stroke: color,
        strokeWidth: 5,
        listening: false
      }));
      this.layer.add(new Konva.Line({
        points: [x - radius, y, x + radius, y],
        stroke: color,
        strokeWidth: 4,
        listening: false
      }));
      this.layer.add(new Konva.Ellipse({
        x,
        y,
        radiusX: radius * 0.45,
        radiusY: radius,
        stroke: color,
        strokeWidth: 4,
        listening: false
      }));
    }

    drawText() {
      const [topLine, bottomLine] = this.getMainTextLines();
      const primary = this.getPaletteColor('text');
      const secondary = this.getPaletteColor('text');
      const textFontFamily = this.getSelectedTextFont();
      const textFontStyle = this.getSelectedTextFontStyle();
      const topSize = MAIN_TEXT_AREA.topFontSize;
      const bottomSize = bottomLine ? MAIN_TEXT_AREA.bottomFontSize : 0;
      const sideText = this.getSideText();
      const sideSize = this.fitFontSize(sideText, 70, 390, 34, 'Outfit');
      const sideTextVisualTop = BASE_HEIGHT * 0.1975;
      const sideTextAnchorY = sideTextVisualTop + this.measureTextWidth(DEFAULT_SIDE_TEXT, 70, 'Outfit');
      const builtForInputVisualTop = BASE_HEIGHT * 0.0435;

      this.layer.add(new Konva.Text({
        x: MAIN_TEXT_AREA.x,
        y: MAIN_TEXT_AREA.topY,
        text: topLine,
        fontFamily: textFontFamily,
        fontSize: topSize,
        fontStyle: textFontStyle,
        fill: primary,
        width: MAIN_TEXT_AREA.width,
        wrap: 'none',
        ellipsis: false,
        listening: false
      }));

      if (bottomLine) {
        this.layer.add(new Konva.Text({
          x: MAIN_TEXT_AREA.x,
          y: MAIN_TEXT_AREA.bottomY,
          text: bottomLine,
          fontFamily: textFontFamily,
          fontSize: bottomSize,
          fontStyle: textFontStyle,
          fill: primary,
          width: MAIN_TEXT_AREA.width,
          wrap: 'none',
          ellipsis: false,
          listening: false
        }));
      }

      this.layer.add(new Konva.Text({
        x: 1034,
        y: sideTextAnchorY,
        text: sideText,
        fontFamily: 'Outfit',
        fontSize: sideSize,
        fontStyle: '800',
        align: 'left',
        fill: primary,
        rotation: -90,
        listening: false
      }));

      this.layer.add(new Konva.Text({
        x: 1122,
        y: builtForInputVisualTop + this.measureTextWidth('BUILT FOR INPUT', 30, MONO_FONT_FAMILY, '400'),
        text: 'BUILT FOR INPUT',
        fontFamily: MONO_FONT_FAMILY,
        fontSize: 30,
        fill: secondary,
        rotation: -90,
        listening: false
      }));
    }

    drawBottomText(options = {}) {
      if (this.isStandardCustomizationMode()) {
        this.drawStandardBottomBrand();
        return;
      }

      if (this.bottomTextSkipped) return;

      const text = this.getBottomText();
      if (!text) {
        if (options.showGuide) this.addBottomTextEmptyGuide();
        return;
      }

      const lines = text.split('\n').filter(Boolean);
      const textFontFamily = this.getSelectedTextFont();
      const textFontStyle = this.getSelectedTextFontStyle();
      const textStyle = this.getBottomTextStyle();
      const textSizeScale = Number(this.textSizeScale) || 1;
      const baseFontSize = BOTTOM_TEXT_AREA.fontSize * textSizeScale;
      const minFontSize = BOTTOM_TEXT_AREA.minFontSize * textSizeScale;
      const fontSize = Math.min(
        baseFontSize,
        ...lines.map((line) => this.fitFontSize(line, baseFontSize, BOTTOM_TEXT_AREA.width, minFontSize, textFontFamily, textFontStyle))
      );
      const textWidth = this.getBottomTextBlockWidth(lines, fontSize, textFontFamily, textFontStyle);
      const textHeight = Math.max(BOTTOM_TEXT_AREA.height, fontSize * lines.length * BOTTOM_TEXT_AREA.lineHeight);
      const bottomClearance = Math.min(18, Math.max(12, fontSize * 0.32));
      const textY = lines.length >= 3
        ? BOTTOM_TEXT_AREA.y + BOTTOM_TEXT_AREA.height - textHeight - bottomClearance
        : BOTTOM_TEXT_AREA.y + ((BOTTOM_TEXT_AREA.height - textHeight) / 2);
      this.layer.add(new Konva.Text({
        x: BOTTOM_TEXT_AREA.x + ((BOTTOM_TEXT_AREA.width - textWidth) / 2),
        y: textY,
        text,
        fontFamily: textFontFamily,
        fontSize,
        fontStyle: textFontStyle,
        fill: textStyle.fill,
        stroke: textStyle.stroke,
        strokeWidth: textStyle.strokeWidth,
        width: textWidth,
        height: textHeight,
        align: textStyle.align || 'center',
        verticalAlign: 'middle',
        lineHeight: BOTTOM_TEXT_AREA.lineHeight,
        wrap: 'none',
        ellipsis: false,
        listening: false
      }));
      const textNode = this.layer.children[this.layer.children.length - 1];
      if (textNode && typeof textNode.fillAfterStrokeEnabled === 'function') {
        textNode.fillAfterStrokeEnabled(true);
      }
    }

    drawStandardBottomBrand() {
      const text = 'smallsmore';
      const fontFamily = 'Outfit';
      const fontStyle = '800';
      const maxFontSize = Math.round(BOTTOM_TEXT_AREA.fontSize * 0.82);
      const minFontSize = Math.round(BOTTOM_TEXT_AREA.minFontSize * 0.9);
      const fontSize = this.fitFontSize(text, maxFontSize, BOTTOM_TEXT_AREA.width, minFontSize, fontFamily, fontStyle);
      const fill = this.getStandardBottomBrandFill();

      this.layer.add(new Konva.Text({
        x: BOTTOM_TEXT_AREA.x,
        y: BOTTOM_TEXT_AREA.y + ((BOTTOM_TEXT_AREA.height - fontSize * BOTTOM_TEXT_AREA.lineHeight) / 2),
        text,
        fontFamily,
        fontSize,
        fontStyle,
        fill,
        width: BOTTOM_TEXT_AREA.width,
        height: fontSize * BOTTOM_TEXT_AREA.lineHeight,
        align: 'center',
        verticalAlign: 'middle',
        lineHeight: BOTTOM_TEXT_AREA.lineHeight,
        wrap: 'none',
        ellipsis: false,
        listening: false
      }));
    }

    getStandardBottomBrandFill() {
      if (this.isPureColorTemplate()) return this.getPureColorStandardBrandFill();

      return STANDARD_BOTTOM_BRAND_FILL;
    }

    getPureColorStandardBrandFill() {
      const patchColor = this.getActivePatchColor();
      const patchColorId = (patchColor && patchColor.id) || this.patchColorId || '';

      return PURE_COLOR_STANDARD_BRAND_FILLS[patchColorId] || PURE_COLOR_STANDARD_BRAND_FALLBACK_FILL;
    }

    addBottomTextEmptyGuide() {
      this.layer.add(this.createDashedGuideRect(BOTTOM_TEXT_AREA, 'customizer-empty-text-guide'));
      this.addGuideLabel(BOTTOM_TEXT_AREA, 'Text area', {
        fontSize: BOTTOM_TEXT_AREA.guideFontSize
      });
    }

    createDashedGuideRect(area, name) {
      return new Konva.Rect({
        name: `customizer-empty-guide ${name}`,
        x: area.x,
        y: area.y,
        width: area.width,
        height: area.height,
        dash: area.guideDash || [12, 10],
        stroke: '#ffffff',
        strokeWidth: area.guideStrokeWidth || 3,
        listening: false
      });
    }

    addGuideLabel(area, text, options = {}) {
      const fontSize = options.fontSize || 26;
      this.layer.add(new Konva.Text({
        name: 'customizer-empty-guide customizer-empty-guide-label',
        x: area.x,
        y: area.y + area.height / 2 - fontSize / 2,
        width: area.width,
        align: 'center',
        fill: '#ffffff',
        fontSize,
        fontStyle: '800',
        text,
        listening: false
      }));
    }

    ensureProductionLineId() {
      if (!this.productionLineId) this.productionLineId = this.createProductionLineId();
      return this.productionLineId;
    }

    createProductionLineId() {
      return `smr_${Date.now().toString(36)}_${this.createProductionLineRandomSuffix()}`;
    }

    createProductionLineRandomSuffix() {
      const cryptoApi = window.crypto || window.msCrypto;
      if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
        return cryptoApi.randomUUID().replace(/[^a-z0-9]+/gi, '').slice(0, 12).toLowerCase();
      }
      if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
        const values = new Uint32Array(2);
        cryptoApi.getRandomValues(values);
        return Array.from(values).map((value) => value.toString(36)).join('').slice(0, 12);
      }
      return Math.random().toString(36).slice(2, 14);
    }

    getPayload() {
      const palette = this.activePalette || this.getPalettes()[0];
      const contourTemplate = this.isContourTemplate();
      const pureColorTemplate = this.isPureColorTemplate();
      const bottomTextTemplate = this.isBottomTextTemplate();
      const theme = this.getThemeId();
      const textSize = this.getTextSizePayload();
      const bottomTextStyle = this.getEffectiveBottomTextStyle();
      const caseColor = this.getActiveCaseColor();
      const buttonColor = this.getActiveButtonColor();
      const patchColor = this.getActivePatchColor();

      return {
        ...(theme && !pureColorTemplate ? {
          series: 'theme',
          theme
        } : {}),
        ...(pureColorTemplate ? {
          series: 'pure_color'
        } : {}),
        template_id: this.getTemplateId(),
        template_label: this.getTemplateLabel(),
        variant_id: this.config.variant_id,
        production_line_id: this.productionLineId || '',
        main_text: bottomTextTemplate ? '' : this.getMainText(),
        side_text: bottomTextTemplate ? '' : this.getSideText(),
        bottom_text: bottomTextTemplate ? this.getBottomText() : '',
        text_font: this.getSelectedTextFont(),
        bottom_text_skipped: bottomTextTemplate ? Boolean(this.bottomTextSkipped) : false,
        ...(bottomTextTemplate ? {
          text_size: textSize.id,
          text_size_scale: textSize.scale,
          text_align: bottomTextStyle.align,
          text_color: bottomTextStyle.fill,
          text_color_id: bottomTextStyle.colorId,
          text_stroke: bottomTextStyle.stroke,
          text_stroke_width: bottomTextStyle.strokeWidth,
          text_stroke_id: bottomTextStyle.strokeId
        } : {}),
        region_text: contourTemplate && this.shouldShowRegionMark() ? this.getRegionText() : '',
        show_region: contourTemplate ? this.shouldShowRegionMark() : false,
        case_color: this.getHardwareColorPayload(caseColor),
        button_color: this.getHardwareColorPayload(buttonColor),
        patch_color: pureColorTemplate ? this.getHardwareColorPayload(patchColor) : null,
        customization_mode: this.getCustomizationMode(),
        terrain_choice: contourTemplate ? this.getTerrainChoiceLabel() : '',
        palette_id: palette.id,
        palette_label: palette.label,
        colors: {
          base: palette.base || palette.black || palette.background,
          pattern: palette.pattern || palette.grid,
          text: palette.text || palette.white || palette.secondary || palette.primary,
          accent: palette.accent || palette.red
        },
        terrain: contourTemplate ? this.getTerrainPayload() : null,
        print_file: {
          format: 'png',
          ...this.getPrintDimensions(),
          ...(this.hasThemeBleed() ? this.getThemePrintMetadata() : {})
        },
        preview_url: this.previewUploadMeta && this.previewUploadMeta.url ? this.previewUploadMeta.url : ''
      };
    }

    getRoute(path, fallback) {
      return window.routes && window.routes[path] ? window.routes[path] : fallback;
    }

    waitForNextFrame() {
      return new Promise((resolve) => {
        if (typeof window.requestAnimationFrame !== 'function') {
          window.setTimeout(resolve, 0);
          return;
        }

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(resolve);
        });
      });
    }

    async addCurrentFormToCart() {
      const response = await fetch(this.getRoute('cart_add_url', '/cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(this.nodes.form)
      });
      const data = await response.json().catch(() => null);

      if (!response.ok || (data && data.status)) {
        const message = data && (data.description || data.message)
          ? data.description || data.message
          : 'The updated patch could not be added to cart.';
        throw new Error(message);
      }

      return data;
    }

    async removeOriginalCartItem(cartKey) {
      if (!cartKey) return null;

      const response = await fetch(this.getRoute('cart_change_url', '/cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: cartKey,
          quantity: 0
        })
      });
      const data = await response.json().catch(() => null);

      if (!response.ok || (data && data.status)) {
        throw new Error('The previous cart item could not be removed.');
      }

      return data;
    }

    getPreviewThemeIdForRedirect(currentUrl = new URL(window.location.href)) {
      const explicitThemeId = currentUrl.searchParams.get('preview_theme_id');
      if (explicitThemeId) return explicitThemeId;

      const shopifyTheme = window.Shopify && window.Shopify.theme ? window.Shopify.theme : null;
      const themeId = shopifyTheme && shopifyTheme.id ? String(shopifyTheme.id) : '';
      const themeRole = shopifyTheme && shopifyTheme.role ? String(shopifyTheme.role) : '';

      return themeId && themeRole !== 'main' ? themeId : '';
    }

    getCartUrlWithPreviewParams() {
      const cartUrl = new URL(this.getRoute('cart_url', '/cart'), window.location.origin);
      const currentUrl = new URL(window.location.href);
      const previewThemeId = this.getPreviewThemeIdForRedirect(currentUrl);

      ['preview_theme_id', '_fd', 'pb'].forEach((name) => {
        if (currentUrl.searchParams.has(name)) {
          cartUrl.searchParams.set(name, currentUrl.searchParams.get(name));
        }
      });
      if (previewThemeId) cartUrl.searchParams.set('preview_theme_id', previewThemeId);

      return cartUrl;
    }

    redirectToCart() {
      const cartUrl = this.getCartUrlWithPreviewParams();
      window.location.href = cartUrl.toString();
    }

    prepareNativeCartReturnTo() {
      if (!this.nodes.form) return;

      const cartUrl = this.getCartUrlWithPreviewParams();
      let returnTo = this.nodes.form.querySelector('[data-patch-return-to]');
      if (!returnTo) {
        returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        returnTo.dataset.patchReturnTo = 'true';
        this.nodes.form.append(returnTo);
      }
      returnTo.value = `${cartUrl.pathname}${cartUrl.search}`;
    }

    submitNativeCartForm() {
      this.prepareNativeCartReturnTo();
      if (typeof HTMLFormElement !== 'undefined' && HTMLFormElement.prototype.submit) {
        HTMLFormElement.prototype.submit.call(this.nodes.form);
        return;
      }
      this.nodes.form.submit();
    }

    prepareShopifyPrintFileFallback(file) {
      if (!file || !this.nodes.printFile || typeof DataTransfer !== 'function') return false;

      const transfer = new DataTransfer();
      transfer.items.add(file);
      this.nodes.printFile.files = transfer.files;
      this.nodes.printFile.name = 'properties[_smallsmore_print_file]';
      this.nodes.printFile.disabled = false;
      if (this.nodes.propertyPrintFile) {
        this.nodes.propertyPrintFile.value = '';
        this.nodes.propertyPrintFile.disabled = true;
      }
      this.useNativeCartSubmit = true;
      return true;
    }

    async submitEditedCartItem(payload = null, uploadedPrint = null) {
      this.setStatus('Adding your revised patch to cart...', '');
      const cartAddData = await this.addCurrentFormToCart();
      await this.logCartAdd(payload, cartAddData, uploadedPrint);
      this.setStatus('Removing the earlier patch from your cart...', '');
      await this.removeOriginalCartItem(this.editCartKey);
      this.redirectToCart();
    }

    async prepareSubmit(event) {
      event.preventDefault();
      const submitter = event.submitter || null;
      const isAddSubmit = submitter === this.nodes.submitButton || this.isAddSubmitIntent;
      this.isAddSubmitIntent = false;

      if (!isAddSubmit) {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
        return;
      }

      if (this.isSubmitting) return;

      if (this.promptForBottomTextBeforeSubmit()) {
        return;
      }

      if (this.isContourTemplate() && !this.isStandardCustomizationMode() && !this.hasTerrainForCurrentSelection()) {
        if (this.hasPendingTerrainInput()) {
          this.setStatus('Generate the map before adding this patch to cart.', 'error');
          this.setPreviewStatus('GET MAP FIRST', 'error');
          this.openTerrainReminderDialog();
          return;
        }

        this.setStatus('Choose a location or enter coordinates, then click Get the map before adding this patch.', 'error');
        this.setPreviewStatus('GET MAP FIRST', 'error');
        return;
      }

      if (this.isContourTemplate() && this.isStandardCustomizationMode() && !this.hasTerrainForCurrentSelection()) {
        this.ensureStandardRandomPattern({ silent: true });
      }

      let payload = this.getPayload();
      if (!payload.variant_id) {
        this.setStatus('No Shopify variant is configured for this patch template yet.', 'error');
        return;
      }

      this.ensureProductionLineId();
      payload = this.getPayload();

      this.isSubmitting = true;
      if (this.nodes.submitButton) {
        this.nodes.submitButton.disabled = true;
      }

      this.openCartAddingDialog({
        title: this.editCartKey ? 'Updating cart' : 'Adding to cart',
        message: 'Preparing your custom print file.'
      });
      await this.waitForNextFrame();

      try {
        const shouldCreatePrintFile = Boolean(payload.print_file);
        let uploadedPrint = null;
        let draftRecord = null;

        if (shouldCreatePrintFile) {
          this.updateCartAddingDialog({
            title: this.editCartKey ? 'Updating cart' : 'Adding to cart',
            message: 'Rendering your print-ready artwork.'
          });
          this.setStatus('Preparing print-ready artwork...', '');
          draftRecord = await this.saveCurrentEditDraft(payload);
          this.syncEditDraftProperties(draftRecord);
          if (!draftRecord) {
            this.updateCartAddingDialog({
              title: this.editCartKey ? 'Updating cart' : 'Adding to cart',
              message: this.editCartKey
                ? 'Draft storage is unavailable, but this version can still replace the cart item.'
                : 'Draft storage is unavailable, so this case may not be editable after you leave.'
            });
            this.setStatus('Draft storage is unavailable, so this patch may not be editable after you leave.', 'warning');
          }
          uploadedPrint = await this.prepareUploadedPrintFile(payload);
          this.previewUploadMeta = await this.prepareVisiblePreviewUpload(payload).catch(() => null);
          payload.preview_url = this.previewUploadMeta && this.previewUploadMeta.url ? this.previewUploadMeta.url : '';
          payload = this.decoratePayloadForEdit(payload, draftRecord);
        } else {
          this.syncEditDraftProperties(null);
          this.previewUploadMeta = null;
        }

        const includeCustomerVisibleDetails = false;

        this.nodes.variantId.value = payload.variant_id;
        this.setLineItemProperty(this.nodes.propertyTemplate, payload.template_label, includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyMainText, payload.main_text || '', includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertySideText, payload.side_text || '', includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyBottomText, payload.bottom_text || '', includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyTextFont, payload.text_font || '', includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyTextColor, payload.text_color || '', includeCustomerVisibleDetails);
        this.setLineItemProperty(
          this.nodes.propertyTextOutline,
          payload.text_stroke_id === 'none' ? 'None' : `${payload.text_stroke || ''} / ${payload.text_stroke_width || 0}px`,
          includeCustomerVisibleDetails
        );
        this.setLineItemProperty(this.nodes.propertyRegion, payload.region_text, includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyShowRegion, payload.show_region ? 'Yes' : 'No', includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyCustomization, payload.customization_mode || '', includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyTerrainChoice, payload.terrain_choice || payload.region_text || '', includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyCaseColor, this.formatHardwareColorProperty(payload.case_color), includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyButtonColor, this.formatHardwareColorProperty(payload.button_color), true);
        this.setLineItemProperty(this.nodes.propertyPatchColor, this.formatHardwareColorProperty(payload.patch_color || payload.button_color), includeCustomerVisibleDetails);
        this.setLineItemProperty(this.nodes.propertyPalette, payload.palette_label, includeCustomerVisibleDetails);
        this.setLineItemProperty(
          this.nodes.propertyPrintResolution,
          payload.print_file ? `${payload.print_file.width} x ${payload.print_file.height}px PNG` : '',
          includeCustomerVisibleDetails
        );
        this.setLineItemProperty(this.nodes.propertyPrintFile, uploadedPrint ? uploadedPrint.url : '', Boolean(uploadedPrint));
        this.setLineItemProperty(this.nodes.propertyDesignImage, this.previewUploadMeta ? this.previewUploadMeta.url : '', Boolean(this.previewUploadMeta));
        this.setLineItemProperty(this.nodes.propertyProductionLineId, payload.production_line_id || '', Boolean(payload.production_line_id));
        this.setLineItemProperty(this.nodes.propertyPayload, JSON.stringify(payload), true);
        this.setLineItemProperty(this.nodes.propertyEditDraftId, this.nodes.propertyEditDraftId ? this.nodes.propertyEditDraftId.value : '', Boolean(this.nodes.propertyEditDraftId && this.nodes.propertyEditDraftId.value));
        this.setLineItemProperty(this.nodes.propertyEditPath, this.nodes.propertyEditPath ? this.nodes.propertyEditPath.value : '', Boolean(this.nodes.propertyEditPath && this.nodes.propertyEditPath.value));

        if (!this.validatePurchaseCartProperties(payload)) {
          throw new Error('Button color was not saved. Please reselect a button color and add to cart again.');
        }

        if (this.editCartKey) {
          this.updateCartAddingDialog({
            title: 'Updating cart',
            message: 'Replacing the earlier version.'
          });
          await this.submitEditedCartItem(payload, uploadedPrint);
          return;
        }

        this.updateCartAddingDialog({
          title: 'Adding to cart',
          message: 'Sending your custom case to the cart.'
        });
        this.setStatus('Adding your customized patch to cart...', '');
        if (this.useNativeCartSubmit) {
          this.updateCartAddingDialog({
            title: 'Adding to cart',
            message: 'Uploading your print file through Shopify.'
          });
          this.submitNativeCartForm();
          return;
        }
        const cartAddData = await this.addCurrentFormToCart();
        await this.logCartAdd(payload, cartAddData, uploadedPrint);
        this.redirectToCart();
      } catch (error) {
        this.isSubmitting = false;
        if (this.nodes.submitButton) {
          this.nodes.submitButton.disabled = false;
        }
        this.closeCartAddingDialog();
        this.setStatus(error && error.message ? error.message : 'The print file could not be uploaded. Please refresh and try again.', 'error');
      }
    }

    async prepareUploadedPrintFile(payload) {
      await this.ensureEditorFontsLoaded();

      this.render();
      const file = await this.createGeneratedPrintFile(payload.print_file, this.getPrintFilename(payload));

      if (this.nodes.printFile && window.DataTransfer) {
        const transfer = new DataTransfer();
        transfer.items.add(file);
        this.nodes.printFile.files = transfer.files;
      }

      this.updateCartAddingDialog({
        title: this.editCartKey ? 'Updating cart' : 'Adding to cart',
        message: 'Uploading your print file.'
      });
      this.setStatus('Uploading print file...', '');
      let uploadedPrint = null;
      try {
        uploadedPrint = await this.uploadPrintFile(file, payload);
      } catch (error) {
        if (!this.prepareShopifyPrintFileFallback(file)) throw error;
      }
      payload.print_file = {
        ...payload.print_file,
        file_name: file.name,
        size_bytes: file.size,
        url: uploadedPrint ? uploadedPrint.url : '',
        pathname: uploadedPrint ? uploadedPrint.pathname : '',
        provider: uploadedPrint ? uploadedPrint.provider : 'shopify-line-item-file',
        asset_id: uploadedPrint ? uploadedPrint.assetId : `shopify-file-upload:${file.name}`,
        temporary: uploadedPrint ? uploadedPrint.temporary : false
      };

      return uploadedPrint;
    }

    async prepareVisiblePreviewUpload(payload) {
      const blob = await this.prepareSharePreviewBlob(SHARE_PREVIEW_SIZE);
      const file = new File([blob], this.getPreviewFilename(payload), { type: 'image/png' });
      return this.uploadPrintFile(file, {
        ...payload,
        customize_mode: 'preview'
      });
    }

    async createGeneratedPrintFile(printFile, filename) {
      if (!this.stage) {
        throw new Error('Missing patch stage.');
      }

      const printConfig = printFile && typeof printFile === 'object' ? printFile : { width: Number(printFile) || BASE_WIDTH };
      const canvasWidth = Number(printConfig.canvas_width_units) || BASE_WIDTH;
      const canvasHeight = Number(printConfig.canvas_height_units) || BASE_HEIGHT;
      const outputPixelRatio = Number(printConfig.pixelRatio) || (Number(printConfig.width) || canvasWidth) / canvasWidth;
      const useBleed = printConfig.production_clip === 'bleed' && this.hasThemeBleed();
      const container = document.createElement('div');
      container.style.left = '-99999px';
      container.style.position = 'fixed';
      container.style.top = '0';
      document.body.append(container);

      const printStage = new Konva.Stage({
        container,
        width: canvasWidth,
        height: canvasHeight
      });
      const printLayer = new Konva.Layer();
      printStage.add(printLayer);
      this.drawPatchArtwork(printLayer, {
        clipMode: useBleed ? 'bleed' : 'preview',
        omitPatchBase: this.isPureColorTemplate(),
        showTextGuide: false
      });
      printLayer.draw();

      const dataUrl = printStage.toDataURL({
        mimeType: 'image/png',
        pixelRatio: outputPixelRatio
      });
      printStage.destroy();
      container.remove();

      const response = await fetch(dataUrl);
      const blob = await response.blob();
      return new File([blob], filename, { type: 'image/png' });
    }

    async uploadPrintFile(file, payload) {
      const endpoint = typeof this.config.design_upload_endpoint === 'string' ? this.config.design_upload_endpoint.trim() : '';
      if (!endpoint) throw new Error('Design upload endpoint is not configured.');

      const body = new FormData();
      body.append('design_file', file);
      body.append('filename', file.name);
      body.append('template_id', payload.template_id || '');
      body.append('customize_mode', payload.customize_mode || 'patch');

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), DESIGN_UPLOAD_TIMEOUT_MS);
      let response;

      try {
        response = await fetch(endpoint, { method: 'POST', body, signal: controller.signal });
      } finally {
        window.clearTimeout(timeout);
      }

      const contentType = response.headers.get('content-type') || '';
      const result = contentType.includes('application/json') ? await response.json().catch(() => null) : null;
      if (!response.ok) {
        const message = result && result.error && result.error.message ? result.error.message : `Design upload failed: ${response.status}`;
        throw new Error(message);
      }

      const url = result && (result.url || result.downloadUrl);
      if (!url) throw new Error('Design upload did not return a file URL.');

      const pathname = result.pathname || '';
      return {
        provider: result.provider || 'temporary-storage',
        temporary: result.temporary !== false,
        url,
        pathname,
        assetId: result.asset_id || `temporary-design-upload:${pathname || url}`
      };
    }

    getPrintFilename(payload) {
      const safeText = String(payload.bottom_text || payload.main_text || payload.region_text || 'contour').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 36);
      const safePalette = payload.palette_id || 'palette';
      const suffix = Date.now().toString(36);

      return `smallsmore-${payload.template_id}-${safePalette}-${safeText || 'custom'}-${suffix}.png`;
    }

    getPreviewFilename(payload) {
      const safeTemplate = String(payload.template_id || 'patch').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 32);
      return `smallsmore-preview-${safeTemplate || 'patch'}-${Date.now().toString(36)}.png`;
    }

    setPreviewLoading(isLoading, message = 'GETTING MAP') {
      if (!this.nodes.previewOverlay) return;

      if (isLoading) {
        window.clearTimeout(this.previewOverlayTimer);
        this.updatePreviewOverlayBounds();
        this.nodes.previewOverlay.hidden = false;
        this.nodes.previewOverlay.dataset.state = 'loading';
        this.nodes.previewOverlay.setAttribute('aria-hidden', 'false');
        if (this.nodes.previewOverlayText) this.nodes.previewOverlayText.textContent = message;
        if (this.nodes.previewOverlaySpinner) this.nodes.previewOverlaySpinner.hidden = false;
        return;
      }

      if (this.nodes.previewOverlay.dataset.state === 'loading') {
        this.clearPreviewOverlay();
      }
    }

    setPreviewStatus(message, state = 'success') {
      if (!this.nodes.previewOverlay || !message) return;

      window.clearTimeout(this.previewOverlayTimer);
      this.updatePreviewOverlayBounds();
      this.nodes.previewOverlay.hidden = false;
      this.nodes.previewOverlay.dataset.state = state;
      this.nodes.previewOverlay.setAttribute('aria-hidden', 'false');
      if (this.nodes.previewOverlayText) this.nodes.previewOverlayText.textContent = message;
      if (this.nodes.previewOverlaySpinner) this.nodes.previewOverlaySpinner.hidden = true;

      this.previewOverlayTimer = window.setTimeout(() => {
        this.clearPreviewOverlay();
      }, state === 'success' ? 900 : 3600);
    }

    clearPreviewOverlay() {
      window.clearTimeout(this.previewOverlayTimer);
      if (!this.nodes.previewOverlay) return;

      this.nodes.previewOverlay.hidden = true;
      this.nodes.previewOverlay.removeAttribute('data-state');
      this.nodes.previewOverlay.setAttribute('aria-hidden', 'true');
    }

    updatePreviewOverlayBounds() {
      if (!this.nodes.previewOverlay || !this.nodes.preview || !this.nodes.stage) return;

      const previewRect = this.nodes.preview.getBoundingClientRect();
      const stageRect = this.nodes.stage.getBoundingClientRect();
      const previewSize = this.getPreviewSize();
      const placement = this.getPatchPlacement();
      if (!previewRect.width || !stageRect.width || !previewSize.width || !previewSize.height) return;

      const scaleX = stageRect.width / previewSize.width;
      const scaleY = stageRect.height / previewSize.height;
      const left = stageRect.left - previewRect.left + placement.x * scaleX;
      const top = stageRect.top - previewRect.top + placement.y * scaleY;
      const width = placement.width * scaleX;
      const height = placement.height * scaleY;

      this.nodes.previewOverlay.style.setProperty('--sm-patch-overlay-left', `${left}px`);
      this.nodes.previewOverlay.style.setProperty('--sm-patch-overlay-top', `${top}px`);
      this.nodes.previewOverlay.style.setProperty('--sm-patch-overlay-width', `${width}px`);
      this.nodes.previewOverlay.style.setProperty('--sm-patch-overlay-height', `${height}px`);
    }

    setStatus(message, state) {
      if (!this.nodes.status) return;

      window.clearTimeout(this.statusTimer);
      this.nodes.status.textContent = message;
      this.nodes.status.hidden = !message;
      if (state) {
        this.nodes.status.dataset.state = state;
      } else {
        this.nodes.status.removeAttribute('data-state');
      }

      if (state === 'success') {
        this.statusTimer = window.setTimeout(() => {
          this.nodes.status.textContent = '';
          this.nodes.status.hidden = true;
          this.nodes.status.removeAttribute('data-state');
        }, 2400);
      }
    }

    openCartAddingDialog(options = {}) {
      if (!this.nodes.cartAdding) return;

      if (this.nodes.cartAddingTitle && options.title) {
        this.nodes.cartAddingTitle.textContent = options.title;
      }
      if (this.nodes.cartAddingMessage && options.message) {
        this.nodes.cartAddingMessage.textContent = options.message;
      }

      this.mountCartAddingDialog();
      this.nodes.cartAdding.hidden = false;
      this.nodes.cartAdding.setAttribute('aria-hidden', 'false');
      this.root.classList.add('smallsmore-patch-customizer--cart-adding-open');
    }

    updateCartAddingDialog(options = {}) {
      if (!this.nodes.cartAdding || this.nodes.cartAdding.hidden) return;

      if (this.nodes.cartAddingTitle && options.title) {
        this.nodes.cartAddingTitle.textContent = options.title;
      }
      if (this.nodes.cartAddingMessage && options.message) {
        this.nodes.cartAddingMessage.textContent = options.message;
      }
    }

    closeCartAddingDialog() {
      if (!this.nodes.cartAdding) return;

      this.nodes.cartAdding.hidden = true;
      this.nodes.cartAdding.setAttribute('aria-hidden', 'true');
      this.root.classList.remove('smallsmore-patch-customizer--cart-adding-open');
      this.restoreCartAddingDialog();
    }

    mountCartAddingDialog() {
      if (!this.nodes.cartAdding || this.nodes.cartAdding.parentNode === document.body) return;

      this.cartAddingMount = {
        parent: this.nodes.cartAdding.parentNode,
        nextSibling: this.nodes.cartAdding.nextSibling
      };
      document.body.appendChild(this.nodes.cartAdding);
    }

    restoreCartAddingDialog() {
      if (!this.nodes.cartAdding || !this.cartAddingMount?.parent?.isConnected) return;

      const { parent, nextSibling } = this.cartAddingMount;
      parent.insertBefore(this.nodes.cartAdding, nextSibling?.isConnected ? nextSibling : null);
      this.cartAddingMount = null;
    }
  }

  function initPatchCustomizers() {
    document.querySelectorAll(SELECTOR).forEach((root) => {
      new SmallsmorePatchCustomizer(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPatchCustomizers);
  } else {
    initPatchCustomizers();
  }
})();

(function () {
  const TOUR_SELECTOR = '[data-smallsmore-ocase-product-tour]';
  const TARGET_CLASS = 'smallsmore-ocase-product-tour-target';
  const STEPS = [
    {
      targetKey: 'custom',
      title: 'Make it yours',
      copy: 'Choose this when you want to customize the case artwork, text, colors, and button details before adding it to cart.',
      button: 'Next'
    },
    {
      targetKey: 'photo',
      title: 'Real Photo',
      copy: 'See the actual case photo for this design. Your selected button color will still show in Design Preview.',
      button: 'Next'
    },
    {
      targetKey: 'buttons',
      title: 'Mix More Colors',
      copy: 'Choose extra button colors to swap later, or mix different colors for a more personal case combination.',
      button: 'Next'
    },
    {
      targetKey: 'bottom',
      title: 'More OCase details below',
      copy: 'Scroll down for close-up product details about the case build, buttons, MagSafe, and everyday fit.',
      button: 'Got it'
    }
  ];

  function canUseStorage() {
    try {
      const key = 'smallsmore:ocase-product-tour:test';
      window.localStorage.setItem(key, '1');
      window.localStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  }

  const storageAvailable = canUseStorage();

  function isRemembered(key) {
    if (!storageAvailable || !key) return false;
    return window.localStorage.getItem(key) === 'true';
  }

  function shouldIgnoreRemembered() {
    const params = new URLSearchParams(window.location.search);
    return params.has('tour_check') || params.has('tour_reset');
  }

  function remember(key) {
    if (!storageAvailable || !key) return;
    window.localStorage.setItem(key, 'true');
  }

  function isVisible(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  class OCaseProductTour {
    constructor(tour) {
      this.tour = tour;
      this.storageKey = tour.dataset.tourStorageKey || '';
      this.stepIndex = 0;
      this.activeTarget = null;
      this.reposition = this.reposition.bind(this);
      this.closeWithoutRemembering = this.closeWithoutRemembering.bind(this);
      this.nodes = {
        close: tour.querySelector('[data-ocase-product-tour-close]'),
        next: tour.querySelector('[data-ocase-product-tour-next]'),
        step: tour.querySelector('[data-ocase-product-tour-step]'),
        total: tour.querySelector('[data-ocase-product-tour-total]'),
        title: tour.querySelector('[data-ocase-product-tour-title]'),
        copy: tour.querySelector('[data-ocase-product-tour-copy]')
      };
    }

    init() {
      if (this.tour.dataset.ocaseProductTourReady === 'true') return;
      this.tour.dataset.ocaseProductTourReady = 'true';
      if (!shouldIgnoreRemembered() && isRemembered(this.storageKey)) return;
      if (this.tour.parentElement !== document.body) document.body.append(this.tour);

      this.nodes.close?.addEventListener('click', () => this.closeWithoutRemembering());
      this.nodes.next?.addEventListener('click', () => this.goNext());
      document.addEventListener('keydown', this.closeWithoutRemembering);
      window.addEventListener('resize', this.reposition, { passive: true });
      window.addEventListener('scroll', this.reposition, { passive: true });
      window.setTimeout(() => this.waitForStepTarget(0), 450);
    }

    getTarget(index = this.stepIndex) {
      const step = STEPS[index] || STEPS[0];
      if (step.targetKey === 'bottom') return null;
      const selectors = {
        custom: this.tour.dataset.tourCustomTarget,
        photo: this.tour.dataset.tourPhotoTarget,
        buttons: this.tour.dataset.tourButtonsTarget
      };
      const selector = selectors[step.targetKey];
      return selector ? document.querySelector(selector) : null;
    }

    waitForStepTarget(index, attempts = 0) {
      if (STEPS[index]?.targetKey === 'bottom') {
        this.showStep(index);
        return;
      }

      const target = this.getTarget(index);
      if (isVisible(target)) {
        this.showStep(index);
        return;
      }

      if (attempts >= 120) return;
      window.setTimeout(() => this.waitForStepTarget(index, attempts + 1), 120);
    }

    showStep(index) {
      if (STEPS[index]?.targetKey === 'bottom') {
        this.clearTarget();
        this.stepIndex = index;
        this.tour.dataset.placement = 'bottom-center';
        this.tour.classList.add('smallsmore-ocase-product-tour--bottom-center');
        const step = STEPS[index];
        if (this.nodes.step) this.nodes.step.textContent = String(index + 1);
        if (this.nodes.total) this.nodes.total.textContent = String(STEPS.length);
        if (this.nodes.title) this.nodes.title.textContent = step.title;
        if (this.nodes.copy) this.nodes.copy.textContent = step.copy;
        if (this.nodes.next) this.nodes.next.textContent = step.button;
        this.tour.hidden = false;
        this.tour.setAttribute('aria-hidden', 'false');
        window.setTimeout(() => {
          this.reposition();
          this.nodes.next?.focus({ preventScroll: true });
        }, 80);
        return;
      }

      const target = this.getTarget(index);
      if (!isVisible(target)) {
        this.waitForStepTarget(index);
        return;
      }

      this.clearTarget();
      this.stepIndex = index;
      this.activeTarget = target;
      target.classList.add(TARGET_CLASS);
      this.tour.classList.remove('smallsmore-ocase-product-tour--bottom-center');

      const step = STEPS[index];
      if (this.nodes.step) this.nodes.step.textContent = String(index + 1);
      if (this.nodes.total) this.nodes.total.textContent = String(STEPS.length);
      if (this.nodes.title) this.nodes.title.textContent = step.title;
      if (this.nodes.copy) this.nodes.copy.textContent = step.copy;
      if (this.nodes.next) this.nodes.next.textContent = step.button;

      this.tour.hidden = false;
      this.tour.setAttribute('aria-hidden', 'false');
      target.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' });
      window.setTimeout(() => {
        this.reposition();
        this.nodes.next?.focus({ preventScroll: true });
      }, 260);
    }

    goNext() {
      if (this.stepIndex < STEPS.length - 1) {
        this.showStep(this.stepIndex + 1);
        return;
      }

      this.dismiss();
    }

    dismiss() {
      remember(this.storageKey);
      this.hide();
    }

    closeWithoutRemembering(event) {
      if (event && event.type === 'keydown' && event.key !== 'Escape') return;
      this.hide();
    }

    hide() {
      this.clearTarget();
      this.tour.hidden = true;
      this.tour.setAttribute('aria-hidden', 'true');
      this.tour.classList.remove('smallsmore-ocase-product-tour--bottom-center');
      document.removeEventListener('keydown', this.closeWithoutRemembering);
      window.removeEventListener('resize', this.reposition);
      window.removeEventListener('scroll', this.reposition);
    }

    clearTarget() {
      if (this.activeTarget) this.activeTarget.classList.remove(TARGET_CLASS);
      this.activeTarget = null;
    }

    reposition() {
      if (STEPS[this.stepIndex]?.targetKey === 'bottom') {
        if (this.tour.hidden) return;
        const margin = 16;
        const bottomOffset = 72;
        const tourRect = this.tour.getBoundingClientRect();
        const left = (window.innerWidth - tourRect.width) / 2;
        const top = window.innerHeight - tourRect.height - bottomOffset;
        this.tour.dataset.placement = 'bottom-center';
        this.tour.style.left = `${Math.round(clamp(left, margin, window.innerWidth - tourRect.width - margin))}px`;
        this.tour.style.top = `${Math.round(clamp(top, margin, window.innerHeight - tourRect.height - margin))}px`;
        return;
      }

      const target = this.activeTarget;
      if (!isVisible(target) || this.tour.hidden) return;

      const margin = 16;
      const gap = 14;
      const targetRect = target.getBoundingClientRect();
      const tourRect = this.tour.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      let placement = 'bottom';
      let left = targetRect.left;
      let top = targetRect.bottom + gap;

      if (viewportWidth - targetRect.right >= tourRect.width + gap + margin) {
        placement = 'right';
        left = targetRect.right + gap;
        top = targetRect.top + (targetRect.height - tourRect.height) / 2;
      } else if (targetRect.left >= tourRect.width + gap + margin) {
        placement = 'left';
        left = targetRect.left - tourRect.width - gap;
        top = targetRect.top + (targetRect.height - tourRect.height) / 2;
      } else if (viewportHeight - targetRect.bottom >= tourRect.height + gap + margin) {
        placement = 'bottom';
        left = targetRect.left + Math.min(0, (targetRect.width - tourRect.width) / 2);
        top = targetRect.bottom + gap;
      } else {
        placement = 'top';
        left = targetRect.left + Math.min(0, (targetRect.width - tourRect.width) / 2);
        top = targetRect.top - tourRect.height - gap;
      }

      this.tour.dataset.placement = placement;
      this.tour.style.left = `${Math.round(clamp(left, margin, viewportWidth - tourRect.width - margin))}px`;
      this.tour.style.top = `${Math.round(clamp(top, margin, viewportHeight - tourRect.height - margin))}px`;
    }
  }

  function initProductTours() {
    document.querySelectorAll(TOUR_SELECTOR).forEach((tour) => new OCaseProductTour(tour).init());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTours);
  } else {
    initProductTours();
  }
})();
